import W, { useMemo as ze, useContext as Pr, createContext as Gr, useState as Ne, useCallback as R, useEffect as pe, forwardRef as ja, useRef as me, useImperativeHandle as _r, useLayoutEffect as Na, useId as Rt } from "react";
import { createPortal as Xr, flushSync as Ha } from "react-dom";
var Hr = { exports: {} }, mr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ea;
function Ba() {
  if (ea) return mr;
  ea = 1;
  var e = W, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(h, u, b) {
    var f, w = {}, x = null, k = null;
    b !== void 0 && (x = "" + b), u.key !== void 0 && (x = "" + u.key), u.ref !== void 0 && (k = u.ref);
    for (f in u) a.call(u, f) && !c.hasOwnProperty(f) && (w[f] = u[f]);
    if (h && h.defaultProps) for (f in u = h.defaultProps, u) w[f] === void 0 && (w[f] = u[f]);
    return { $$typeof: t, type: h, key: x, ref: k, props: w, _owner: o.current };
  }
  return mr.Fragment = r, mr.jsx = s, mr.jsxs = s, mr;
}
var hr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ta;
function qa() {
  return ta || (ta = 1, process.env.NODE_ENV !== "production" && function() {
    var e = W, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), h = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function F(l) {
      if (l === null || typeof l != "object")
        return null;
      var v = N && l[N] || l[j];
      return typeof v == "function" ? v : null;
    }
    var B = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(l) {
      {
        for (var v = arguments.length, i = new Array(v > 1 ? v - 1 : 0), m = 1; m < v; m++)
          i[m - 1] = arguments[m];
        P("error", l, i);
      }
    }
    function P(l, v, i) {
      {
        var m = B.ReactDebugCurrentFrame, U = m.getStackAddendum();
        U !== "" && (v += "%s", i = i.concat([U]));
        var de = i.map(function(fe) {
          return String(fe);
        });
        de.unshift("Warning: " + v), Function.prototype.apply.call(console[l], console, de);
      }
    }
    var Y = !1, X = !1, oe = !1, G = !1, S = !1, Z;
    Z = Symbol.for("react.module.reference");
    function We(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === a || l === c || S || l === o || l === b || l === f || G || l === k || Y || X || oe || typeof l == "object" && l !== null && (l.$$typeof === x || l.$$typeof === w || l.$$typeof === s || l.$$typeof === h || l.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === Z || l.getModuleId !== void 0));
    }
    function be(l, v, i) {
      var m = l.displayName;
      if (m)
        return m;
      var U = v.displayName || v.name || "";
      return U !== "" ? i + "(" + U + ")" : i;
    }
    function ee(l) {
      return l.displayName || "Context";
    }
    function q(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case a:
          return "Fragment";
        case r:
          return "Portal";
        case c:
          return "Profiler";
        case o:
          return "StrictMode";
        case b:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case h:
            var v = l;
            return ee(v) + ".Consumer";
          case s:
            var i = l;
            return ee(i._context) + ".Provider";
          case u:
            return be(l, l.render, "ForwardRef");
          case w:
            var m = l.displayName || null;
            return m !== null ? m : q(l.type) || "Memo";
          case x: {
            var U = l, de = U._payload, fe = U._init;
            try {
              return q(fe(de));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, L = 0, ke, te, ce, we, Fe, De, Ee;
    function Me() {
    }
    Me.__reactDisabledLog = !0;
    function Be() {
      {
        if (L === 0) {
          ke = console.log, te = console.info, ce = console.warn, we = console.error, Fe = console.group, De = console.groupCollapsed, Ee = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: Me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        L++;
      }
    }
    function qe() {
      {
        if (L--, L === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, l, {
              value: ke
            }),
            info: T({}, l, {
              value: te
            }),
            warn: T({}, l, {
              value: ce
            }),
            error: T({}, l, {
              value: we
            }),
            group: T({}, l, {
              value: Fe
            }),
            groupCollapsed: T({}, l, {
              value: De
            }),
            groupEnd: T({}, l, {
              value: Ee
            })
          });
        }
        L < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Xe = B.ReactCurrentDispatcher, xe;
    function ue(l, v, i) {
      {
        if (xe === void 0)
          try {
            throw Error();
          } catch (U) {
            var m = U.stack.trim().match(/\n( *(at )?)/);
            xe = m && m[1] || "";
          }
        return `
` + xe + l;
      }
    }
    var Ve = !1, Oe;
    {
      var st = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new st();
    }
    function Pe(l, v) {
      if (!l || Ve)
        return "";
      {
        var i = Oe.get(l);
        if (i !== void 0)
          return i;
      }
      var m;
      Ve = !0;
      var U = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var de;
      de = Xe.current, Xe.current = null, Be();
      try {
        if (v) {
          var fe = function() {
            throw Error();
          };
          if (Object.defineProperty(fe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(fe, []);
            } catch (jt) {
              m = jt;
            }
            Reflect.construct(l, [], fe);
          } else {
            try {
              fe.call();
            } catch (jt) {
              m = jt;
            }
            l.call(fe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (jt) {
            m = jt;
          }
          l();
        }
      } catch (jt) {
        if (jt && m && typeof jt.stack == "string") {
          for (var Re = jt.stack.split(`
`), bt = m.stack.split(`
`), Qe = Re.length - 1, ot = bt.length - 1; Qe >= 1 && ot >= 0 && Re[Qe] !== bt[ot]; )
            ot--;
          for (; Qe >= 1 && ot >= 0; Qe--, ot--)
            if (Re[Qe] !== bt[ot]) {
              if (Qe !== 1 || ot !== 1)
                do
                  if (Qe--, ot--, ot < 0 || Re[Qe] !== bt[ot]) {
                    var St = `
` + Re[Qe].replace(" at new ", " at ");
                    return l.displayName && St.includes("<anonymous>") && (St = St.replace("<anonymous>", l.displayName)), typeof l == "function" && Oe.set(l, St), St;
                  }
                while (Qe >= 1 && ot >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, Xe.current = de, qe(), Error.prepareStackTrace = U;
      }
      var Kt = l ? l.displayName || l.name : "", Vt = Kt ? ue(Kt) : "";
      return typeof l == "function" && Oe.set(l, Vt), Vt;
    }
    function dt(l, v, i) {
      return Pe(l, !1);
    }
    function ut(l) {
      var v = l.prototype;
      return !!(v && v.isReactComponent);
    }
    function Q(l, v, i) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return Pe(l, ut(l));
      if (typeof l == "string")
        return ue(l);
      switch (l) {
        case b:
          return ue("Suspense");
        case f:
          return ue("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case u:
            return dt(l.render);
          case w:
            return Q(l.type, v, i);
          case x: {
            var m = l, U = m._payload, de = m._init;
            try {
              return Q(de(U), v, i);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, re = {}, p = B.ReactDebugCurrentFrame;
    function z(l) {
      if (l) {
        var v = l._owner, i = Q(l.type, l._source, v ? v.type : null);
        p.setExtraStackFrame(i);
      } else
        p.setExtraStackFrame(null);
    }
    function V(l, v, i, m, U) {
      {
        var de = Function.call.bind(se);
        for (var fe in l)
          if (de(l, fe)) {
            var Re = void 0;
            try {
              if (typeof l[fe] != "function") {
                var bt = Error((m || "React class") + ": " + i + " type `" + fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[fe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw bt.name = "Invariant Violation", bt;
              }
              Re = l[fe](v, fe, m, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Qe) {
              Re = Qe;
            }
            Re && !(Re instanceof Error) && (z(U), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", i, fe, typeof Re), z(null)), Re instanceof Error && !(Re.message in re) && (re[Re.message] = !0, z(U), A("Failed %s type: %s", i, Re.message), z(null));
          }
      }
    }
    var le = Array.isArray;
    function he(l) {
      return le(l);
    }
    function ie(l) {
      {
        var v = typeof Symbol == "function" && Symbol.toStringTag, i = v && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return i;
      }
    }
    function rt(l) {
      try {
        return He(l), !1;
      } catch {
        return !0;
      }
    }
    function He(l) {
      return "" + l;
    }
    function ae(l) {
      if (rt(l))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ie(l)), He(l);
    }
    var ye = B.ReactCurrentOwner, Ke = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, $e, Ue;
    function xt(l) {
      if (se.call(l, "ref")) {
        var v = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function nt(l) {
      if (se.call(l, "key")) {
        var v = Object.getOwnPropertyDescriptor(l, "key").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function Ye(l, v) {
      typeof l.ref == "string" && ye.current;
    }
    function mt(l, v) {
      {
        var i = function() {
          $e || ($e = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        i.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function gt(l, v) {
      {
        var i = function() {
          Ue || (Ue = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        i.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var ft = function(l, v, i, m, U, de, fe) {
      var Re = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: l,
        key: v,
        ref: i,
        props: fe,
        // Record the component responsible for creating this element.
        _owner: de
      };
      return Re._store = {}, Object.defineProperty(Re._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Re, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(Re, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: U
      }), Object.freeze && (Object.freeze(Re.props), Object.freeze(Re)), Re;
    };
    function $(l, v, i, m, U) {
      {
        var de, fe = {}, Re = null, bt = null;
        i !== void 0 && (ae(i), Re = "" + i), nt(v) && (ae(v.key), Re = "" + v.key), xt(v) && (bt = v.ref, Ye(v, U));
        for (de in v)
          se.call(v, de) && !Ke.hasOwnProperty(de) && (fe[de] = v[de]);
        if (l && l.defaultProps) {
          var Qe = l.defaultProps;
          for (de in Qe)
            fe[de] === void 0 && (fe[de] = Qe[de]);
        }
        if (Re || bt) {
          var ot = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          Re && mt(fe, ot), bt && gt(fe, ot);
        }
        return ft(l, Re, bt, U, m, ye.current, fe);
      }
    }
    var K = B.ReactCurrentOwner, je = B.ReactDebugCurrentFrame;
    function C(l) {
      if (l) {
        var v = l._owner, i = Q(l.type, l._source, v ? v.type : null);
        je.setExtraStackFrame(i);
      } else
        je.setExtraStackFrame(null);
    }
    var J;
    J = !1;
    function ve(l) {
      return typeof l == "object" && l !== null && l.$$typeof === t;
    }
    function Te() {
      {
        if (K.current) {
          var l = q(K.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function Ae(l) {
      return "";
    }
    var vt = {};
    function _t(l) {
      {
        var v = Te();
        if (!v) {
          var i = typeof l == "string" ? l : l.displayName || l.name;
          i && (v = `

Check the top-level render call using <` + i + ">.");
        }
        return v;
      }
    }
    function g(l, v) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var i = _t(v);
        if (vt[i])
          return;
        vt[i] = !0;
        var m = "";
        l && l._owner && l._owner !== K.current && (m = " It was passed a child from " + q(l._owner.type) + "."), C(l), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, m), C(null);
      }
    }
    function H(l, v) {
      {
        if (typeof l != "object")
          return;
        if (he(l))
          for (var i = 0; i < l.length; i++) {
            var m = l[i];
            ve(m) && g(m, v);
          }
        else if (ve(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var U = F(l);
          if (typeof U == "function" && U !== l.entries)
            for (var de = U.call(l), fe; !(fe = de.next()).done; )
              ve(fe.value) && g(fe.value, v);
        }
      }
    }
    function D(l) {
      {
        var v = l.type;
        if (v == null || typeof v == "string")
          return;
        var i;
        if (typeof v == "function")
          i = v.propTypes;
        else if (typeof v == "object" && (v.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        v.$$typeof === w))
          i = v.propTypes;
        else
          return;
        if (i) {
          var m = q(v);
          V(i, l.props, "prop", m, l);
        } else if (v.PropTypes !== void 0 && !J) {
          J = !0;
          var U = q(v);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", U || "Unknown");
        }
        typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function I(l) {
      {
        for (var v = Object.keys(l.props), i = 0; i < v.length; i++) {
          var m = v[i];
          if (m !== "children" && m !== "key") {
            C(l), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), C(null);
            break;
          }
        }
        l.ref !== null && (C(l), A("Invalid attribute `ref` supplied to `React.Fragment`."), C(null));
      }
    }
    var Ce = {};
    function Le(l, v, i, m, U, de) {
      {
        var fe = We(l);
        if (!fe) {
          var Re = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (Re += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var bt = Ae();
          bt ? Re += bt : Re += Te();
          var Qe;
          l === null ? Qe = "null" : he(l) ? Qe = "array" : l !== void 0 && l.$$typeof === t ? (Qe = "<" + (q(l.type) || "Unknown") + " />", Re = " Did you accidentally export a JSX literal instead of a component?") : Qe = typeof l, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Qe, Re);
        }
        var ot = $(l, v, i, U, de);
        if (ot == null)
          return ot;
        if (fe) {
          var St = v.children;
          if (St !== void 0)
            if (m)
              if (he(St)) {
                for (var Kt = 0; Kt < St.length; Kt++)
                  H(St[Kt], l);
                Object.freeze && Object.freeze(St);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              H(St, l);
        }
        if (se.call(v, "key")) {
          var Vt = q(l), jt = Object.keys(v).filter(function(d) {
            return d !== "key";
          }), or = jt.length > 0 ? "{key: someKey, " + jt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ce[Vt + or]) {
            var wr = jt.length > 0 ? "{" + jt.join(": ..., ") + ": ...}" : "{}";
            A(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, or, Vt, wr, Vt), Ce[Vt + or] = !0;
          }
        }
        return l === a ? I(ot) : D(ot), ot;
      }
    }
    function Je(l, v, i) {
      return Le(l, v, i, !0);
    }
    function Ge(l, v, i) {
      return Le(l, v, i, !1);
    }
    var Ze = Ge, E = Je;
    hr.Fragment = a, hr.jsx = Ze, hr.jsxs = E;
  }()), hr;
}
process.env.NODE_ENV === "production" ? Hr.exports = Ba() : Hr.exports = qa();
var n = Hr.exports;
const kt = {
  mode: "light",
  colors: {
    neutral: { 50: "#f9fafb", 100: "#f3f4f6", 200: "#e5e7eb", 300: "#d1d5db", 400: "#9ca3af", 500: "#6b7280", 600: "#4b5563", 700: "#374151", 800: "#1f2937", 900: "#111827" },
    accent: { 50: "#f5faff", 100: "#e0f2ff", 200: "#b9e4ff", 300: "#7fd0ff", 400: "#40b9ff", 500: "#0ea5e9", 600: "#0284c7", 700: "#0369a1", 800: "#075985", 900: "#0c4a6e" },
    success: { 500: "#16a34a" },
    warning: { 500: "#d97706" },
    danger: { 500: "#dc2626" }
  },
  semantic: {
    bg: "#ffffff",
    bgSubtle: "#f9fafb",
    surface: "#f6f7f9",
    surfaceSubtle: "#f4f6f8",
    surfaceElevated: "#ffffff",
    fg: "#111827",
    fgMuted: "#6b7280",
    border: "#e5e7eb",
    borderSubtle: "#e2e8ee",
    accent: "#0ea5e9",
    accentHover: "#0284c7",
    accentActive: "#0369a1",
    success: "#16a34a",
    warning: "#d97706",
    danger: "#dc2626"
  },
  sizing: {
    spacing: { xs: "0.25rem", sm: "0.5rem", md: "0.75rem", lg: "1rem", xl: "1.5rem", xxl: "2rem" },
    size: { xs: "2.25rem", sm: "2.5rem", md: "2.75rem", lg: "3rem", xl: "3.5rem" },
    radius: { none: "0", sm: "0.1875rem", md: "0.375rem", lg: "0.625rem", pill: "999rem", full: "100%" },
    fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem", lg: "1.125rem", xl: "1.25rem", xxl: "1.5rem" },
    lineHeight: { tight: "1.2", normal: "1.4", relaxed: "1.6" },
    shadow: { sm: "0 0.0625rem 0.125rem rgba(0,0,0,0.08)", md: "0 0.125rem 0.25rem rgba(0,0,0,0.12)", lg: "0 0.25rem 0.5rem rgba(0,0,0,0.16)", xl: "0 0.5rem 1rem rgba(0,0,0,0.20)", overlay: "0 0.75rem 1.5rem rgba(0,0,0,0.32)" },
    borderWidth: { thin: "1px", default: "1px", thick: "2px" },
    fontFamily: { base: "system-ui,-apple-system,Segoe UI,Roboto,sans-serif", mono: "SFMono-Regular,Menlo,monospace" },
    fontWeight: { regular: "400", medium: "500", semibold: "600", bold: "700" },
    motionDuration: { fast: "120ms", normal: "200ms", slow: "320ms" },
    motionEasing: { in: "cubic-bezier(0.4,0,1,1)", out: "cubic-bezier(0,0,0.2,1)", inout: "cubic-bezier(0.4,0,0.2,1)" },
    opacity: { disabled: "0.5", muted: "0.72" },
    zIndex: { dropdown: 1e3, sticky: 1100, modal: 1300, toast: 1400, tooltip: 1500 },
    transition: { fade: "opacity var(--flare-motion-duration-normal) var(--flare-motion-easing-out)", bg: "background-color var(--flare-motion-duration-fast) var(--flare-motion-easing-inout)", color: "color var(--flare-motion-duration-fast) var(--flare-motion-easing-inout)" },
    density: { comfortable: 1, compact: 0.85 }
  },
  component: {
    button: {
      "bg-primary": "var(--flare-color-accent)",
      "bg-primary-hover": "var(--flare-color-accent-hover)",
      "fg-primary": "#ffffff",
      "bg-secondary-hover": "rgba(0, 0, 0, 0.04)",
      "bg-secondary-active": "rgba(0, 0, 0, 0.08)",
      radius: "var(--flare-radius-md)",
      "padding-y": "var(--flare-spacing-sm)",
      "padding-x": "var(--flare-spacing-md)",
      "bg-secondary": "transparent",
      "fg-secondary": "var(--flare-color-accent)",
      "border-secondary": "var(--flare-color-accent-hover)",
      border: "none",
      shadow: "none",
      "shadow-active": "none",
      "bevel-light": "transparent",
      "bevel-dark": "transparent"
    },
    scrollbar: {
      track: "var(--flare-color-surface-subtle)",
      thumb: "var(--flare-color-border)",
      "thumb-hover": "color-mix(in srgb, var(--flare-color-border) 75%, var(--flare-color-accent))",
      "track-gradient": "linear-gradient(180deg, #f4f6f8 0%, #e4e8ed 100%)",
      "track-border": "#d9e0e7",
      "track-shadow": "inset 0 0.0625rem 0.1875rem rgba(15, 23, 42, 0.12), inset 0 0 var(--flare-border-width-thin) rgba(255, 255, 255, 0.72)",
      "thumb-gradient": "linear-gradient(135deg, #ebcbcb 0%, #f0c1ff 100%)",
      "thumb-hover-gradient": "linear-gradient(135deg, #dfaebc 0%, #df9ff2 100%)",
      "thumb-border": "rgba(133, 74, 151, 0.3)"
    },
    card: {
      bg: "var(--flare-color-surface-elevated)",
      "border-color": "#e2e8ee",
      "border-width": "var(--flare-border-width-default)",
      radius: "var(--flare-radius-lg)",
      shadow: "var(--flare-shadow-md)",
      padding: "var(--flare-spacing-xxl)"
    },
    "check-box": {
      size: "1rem",
      gap: "var(--flare-spacing-sm)",
      "font-size": "var(--flare-font-size-sm)",
      "label-color": "var(--flare-color-fg)",
      focus: "var(--flare-color-accent)",
      "box-radius": "var(--flare-radius-sm)",
      "border-width": "var(--flare-border-width-default)",
      "border-color": "var(--flare-color-border)",
      bg: "var(--flare-color-bg)",
      "bg-checked": "var(--flare-color-accent)",
      "border-checked": "var(--flare-color-accent)",
      "check-color": "#ffffff",
      ripple: "rgba(14, 165, 233, 0.2)",
      shadow: "none",
      "shadow-checked": "none"
    },
    "date-picker": {
      bg: "var(--flare-color-bg)",
      fg: "var(--flare-color-fg)",
      "border-width": "var(--flare-border-width-default)",
      "border-color": "var(--flare-color-border)",
      "border-focus": "var(--flare-color-accent)",
      radius: "var(--flare-radius-md)",
      "padding-y": "var(--flare-spacing-sm)",
      "padding-x": "var(--flare-spacing-md)",
      "min-height": "var(--flare-size-xs)",
      "font-size": "var(--flare-font-size-md)",
      "line-height": "var(--flare-line-height-normal)",
      placeholder: "var(--flare-color-fg-muted)",
      icon: "var(--flare-color-fg-muted)",
      focus: "var(--flare-color-accent)",
      shadow: "none",
      "shadow-focus": "0 0 0 var(--flare-border-width-thick) var(--flare-color-accent-100)",
      disabled: "var(--flare-color-fg-muted)",
      "bg-disabled": "var(--flare-color-bg-subtle)",
      "menu-bg": "var(--flare-color-surface-elevated)",
      "menu-radius": "var(--flare-radius-md)",
      "menu-border-width": "var(--flare-border-width-default)",
      "menu-border-color": "var(--flare-color-border-subtle)",
      "menu-shadow": "var(--flare-shadow-md)",
      "menu-padding": "var(--flare-spacing-sm)",
      "menu-min-width": "15.75rem",
      "nav-size": "1.75rem",
      "day-size": "1.75rem",
      "day-hover": "var(--flare-color-surface-subtle)",
      "day-selected": "var(--flare-color-accent)",
      "day-selected-hover": "var(--flare-color-accent-hover)",
      "day-selected-fg": "var(--flare-color-bg)",
      "today-border": "var(--flare-color-accent)",
      weekday: "var(--flare-color-fg-muted)",
      outside: "var(--flare-color-fg-muted)"
    },
    "date-range-picker": {
      bg: "var(--flare-color-bg)",
      fg: "var(--flare-color-fg)",
      "border-width": "var(--flare-border-width-default)",
      "border-color": "var(--flare-color-border)",
      "border-focus": "var(--flare-color-accent)",
      radius: "var(--flare-radius-md)",
      "padding-y": "var(--flare-spacing-sm)",
      "padding-x": "var(--flare-spacing-md)",
      "min-height": "var(--flare-size-xs)",
      "font-size": "var(--flare-font-size-md)",
      "line-height": "var(--flare-line-height-normal)",
      placeholder: "var(--flare-color-fg-muted)",
      icon: "var(--flare-color-fg-muted)",
      focus: "var(--flare-color-accent)",
      shadow: "none",
      "shadow-focus": "0 0 0 var(--flare-border-width-thick) var(--flare-color-accent-100)",
      disabled: "var(--flare-color-fg-muted)",
      "bg-disabled": "var(--flare-color-bg-subtle)",
      "menu-bg": "var(--flare-color-surface-elevated)",
      "menu-radius": "var(--flare-radius-md)",
      "menu-border-width": "var(--flare-border-width-default)",
      "menu-border-color": "var(--flare-color-border-subtle)",
      "menu-shadow": "var(--flare-shadow-md)",
      "menu-padding": "var(--flare-spacing-sm)",
      "menu-min-width": "15.75rem",
      "nav-size": "1.75rem",
      "day-size": "1.75rem",
      "day-hover": "var(--flare-color-surface-subtle)",
      "day-selected": "var(--flare-color-accent)",
      "day-selected-hover": "var(--flare-color-accent-hover)",
      "day-selected-fg": "var(--flare-color-bg)",
      "day-in-range": "color-mix(in srgb, var(--flare-color-accent) 16%, transparent)",
      "day-in-range-hover": "color-mix(in srgb, var(--flare-color-accent) 24%, transparent)",
      "day-in-range-fg": "var(--flare-color-fg)",
      "today-border": "var(--flare-color-accent)",
      weekday: "var(--flare-color-fg-muted)",
      outside: "var(--flare-color-fg-muted)",
      hint: "var(--flare-color-fg-muted)"
    },
    "amount-range-picker": {
      gap: "var(--flare-spacing-sm)",
      "field-gap": "var(--flare-spacing-xs)",
      "field-radius": "var(--flare-radius-md)",
      "field-border-width": "var(--flare-border-width-default)",
      "field-border-color": "var(--flare-color-border)",
      "field-bg": "var(--flare-color-bg)",
      "field-fg": "var(--flare-color-fg)",
      "field-min-height": "var(--flare-size-xs)",
      "field-padding-y": "var(--flare-spacing-sm)",
      "field-padding-x": "var(--flare-spacing-md)",
      "field-font-size": "var(--flare-font-size-md)",
      "field-line-height": "var(--flare-line-height-normal)",
      "field-prefix-color": "var(--flare-color-fg-muted)",
      "field-label-size": "var(--flare-font-size-xs)",
      "field-label-weight": "var(--flare-font-weight-medium)",
      "field-label-color": "var(--flare-color-fg)",
      "field-placeholder": "var(--flare-color-fg-muted)",
      "field-focus": "var(--flare-color-accent)",
      "field-shadow": "none",
      "field-shadow-focus": "0 0 0 var(--flare-border-width-thick) var(--flare-color-accent-100)",
      "separator-color": "var(--flare-color-fg-muted)",
      "separator-size": "var(--flare-font-size-md)",
      "clear-color": "var(--flare-color-fg-muted)",
      "clear-hover-bg": "var(--flare-color-surface-subtle)",
      "clear-hover-color": "var(--flare-color-fg)",
      "hint-color": "var(--flare-color-fg-muted)",
      "help-size": "var(--flare-font-size-xs)"
    },
    "text-box": {
      gap: "var(--flare-spacing-xs)",
      fg: "var(--flare-color-fg)",
      "label-size": "var(--flare-font-size-sm)",
      "label-weight": "var(--flare-font-weight-medium)",
      "label-color": "var(--flare-color-fg)",
      "icon-gap": "var(--flare-spacing-sm)",
      radius: "var(--flare-radius-md)",
      "border-width": "var(--flare-border-width-default)",
      "border-color": "var(--flare-color-border)",
      bg: "var(--flare-color-bg)",
      "padding-y": "var(--flare-spacing-sm)",
      "padding-x": "var(--flare-spacing-md)",
      "min-height": "var(--flare-size-xs)",
      "border-focus": "var(--flare-color-accent)",
      ring: "rgba(14, 165, 233, 0.25)",
      "font-size": "var(--flare-font-size-md)",
      "line-height": "var(--flare-line-height-normal)",
      "input-color": "var(--flare-color-fg)",
      placeholder: "var(--flare-color-fg-muted)",
      "icon-color": "var(--flare-color-fg-muted)",
      "border-error": "var(--flare-color-danger)",
      "border-success": "var(--flare-color-success)",
      "ring-error": "rgba(220, 38, 38, 0.2)",
      "ring-success": "rgba(22, 163, 74, 0.2)",
      disabled: "var(--flare-color-fg-muted)",
      "bg-disabled": "var(--flare-color-bg-subtle)",
      shadow: "none",
      "shadow-focus": "0 0 0 0.125rem var(--flare-text-box-ring, rgba(14, 165, 233, 0.25))",
      "shadow-error": "0 0 0 0.125rem var(--flare-text-box-ring-error, rgba(220, 38, 38, 0.2))",
      "shadow-success": "0 0 0 0.125rem var(--flare-text-box-ring-success, rgba(22, 163, 74, 0.2))"
    },
    "drop-down-list": {
      gap: "var(--flare-spacing-xs)",
      fg: "var(--flare-color-fg)",
      "label-size": "var(--flare-font-size-sm)",
      "label-weight": "var(--flare-font-weight-medium)",
      "label-color": "var(--flare-color-fg)",
      "icon-gap": "var(--flare-spacing-sm)",
      radius: "var(--flare-radius-md)",
      "border-width": "var(--flare-border-width-default)",
      "border-color": "var(--flare-color-border)",
      bg: "var(--flare-color-surface-elevated)",
      "padding-y": "var(--flare-spacing-sm)",
      "padding-x": "var(--flare-spacing-md)",
      "min-height": "var(--flare-size-xs)",
      focus: "var(--flare-color-accent)",
      "border-open": "var(--flare-color-accent)",
      ring: "rgba(14, 165, 233, 0.2)",
      "icon-color": "var(--flare-color-fg-muted)",
      "value-gap": "var(--flare-spacing-xs)",
      placeholder: "var(--flare-color-fg-muted)",
      "font-size": "var(--flare-font-size-md)",
      "line-height": "var(--flare-line-height-normal)",
      "input-color": "var(--flare-color-fg)",
      "clear-color": "var(--flare-color-fg-muted)",
      "clear-size": "1.125rem",
      caret: "var(--flare-color-fg-muted)",
      "menu-bg": "var(--flare-color-surface-elevated)",
      "menu-radius": "var(--flare-radius-md)",
      "menu-border-width": "var(--flare-border-width-default)",
      "menu-border-color": "var(--flare-color-border-subtle)",
      "menu-shadow": "var(--flare-shadow-md)",
      "menu-min-width": "13.75rem",
      "menu-padding": "var(--flare-spacing-xs)",
      "menu-max-height": "17.5rem",
      "item-gap": "var(--flare-spacing-sm)",
      "item-padding-y": "var(--flare-spacing-xs)",
      "item-padding-x": "var(--flare-spacing-sm)",
      "item-radius": "var(--flare-radius-sm)",
      "item-hover": "var(--flare-color-surface-subtle)",
      "item-highlight": "color-mix(in srgb, var(--flare-color-accent) 14%, var(--flare-color-surface-subtle))",
      "item-selected": "var(--flare-color-accent-50)",
      "item-icon": "var(--flare-color-fg-muted)",
      "empty-padding": "var(--flare-spacing-sm)",
      "empty-color": "var(--flare-color-fg-muted)",
      shadow: "none",
      "shadow-open": "0 0 0 0.125rem var(--flare-drop-down-list-ring, rgba(14, 165, 233, 0.2))",
      "menu-shadow-open": "var(--flare-drop-down-list-menu-shadow, var(--flare-shadow-md))"
    },
    "auto-complete": {
      gap: "var(--flare-spacing-xs)",
      fg: "var(--flare-color-fg)",
      "label-size": "var(--flare-font-size-sm)",
      "label-weight": "var(--flare-font-weight-medium)",
      "label-color": "var(--flare-color-fg)",
      "icon-gap": "var(--flare-spacing-sm)",
      radius: "var(--flare-radius-md)",
      "border-width": "var(--flare-border-width-default)",
      "border-color": "var(--flare-color-border)",
      bg: "var(--flare-color-bg)",
      "padding-y": "var(--flare-spacing-sm)",
      "padding-x": "var(--flare-spacing-md)",
      "min-height": "var(--flare-size-xs)",
      focus: "var(--flare-color-accent)",
      ring: "rgba(14, 165, 233, 0.25)",
      "font-size": "var(--flare-font-size-md)",
      "line-height": "var(--flare-line-height-normal)",
      "input-color": "var(--flare-color-fg)",
      placeholder: "var(--flare-color-fg-muted)",
      "icon-color": "var(--flare-color-fg-muted)",
      "border-error": "var(--flare-color-danger)",
      "border-success": "var(--flare-color-success)",
      "ring-error": "rgba(220, 38, 38, 0.2)",
      "ring-success": "rgba(22, 163, 74, 0.2)",
      disabled: "var(--flare-color-fg-muted)",
      "bg-disabled": "var(--flare-color-bg-subtle)",
      "menu-bg": "var(--flare-color-bg)",
      "menu-radius": "var(--flare-radius-md)",
      "menu-border-width": "var(--flare-border-width-default)",
      "menu-border-color": "var(--flare-color-border)",
      "menu-shadow": "var(--flare-shadow-md)",
      "menu-min-width": "13.75rem",
      "menu-padding": "var(--flare-spacing-xs)",
      "menu-max-height": "17.5rem",
      "item-gap": "var(--flare-spacing-xs)",
      "item-padding-y": "var(--flare-spacing-xs)",
      "item-padding-x": "var(--flare-spacing-sm)",
      "item-radius": "var(--flare-radius-sm)",
      "item-hover": "var(--flare-color-bg-subtle)",
      "item-active": "var(--flare-color-bg-subtle)",
      "item-color": "var(--flare-color-fg)",
      "item-disabled": "var(--flare-color-fg-muted)",
      "item-icon": "var(--flare-color-fg-muted)",
      "item-description": "var(--flare-color-fg-muted)",
      "item-description-size": "var(--flare-font-size-xs)",
      "item-disabled-size": "var(--flare-font-size-xs)",
      match: "var(--flare-color-accent)",
      "match-weight": "var(--flare-font-weight-semibold)",
      "empty-padding": "var(--flare-spacing-sm)",
      "empty-color": "var(--flare-color-fg-muted)",
      "empty-size": "var(--flare-font-size-sm)",
      shadow: "none",
      "shadow-open": "0 0 0 0.125rem var(--flare-auto-complete-ring, rgba(14, 165, 233, 0.25))",
      "menu-shadow-open": "var(--flare-auto-complete-menu-shadow, var(--flare-shadow-md))"
    },
    layout: {},
    "split-view": {},
    popup: {
      bg: "var(--flare-color-surface-elevated)",
      border: "var(--flare-border-width-default) solid var(--flare-color-border-subtle)",
      radius: "var(--flare-radius-lg)",
      shadow: "var(--flare-shadow-lg)"
    },
    drawer: {
      bg: "var(--flare-color-surface-elevated)",
      fg: "var(--flare-color-fg)",
      border: "var(--flare-border-width-default) solid var(--flare-color-border-subtle)",
      shadow: "var(--flare-shadow-overlay)",
      width: "min(26rem, calc(100vw - 2rem))",
      height: "min(75vh, calc(100dvh - 2rem))",
      radius: "var(--flare-radius-lg)",
      backdrop: "color-mix(in srgb, #000 42%, transparent)",
      "item-hover-bg": "color-mix(in srgb, var(--flare-color-accent) 12%, transparent)",
      "item-active-bg": "color-mix(in srgb, var(--flare-color-accent) 18%, transparent)",
      "item-active-fg": "var(--flare-color-fg)"
    },
    "popup-menu": {},
    "floating-window": {
      bg: "var(--flare-color-surface-elevated)",
      fg: "var(--flare-color-fg)",
      "border-color": "var(--flare-color-border)",
      "border-width": "var(--flare-border-width-default)",
      radius: "var(--flare-radius-lg)",
      shadow: "var(--flare-shadow-overlay)",
      "titlebar-bg": "var(--flare-color-surface-subtle)",
      "titlebar-fg": "var(--flare-color-fg)",
      "titlebar-border-color": "var(--flare-color-border-subtle)",
      "subtitle-color": "var(--flare-color-fg-muted)",
      "control-hover-bg": "var(--flare-color-bg-subtle)",
      "close-hover-bg": "var(--flare-color-error-subtle)",
      "close-hover-color": "var(--flare-color-error-dark)",
      "focus-color": "var(--flare-color-accent)",
      "header-bg": "var(--flare-color-surface)",
      "footer-bg": "var(--flare-color-surface)",
      "section-border-color": "var(--flare-color-border-subtle)"
    },
    "input-wrapper": {},
    form: {},
    "data-grid": {
      surface: "var(--flare-color-surface)",
      "surface-2": "var(--flare-color-surface-elevated)",
      "surface-subtle": "var(--flare-color-surface-subtle)",
      "surface-elevated": "var(--flare-color-surface-elevated)",
      "row-base": "var(--flare-color-surface)",
      "zebra-odd": "#f1f3f6",
      "zebra-even": "#fafbfc",
      text: "var(--flare-color-fg)",
      muted: "var(--flare-color-fg-muted)",
      "font-size": "var(--flare-font-size-md)",
      border: "var(--flare-color-border)",
      "border-strong": "#e2e4e6",
      "details-row-padding": "var(--flare-spacing-md)",
      header: "#d8e3f3",
      "header-shadow": "color-mix(in srgb, var(--flare-color-surface-elevated) 60%, var(--flare-color-surface-subtle))",
      "header-border": "var(--flare-color-border)",
      accent: "var(--flare-color-accent)",
      "accent-light": "color-mix(in srgb, var(--flare-color-accent) 18%, var(--flare-color-surface))",
      hover: "color-mix(in srgb, var(--flare-color-accent) 10%, var(--flare-color-surface))",
      "shell-border": "0 solid transparent",
      "shell-shadow": "none",
      "header-bevel-light": "transparent",
      "header-bevel-dark": "transparent",
      "cell-bevel-light": "transparent",
      "cell-bevel-dark": "transparent",
      "pager-radius": "0.5rem",
      "pager-border": "var(--flare-color-border)",
      "pager-bevel-light": "transparent",
      "pager-bevel-dark": "transparent"
    }
  },
  meta: { name: "base", version: "1.0.0", layer: "base" }
}, Ka = {
  mode: "dark",
  semantic: {
    bg: "#111827",
    bgSubtle: "#1f2937",
    surface: "#0f172a",
    surfaceSubtle: "#1f2937",
    surfaceElevated: "#111827",
    fg: "#f3f4f6",
    fgMuted: "#9ca3af",
    border: "#374151",
    borderSubtle: "#1f2937",
    accent: "#0ea5e9",
    accentHover: "#0284c7",
    accentActive: "#0369a1",
    success: "#16a34a",
    warning: "#d97706",
    danger: "#dc2626",
    primary: "#0ea5e9",
    primaryHover: "#0284c7",
    primaryActive: "#0369a1",
    error: "#dc2626",
    errorDark: "#dc2626",
    errorSubtle: "color-mix(in srgb, #dc2626 16%, #111827)",
    successDark: "#16a34a",
    successSubtle: "color-mix(in srgb, #16a34a 16%, #111827)"
  },
  component: {
    card: {
      bg: "var(--flare-color-surface-elevated)",
      "border-color": "var(--flare-color-border-subtle)",
      "border-width": "var(--flare-border-width-default)",
      radius: "var(--flare-radius-lg)",
      shadow: "var(--flare-shadow-md)",
      padding: "var(--flare-spacing-xxl)"
    },
    button: {
      "bg-secondary-hover": "rgba(255, 255, 255, 0.08)",
      "bg-secondary-active": "rgba(255, 255, 255, 0.16)"
    },
    scrollbar: {
      track: "var(--flare-color-surface-subtle)",
      thumb: "var(--flare-color-border)",
      "thumb-hover": "color-mix(in srgb, var(--flare-color-border) 75%, var(--flare-color-accent))",
      "track-gradient": "linear-gradient(180deg, #293548 0%, #1a2535 100%)",
      "track-border": "#3a4a60",
      "track-shadow": "inset 0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.36), inset 0 0 var(--flare-border-width-thin) rgba(255, 255, 255, 0.08)",
      "thumb-gradient": "linear-gradient(135deg, #d58cb1 0%, #b886e4 100%)",
      "thumb-hover-gradient": "linear-gradient(135deg, #e39ec1 0%, #c497ed 100%)",
      "thumb-border": "rgba(255, 255, 255, 0.2)"
    },
    popup: {
      "motion-duration": "var(--flare-motion-duration-fast)",
      "motion-easing": "var(--flare-motion-easing-inout)",
      bg: "var(--flare-color-surface-elevated)",
      border: "var(--flare-border-width-default) solid var(--flare-color-border)",
      radius: "var(--flare-radius-lg)",
      shadow: "var(--flare-shadow-lg)"
    },
    "popup-menu": {
      bg: "var(--flare-color-surface-elevated)",
      fg: "var(--flare-color-fg)",
      border: "1px solid var(--flare-color-border)",
      "item-hover-bg": "color-mix(in srgb, var(--flare-color-accent) 18%, transparent)"
    },
    "floating-window": {
      bg: "var(--flare-color-surface-elevated)",
      fg: "var(--flare-color-fg)",
      "border-color": "var(--flare-color-border)",
      "titlebar-bg": "var(--flare-color-surface-subtle)",
      "titlebar-fg": "var(--flare-color-fg)",
      "titlebar-border-color": "var(--flare-color-border)",
      "control-hover-bg": "color-mix(in srgb, var(--flare-color-accent) 18%, transparent)",
      "header-bg": "var(--flare-color-surface)",
      "footer-bg": "var(--flare-color-surface)",
      "section-border-color": "var(--flare-color-border)"
    },
    "check-box": {
      "border-color": "var(--flare-color-border)",
      bg: "var(--flare-color-bg-subtle)"
    },
    "date-picker": {
      "menu-bg": "var(--flare-color-surface-elevated)",
      "menu-border-color": "var(--flare-color-border-subtle)"
    },
    "date-range-picker": {
      "menu-bg": "var(--flare-color-surface-elevated)",
      "menu-border-color": "var(--flare-color-border-subtle)",
      "day-in-range": "color-mix(in srgb, var(--flare-color-accent) 24%, transparent)",
      "day-in-range-hover": "color-mix(in srgb, var(--flare-color-accent) 32%, transparent)"
    },
    "amount-range-picker": {
      "field-bg": "var(--flare-color-bg-subtle)",
      "field-border-color": "var(--flare-color-border)",
      "separator-color": "var(--flare-color-fg-muted)",
      "clear-hover-bg": "color-mix(in srgb, var(--flare-color-accent) 16%, transparent)"
    },
    "text-box": {
      bg: "var(--flare-color-bg-subtle)",
      "border-color": "var(--flare-color-border)"
    },
    "drop-down-list": {
      "item-selected": "color-mix(in srgb, var(--flare-color-accent) 24%, transparent)",
      "item-highlight": "color-mix(in srgb, var(--flare-color-accent) 18%, var(--flare-color-surface-subtle))",
      "menu-bg": "var(--flare-color-surface-elevated)",
      "menu-border-color": "var(--flare-color-border-subtle)"
    },
    "auto-complete": {
      "menu-bg": "var(--flare-color-surface-elevated)",
      "menu-border-color": "var(--flare-color-border-subtle)"
    },
    layout: {
      "surface-bg": "var(--flare-color-surface)",
      "sidebar-bg": "var(--flare-color-surface-subtle)",
      "sticky-bg": "var(--flare-color-surface-elevated)"
    },
    "split-view": {
      "pane-bg": "var(--flare-color-surface)",
      "splitter-bg": "var(--flare-color-border)",
      "splitter-hover-bg": "var(--flare-color-border-subtle)"
    },
    "data-grid": {
      surface: "var(--flare-color-surface)",
      "surface-subtle": "var(--flare-color-surface-subtle)",
      "surface-elevated": "var(--flare-color-surface-elevated)",
      "zebra-odd": "#202b3a",
      "zebra-even": "#252f3d",
      text: "var(--flare-color-fg)",
      muted: "var(--flare-color-fg-muted)",
      header: "#2e3f56",
      "header-border": "#3f536b"
    },
    "input-wrapper": {
      "error-color": "var(--flare-color-error)",
      "success-color": "var(--flare-color-success)"
    },
    form: {
      fg: "var(--flare-color-fg)",
      bg: "var(--flare-color-surface)"
    }
  }
}, Io = {
  ...kt,
  meta: {
    name: "windows-95",
    version: "1.0.0",
    layer: "theme"
  },
  mode: "light",
  colors: {
    ...kt.colors,
    neutral: {
      50: "#f4f4f4",
      100: "#e0e0e0",
      200: "#d4d0c8",
      300: "#c0c0c0",
      400: "#a6a6a6",
      500: "#808080",
      600: "#5f5f5f",
      700: "#3f3f3f",
      800: "#212121",
      900: "#0f0f0f"
    },
    accent: {
      50: "#e6eaf7",
      100: "#cfd7f0",
      200: "#a5b6e5",
      300: "#6f8ad3",
      400: "#3a5ab5",
      500: "#000080",
      600: "#00006a",
      700: "#000055",
      800: "#00003c",
      900: "#000024"
    },
    success: { 500: "#008000" },
    warning: { 500: "#b8860b" },
    danger: { 500: "#800000" }
  },
  semantic: {
    bg: "#008080",
    bgSubtle: "#009191",
    surface: "#c0c0c0",
    surfaceSubtle: "#d4d0c8",
    surfaceElevated: "#c0c0c0",
    fg: "#000000",
    fgMuted: "#3f3f3f",
    border: "#808080",
    borderSubtle: "#ffffff",
    accent: "#000080",
    accentHover: "#0000a8",
    accentActive: "#000060",
    success: "#008000",
    warning: "#b8860b",
    danger: "#800000"
  },
  sizing: {
    ...kt.sizing,
    radius: {
      ...kt.sizing.radius,
      none: "0",
      sm: "0",
      md: "0",
      lg: "0",
      pill: "999rem",
      full: "100%"
    },
    fontFamily: {
      base: '"MS Sans Serif", "Microsoft Sans Serif", Tahoma, Arial, sans-serif',
      mono: kt.sizing.fontFamily.mono
    },
    shadow: {
      sm: "0 1px 0 #ffffff, 1px 1px 0 #808080",
      md: "0 1px 0 #ffffff, 1px 2px 0 #808080",
      lg: "0 2px 0 #ffffff, 2px 3px 0 #808080",
      xl: "0 2px 0 #f7f7f7, 3px 4px 0 #5f5f5f",
      overlay: "2px 2px 0 rgba(0, 0, 0, 0.35)"
    },
    fontSize: {
      xs: "0.75rem",
      sm: "0.8125rem",
      md: "0.875rem",
      lg: "0.9375rem",
      xl: "1.0625rem",
      xxl: "1.1875rem"
    },
    lineHeight: {
      tight: "1.2",
      normal: "1.35",
      relaxed: "1.5"
    },
    motionDuration: {
      fast: "0ms",
      normal: "0ms",
      slow: "0ms"
    },
    motionEasing: {
      in: "linear",
      out: "linear",
      inout: "linear"
    }
  },
  component: {
    ...kt.component,
    button: {
      ...kt.component.button,
      "bg-primary": "#c0c0c0",
      "bg-primary-hover": "#dcd8d0",
      "bg-primary-active": "#b8b6ad",
      "fg-primary": "#000000",
      "bg-secondary-hover": "#dcd8d0",
      "bg-secondary-active": "#b8b6ad",
      "bg-secondary": "#c0c0c0",
      "border-secondary": "#000000",
      "fg-secondary": "#000000",
      radius: "0",
      "padding-y": "var(--flare-spacing-sm)",
      "padding-x": "var(--flare-spacing-md)",
      border: "1px solid #000000",
      shadow: "inset -1px -1px 0 #404040, inset 1px 1px 0 #ffffff, 1px 1px 0 #808080",
      "shadow-active": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "bevel-light": "#ffffff",
      "bevel-dark": "#404040"
    },
    scrollbar: {
      track: "#d4d0c8",
      thumb: "#a6a6a6",
      "thumb-hover": "#808080",
      "track-gradient": "#d4d0c8",
      "track-border": "#808080",
      "track-shadow": "inset 1px 1px 0 #808080, inset -1px -1px 0 #ffffff",
      "thumb-gradient": "#a6a6a6",
      "thumb-hover-gradient": "#808080",
      "thumb-border": "#404040"
    },
    popup: {
      ...kt.component.popup,
      bg: "#ffffff",
      border: "1px solid #000000",
      radius: "0",
      shadow: "2px 2px 0 rgba(0, 0, 0, 0.35)"
    },
    "popup-menu": {
      bg: "#ffffff",
      fg: "#000000",
      border: "1px solid #000000",
      radius: "0",
      shadow: "2px 2px 0 #808080",
      padding: "0.125rem",
      gap: "0",
      "item-hover-bg": "#000080"
    },
    card: {
      ...kt.component.card,
      bg: "#c0c0c0",
      "border-color": "#000000",
      "border-width": "1px",
      radius: "0",
      shadow: "inset 1px 1px 0 #ffffff, inset -1px -1px 0 #404040",
      padding: "1rem"
    },
    "check-box": {
      ...kt.component["check-box"],
      "box-radius": "0",
      "border-color": "#808080",
      bg: "#ffffff",
      "bg-checked": "#000080",
      "border-checked": "#000080",
      "check-color": "#ffffff",
      focus: "#000080",
      ripple: "rgba(0, 0, 128, 0.2)",
      shadow: "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "shadow-checked": "inset 1px 1px 0 #000060, inset -1px -1px 0 #e6e6e6"
    },
    "date-picker": {
      ...kt.component["date-picker"],
      "min-height": "1.5rem",
      "padding-y": "0.25rem",
      "padding-x": "0.5rem",
      "font-size": "0.8125rem",
      "line-height": "1.2",
      radius: "0",
      "border-color": "#808080",
      bg: "#ffffff",
      "border-focus": "#000080",
      placeholder: "#3f3f3f",
      icon: "#3f3f3f",
      focus: "#000080",
      shadow: "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "shadow-focus": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      disabled: "#5f5f5f",
      "bg-disabled": "#e0e0e0",
      "menu-bg": "#ffffff",
      "menu-radius": "0",
      "menu-border-color": "#808080",
      "menu-shadow": "none",
      "menu-padding": "0.5rem",
      "menu-min-width": "15.75rem",
      "nav-size": "1.75rem",
      "day-size": "1.75rem",
      "day-hover": "#dcd8d0",
      "day-selected": "#000080",
      "day-selected-hover": "#0000a8",
      "day-selected-fg": "#ffffff",
      "today-border": "#000080",
      weekday: "#3f3f3f",
      outside: "#5f5f5f"
    },
    "amount-range-picker": {
      ...kt.component["amount-range-picker"],
      "field-radius": "0",
      "field-border-color": "#808080",
      "field-bg": "#ffffff",
      "field-focus": "#000080",
      "field-shadow": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "field-shadow-focus": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "clear-hover-bg": "#dcd8d0",
      "clear-hover-color": "#000000",
      "separator-color": "#3f3f3f"
    },
    "date-range-picker": {
      ...kt.component["date-range-picker"],
      "min-height": "1.5rem",
      "padding-y": "0.25rem",
      "padding-x": "0.5rem",
      "font-size": "0.8125rem",
      "line-height": "1.2",
      radius: "0",
      "border-color": "#808080",
      bg: "#ffffff",
      "border-focus": "#000080",
      placeholder: "#3f3f3f",
      icon: "#3f3f3f",
      focus: "#000080",
      shadow: "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "shadow-focus": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      disabled: "#5f5f5f",
      "bg-disabled": "#e0e0e0",
      "menu-bg": "#ffffff",
      "menu-radius": "0",
      "menu-border-color": "#808080",
      "menu-shadow": "none",
      "menu-padding": "0.5rem",
      "menu-min-width": "15.75rem",
      "nav-size": "1.75rem",
      "day-size": "1.75rem",
      "day-hover": "#dcd8d0",
      "day-selected": "#000080",
      "day-selected-hover": "#0000a8",
      "day-selected-fg": "#ffffff",
      "day-in-range": "#dcd8d0",
      "day-in-range-hover": "#c9c4bb",
      "day-in-range-fg": "#000000",
      "today-border": "#000080",
      weekday: "#3f3f3f",
      outside: "#5f5f5f",
      hint: "#3f3f3f"
    },
    "text-box": {
      ...kt.component["text-box"],
      radius: "0",
      "border-color": "#808080",
      bg: "#ffffff",
      "border-focus": "#000080",
      ring: "rgba(0, 0, 128, 0.35)",
      placeholder: "#3f3f3f",
      "icon-color": "#3f3f3f",
      "ring-error": "rgba(128, 0, 0, 0.25)",
      "ring-success": "rgba(0, 128, 0, 0.25)",
      "bg-disabled": "#e0e0e0",
      disabled: "#5f5f5f",
      "min-height": "1.5rem",
      "padding-y": "0.25rem",
      "padding-x": "0.5rem",
      "font-size": "0.8125rem",
      "line-height": "1.2",
      shadow: "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "shadow-focus": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "shadow-error": "inset 1px 1px 0 #800000, inset -1px -1px 0 #ffffff",
      "shadow-success": "inset 1px 1px 0 #006400, inset -1px -1px 0 #ffffff"
    },
    "drop-down-list": {
      ...kt.component["drop-down-list"],
      radius: "0",
      "border-color": "#808080",
      bg: "#ffffff",
      focus: "#000080",
      "border-open": "#000080",
      ring: "rgba(0, 0, 128, 0.35)",
      "min-height": "1.5rem",
      "padding-y": "0.25rem",
      "padding-x": "0.5rem",
      "font-size": "0.8125rem",
      "line-height": "1.2",
      "menu-bg": "#ffffff",
      "menu-border-color": "#808080",
      "menu-shadow": "none",
      "menu-shadow-open": "inset 1px 1px 0 #ffffff, inset -1px -1px 0 #404040",
      "menu-radius": "0",
      "menu-padding": "0",
      "item-gap": "0",
      "item-hover": "#000080",
      "item-highlight": "#000080",
      "item-selected": "#000080",
      "item-color": "#000000",
      "item-hover-color": "#ffffff",
      "item-highlight-color": "#ffffff",
      "item-selected-color": "#ffffff",
      "item-padding-y": "0.25rem",
      "item-padding-x": "0.5rem",
      "item-radius": "0",
      "clear-color": "#3f3f3f",
      caret: "#3f3f3f",
      shadow: "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "shadow-open": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff"
    },
    "auto-complete": {
      ...kt.component["auto-complete"],
      radius: "0",
      "border-color": "#808080",
      bg: "#ffffff",
      focus: "#000080",
      ring: "rgba(0, 0, 128, 0.35)",
      "min-height": "1.5rem",
      "padding-y": "0.25rem",
      "padding-x": "0.5rem",
      "font-size": "0.8125rem",
      "line-height": "1.2",
      placeholder: "#3f3f3f",
      "icon-color": "#3f3f3f",
      "ring-error": "rgba(128, 0, 0, 0.25)",
      "ring-success": "rgba(0, 128, 0, 0.25)",
      "bg-disabled": "#e0e0e0",
      disabled: "#5f5f5f",
      "menu-bg": "#ffffff",
      "menu-border-color": "#808080",
      "menu-shadow": "none",
      "menu-shadow-open": "inset 1px 1px 0 #ffffff, inset -1px -1px 0 #404040",
      "menu-radius": "0",
      "menu-padding": "0",
      "item-gap": "0",
      "item-hover": "#000080",
      "item-active": "#000080",
      "item-color": "#000000",
      "item-hover-color": "#ffffff",
      "item-active-color": "#ffffff",
      "item-description": "#e6e6e6",
      "item-disabled": "#5f5f5f",
      "item-icon": "#e6e6e6",
      "item-padding-y": "0.25rem",
      "item-padding-x": "0.5rem",
      "item-radius": "0",
      match: "#000080",
      shadow: "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff",
      "shadow-open": "inset 1px 1px 0 #404040, inset -1px -1px 0 #ffffff"
    },
    "floating-window": {
      bg: "#c0c0c0",
      fg: "#000000",
      "border-color": "#000000",
      "border-width": "1px",
      radius: "0",
      shadow: "2px 2px 0 rgba(0, 0, 0, 0.35)",
      "titlebar-bg": "#000080",
      "titlebar-fg": "#ffffff",
      "titlebar-border-color": "#000080",
      "subtitle-color": "#e6e6e6",
      "control-hover-bg": "#dcd8d0",
      "close-hover-bg": "#dcd8d0",
      "close-hover-color": "#000000",
      "focus-color": "#000080",
      "header-bg": "#c0c0c0",
      "footer-bg": "#c0c0c0",
      "section-border-color": "#808080"
    },
    "data-grid": {
      surface: "#c0c0c0",
      "surface-2": "#c0c0c0",
      "surface-subtle": "#d4d0c8",
      "surface-elevated": "#ffffff",
      "row-base": "#c0c0c0",
      "zebra-odd": "#e2dfd8",
      "zebra-even": "#d2cec7",
      text: "#000000",
      muted: "#3f3f3f",
      "font-size": "0.8125rem",
      border: "#808080",
      "border-strong": "#404040",
      "details-row-padding": "0.75rem",
      header: "#c0c0c0",
      "header-shadow": "#808080",
      "header-border": "#000000",
      accent: "#000080",
      "accent-light": "#cbd2e8",
      hover: "#d4d0c8",
      "shell-border": "1px solid #000000",
      "shell-shadow": "inset 1px 1px 0 #ffffff, inset -1px -1px 0 #404040",
      "header-bevel-light": "#ffffff",
      "header-bevel-dark": "#404040",
      "cell-bevel-light": "#ffffff",
      "cell-bevel-dark": "#404040",
      "pager-radius": "0",
      "pager-border": "#808080",
      "pager-bevel-light": "#ffffff",
      "pager-bevel-dark": "#404040"
    }
  }
};
function Da(e, t) {
  const r = { ...e };
  for (const a of Object.keys(t)) {
    const o = t[a], c = e[a];
    o && typeof o == "object" && !Array.isArray(o) && c && typeof c == "object" ? r[a] = Da(c, o) : r[a] = o;
  }
  return r;
}
function Ua(e) {
  const t = kt;
  e.mode || (e.mode = t.mode);
  const r = ["colors", "semantic", "sizing", "component"];
  for (const o of r)
    e[o] = { ...t[o], ...e[o] };
  const a = ["spacing", "size", "radius", "fontSize", "lineHeight", "shadow", "borderWidth", "fontFamily", "fontWeight", "motionDuration", "motionEasing", "opacity", "zIndex", "transition", "density"];
  for (const o of a)
    e.sizing[o] = { ...t.sizing[o], ...e.sizing[o] };
  for (const o of Object.keys(t.component))
    e.component[o] = { ...t.component[o], ...e.component[o] || {} };
  return e;
}
function Ea(e, ...t) {
  const r = t.reduce((a, o) => {
    if (o.component) {
      const h = { ...a.component };
      for (const u of Object.keys(o.component))
        h[u] = { ...h[u], ...o.component[u] || {} };
      a.component = h;
    }
    const { component: c, ...s } = o;
    return Da(a, s);
  }, { ...e });
  return Ua(r);
}
function Ya(e) {
  return Ea(kt, e || {});
}
function ra(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Ga(e) {
  const t = {};
  for (const [r, a] of Object.entries(e.semantic)) t[`--flare-color-${ra(r)}`] = a;
  for (const [r, a] of Object.entries(e.colors))
    for (const [o, c] of Object.entries(a))
      t[`--flare-color-${r}-${o}`] = String(c);
  for (const [r, a] of Object.entries(e.sizing)) {
    const o = ra(r);
    for (const [c, s] of Object.entries(a))
      t[`--flare-${o}-${c}`] = String(s);
  }
  for (const [r, a] of Object.entries(e.component))
    for (const [o, c] of Object.entries(a))
      t[`--flare-${r}-${o}`] = String(c);
  return t["--flare-color-primary"] = e.semantic.primary ?? e.semantic.accent, t["--flare-color-primary-hover"] = e.semantic.primaryHover ?? e.semantic.accentHover, t["--flare-color-primary-active"] = e.semantic.primaryActive ?? e.semantic.accentActive, t["--flare-color-error"] = e.semantic.error ?? e.semantic.danger, t["--flare-color-error-subtle"] = e.semantic.errorSubtle ?? `color-mix(in srgb, ${e.semantic.danger} 16%, ${e.semantic.bg})`, t["--flare-color-error-dark"] = e.semantic.errorDark ?? e.semantic.danger, t["--flare-color-success-subtle"] = e.semantic.successSubtle ?? `color-mix(in srgb, ${e.semantic.success} 16%, ${e.semantic.bg})`, t["--flare-color-success-dark"] = e.semantic.successDark ?? e.semantic.success, t;
}
const Xa = {
  en: {
    languageTag: "en-US",
    direction: "ltr",
    messages: {
      dropdown: { filter: "Type to filter...", clear: "Clear selection", selectAll: "Select all", selectNone: "Select none", noResults: "No results found" },
      pager: { navigation: "Pagination", firstPage: "First page", previousPage: "Previous page", nextPage: "Next page", lastPage: "Last page", page: (e, t) => `Page ${e} of ${t}` },
      drawer: { close: "Close drawer", navigation: "Navigation", expand: (e) => `Expand ${e}`, collapse: (e) => `Collapse ${e}` },
      dataGrid: { noData: "No data", rows: "rows", of: "of", firstPage: "First page", previousPage: "Previous page", nextPage: "Next page", lastPage: "Last page", columnsMenu: "Columns menu", columns: "Columns", showAllColumns: "Show all", autoSizeColumns: "Auto size columns", hideColumn: (e) => `Hide “${e}”`, sortColumn: (e, t) => `Sort by ${e}${t ? `, currently ${t}` : ""}`, resizeColumn: (e) => `Resize column ${e}`, activateRow: "Row: press Enter to activate" },
      datePicker: { selectDate: "Select date", selectDateRange: "Select date range", clearDate: "Clear selected date", clearDateRange: "Clear selected date range", chooseDate: "Choose date", chooseDateRange: "Choose date range", previousYear: "Previous year", previousMonth: "Previous month", nextMonth: "Next month", nextYear: "Next year" }
    }
  },
  he: {
    languageTag: "he-IL",
    direction: "rtl",
    messages: {
      dropdown: { filter: "חיפוש", clear: "ניקוי בחירה", selectAll: "בחירת הכל", selectNone: "ניקוי הכל", noResults: "לא נמצאו תוצאות" },
      pager: { navigation: "דפדוף", firstPage: "עמוד ראשון", previousPage: "העמוד הקודם", nextPage: "העמוד הבא", lastPage: "עמוד אחרון", page: (e, t) => `עמוד ${e} מתוך ${t}` },
      drawer: { close: "סגירת המגירה", navigation: "ניווט", expand: (e) => `הרחבת ${e}`, collapse: (e) => `צמצום ${e}` },
      dataGrid: { noData: "אין נתונים", rows: "שורות", of: "מתוך", firstPage: "עמוד ראשון", previousPage: "העמוד הקודם", nextPage: "העמוד הבא", lastPage: "עמוד אחרון", columnsMenu: "תפריט עמודות", columns: "עמודות", showAllColumns: "הצגת הכל", autoSizeColumns: "התאמת רוחב עמודות", hideColumn: (e) => `הסתרת ${e}`, sortColumn: (e, t) => `מיון לפי ${e}${t ? `, ${t === "asc" ? "עולה" : "יורד"}` : ""}`, resizeColumn: (e) => `שינוי רוחב ${e}`, activateRow: "שורה: לחצו Enter להפעלה" },
      datePicker: { selectDate: "בחירת תאריך", selectDateRange: "בחירת טווח תאריכים", clearDate: "ניקוי התאריך שנבחר", clearDateRange: "ניקוי טווח התאריכים שנבחר", chooseDate: "בחירת תאריך", chooseDateRange: "בחירת טווח תאריכים", previousYear: "השנה הקודמת", previousMonth: "החודש הקודם", nextMonth: "החודש הבא", nextYear: "השנה הבאה" }
    }
  },
  th: {
    languageTag: "th-TH",
    direction: "ltr",
    messages: {
      dropdown: { filter: "พิมพ์เพื่อค้นหา...", clear: "ล้างการเลือก", selectAll: "เลือกทั้งหมด", selectNone: "ไม่เลือกเลย", noResults: "ไม่พบผลลัพธ์" },
      pager: { navigation: "การแบ่งหน้า", firstPage: "หน้าแรก", previousPage: "หน้าก่อนหน้า", nextPage: "หน้าถัดไป", lastPage: "หน้าสุดท้าย", page: (e, t) => `หน้า ${e} จาก ${t}` },
      drawer: { close: "ปิดแถบด้านข้าง", navigation: "การนำทาง", expand: (e) => `ขยาย ${e}`, collapse: (e) => `ยุบ ${e}` },
      dataGrid: { noData: "ไม่มีข้อมูล", rows: "แถว", of: "จาก", firstPage: "หน้าแรก", previousPage: "หน้าก่อนหน้า", nextPage: "หน้าถัดไป", lastPage: "หน้าสุดท้าย", columnsMenu: "เมนูคอลัมน์", columns: "คอลัมน์", showAllColumns: "แสดงทั้งหมด", autoSizeColumns: "ปรับขนาดคอลัมน์อัตโนมัติ", hideColumn: (e) => `ซ่อน ${e}`, sortColumn: (e, t) => `เรียงตาม ${e}${t ? `, ${t === "asc" ? "น้อยไปมาก" : "มากไปน้อย"}` : ""}`, resizeColumn: (e) => `ปรับขนาดคอลัมน์ ${e}`, activateRow: "แถว: กด Enter เพื่อเปิดใช้งาน" },
      datePicker: { selectDate: "เลือกวันที่", selectDateRange: "เลือกช่วงวันที่", clearDate: "ล้างวันที่ที่เลือก", clearDateRange: "ล้างช่วงวันที่ที่เลือก", chooseDate: "เลือกวันที่", chooseDateRange: "เลือกช่วงวันที่", previousYear: "ปีก่อนหน้า", previousMonth: "เดือนก่อนหน้า", nextMonth: "เดือนถัดไป", nextYear: "ปีถัดไป" }
    }
  }
};
function za(e = "en") {
  const t = Xa[e];
  return {
    locale: e,
    ...t,
    formatDate: (r, a) => new Intl.DateTimeFormat(t.languageTag, a).format(r),
    formatNumber: (r, a) => new Intl.NumberFormat(t.languageTag, a).format(r),
    formatCurrency: (r, a, o) => new Intl.NumberFormat(t.languageTag, { ...o, style: "currency", currency: a }).format(r)
  };
}
const Pa = Gr(za());
function Ja({ locale: e = "en", targetSelector: t = "#root", children: r }) {
  const a = ze(() => za(e), [e]);
  return W.useEffect(() => {
    const o = document.querySelector(t);
    if (!o) return;
    const c = o.getAttribute("lang"), s = o.getAttribute("dir");
    return o.lang = a.languageTag, o.dir = a.direction, () => {
      c === null ? o.removeAttribute("lang") : o.lang = c, s === null ? o.removeAttribute("dir") : o.dir = s;
    };
  }, [a.direction, a.languageTag, t]), /* @__PURE__ */ n.jsx(Pa.Provider, { value: a, children: r });
}
function fr() {
  return Pr(Pa);
}
const Ra = Gr(null);
function Fo(e) {
  var w;
  const t = ze(() => Ya(e.initial), [e.initial]), [r, a] = Ne(t.mode), [o, c] = Ne({}), s = R((x, k) => {
    var j, F, B;
    const N = {
      ...x,
      ...k,
      colors: { ...x.colors || {}, ...k.colors || {} },
      semantic: { ...x.semantic || {}, ...k.semantic || {} },
      sizing: { ...x.sizing || {}, ...k.sizing || {} },
      component: { ...x.component || {}, ...k.component || {} },
      meta: { ...x.meta || {}, ...k.meta || {} }
    };
    if (k.colors)
      for (const A of Object.keys(k.colors))
        N.colors = N.colors || {}, N.colors[A] = { ...((j = x.colors) == null ? void 0 : j[A]) || {}, ...k.colors[A] || {} };
    if (k.sizing)
      for (const A of Object.keys(k.sizing))
        N.sizing = N.sizing || {}, N.sizing[A] = { ...((F = x.sizing) == null ? void 0 : F[A]) || {}, ...k.sizing[A] || {} };
    if (k.component)
      for (const A of Object.keys(k.component))
        N.component = N.component || {}, N.component[A] = { ...((B = x.component) == null ? void 0 : B[A]) || {}, ...k.component[A] || {} };
    return N;
  }, []), h = R((x) => {
    x.mode && a(x.mode);
    const { mode: k, ...N } = x;
    Object.keys(N).length !== 0 && c((j) => s(j, N));
  }, [s]), u = R(() => {
    a((x) => x === "light" ? "dark" : "light");
  }, []), b = ze(() => Ea(t, r === "dark" ? Ka : { mode: "light" }, o), [t, r, o]), f = ze(() => Ga(b), [b]);
  return pe(() => {
    var j;
    const x = e.targetSelector ?? "#root", k = e.targetClassName ?? "flare-ui-theme", N = document.querySelector(x);
    if (N) {
      N.classList.add(k), N.setAttribute("data-flare-mode", b.mode), (j = b.meta) != null && j.name ? N.setAttribute("data-flare-theme", b.meta.name) : N.removeAttribute("data-flare-theme");
      for (const [F, B] of Object.entries(f))
        N.style.setProperty(F, B);
      return () => {
        N.classList.remove(k), N.removeAttribute("data-flare-mode"), N.removeAttribute("data-flare-theme");
        for (const F of Object.keys(f))
          N.style.removeProperty(F);
      };
    }
  }, [f, (w = b.meta) == null ? void 0 : w.name, b.mode, e.targetSelector, e.targetClassName]), /* @__PURE__ */ n.jsx(Ja, { locale: e.locale, targetSelector: e.targetSelector, children: /* @__PURE__ */ n.jsx(Ra.Provider, { value: { theme: b, setTheme: h, toggleMode: u }, children: e.children }) });
}
function To() {
  const e = Pr(Ra);
  if (!e) throw new Error("useFlareTheme must be used inside <FlareThemeProvider>");
  return e;
}
const Jr = Gr(null);
function Mo() {
  const e = Pr(Jr);
  if (!e)
    throw new Error("useFlareFormContext must be used within a FlareForm component");
  return e;
}
function Za() {
  return Pr(Jr);
}
const Qa = ja(
  ({
    onSubmit: e,
    onChange: t,
    onValidationFail: r,
    className: a,
    children: o,
    autoFocusFirstField: c = !1,
    autoShowErrors: s = !0
  }, h) => {
    const u = me(/* @__PURE__ */ new Map()), b = me([]);
    me(null);
    const f = R(() => {
      const P = {};
      let Y = !0;
      return u.current.forEach((X, oe) => {
        X.validate() || (Y = !1, X.getValue(), P[oe] = P[oe] || "Validation failed");
      }), !Y && r && r(P), { isValid: Y, errors: P };
    }, [r]), w = R(() => {
      u.current.forEach((P) => {
        var Y;
        (Y = P.onReset) == null || Y.call(P);
      });
    }, []), x = R(() => {
      const P = {};
      return u.current.forEach((Y, X) => {
        P[X] = Y.getValue();
      }), P;
    }, []), k = R(() => {
      for (const P of u.current.values())
        if (!P.validate())
          return !1;
      return !0;
    }, []), N = R(() => {
      const P = {};
      return u.current.forEach((Y, X) => {
        Y.validate() || (P[X] = P[X] || "Validation failed");
      }), P;
    }, []), j = R(
      (P) => {
        const Y = u.current.get(P);
        if (!Y)
          return { isValid: !0 };
        const X = Y.validate();
        return {
          isValid: X,
          error: X ? void 0 : "Validation failed"
        };
      },
      []
    ), F = R(
      (P, Y, X, oe) => {
        u.current.set(P, { validate: Y, getValue: X, onReset: oe }), b.current.includes(P) || b.current.push(P);
      },
      []
    ), B = R((P) => {
      u.current.delete(P), b.current = b.current.filter((Y) => Y !== P);
    }, []);
    _r(
      h,
      () => ({
        validate: f,
        reset: w,
        getValues: x,
        isValid: k,
        getErrors: N,
        validateField: j,
        registerField: F,
        unregisterField: B
      }),
      [f, w, x, k, N, j]
    );
    const A = W.useMemo(
      () => ({
        registerField: (P, Y, X, oe) => {
          F(P, Y, X, oe);
        },
        unregisterField: B,
        getFormHandle: () => ({
          validate: f,
          reset: w,
          getValues: x,
          isValid: k,
          getErrors: N,
          validateField: j,
          registerField: F,
          unregisterField: B
        })
      }),
      [F, B, f, w, x, k, N, j]
    );
    return /* @__PURE__ */ n.jsx(Jr.Provider, { value: A, children: /* @__PURE__ */ n.jsx("form", { className: a, children: o }) });
  }
);
Qa.displayName = "FlareForm";
const aa = {
  "flare-popup": "_flare-popup_lqug5_1",
  "flare-popup-content": "_flare-popup-content_lqug5_22"
}, ir = /* @__PURE__ */ new Map();
let en = 0;
const tn = 8, rn = 1e4, an = 160, nn = 80;
function na(e, t, r) {
  return Math.max(t, Math.min(e, r));
}
function Ia(e) {
  return e === "bottom" ? "top" : e === "top" ? "bottom" : e === "left" ? "right" : "left";
}
function on(e) {
  return ["bottom", "top", "right", "left"].filter((r) => r !== e && r !== Ia(e));
}
function Zr(e) {
  if (e !== void 0)
    return typeof e == "number" ? `${e}px` : e;
}
function oa(e) {
  if (e === void 0)
    return null;
  if (typeof e == "number")
    return e;
  const t = e.trim();
  if (t.endsWith("px")) {
    const r = Number(t.slice(0, -2));
    return Number.isFinite(r) ? r : null;
  }
  return null;
}
function Fa() {
  return typeof window > "u" ? { width: 0, height: 0 } : window.visualViewport ? {
    width: window.visualViewport.width,
    height: window.visualViewport.height
  } : { width: window.innerWidth, height: window.innerHeight };
}
function ln(e) {
  return typeof document > "u" ? "ltr" : e ? window.getComputedStyle(e).direction === "rtl" ? "rtl" : "ltr" : (document.documentElement.getAttribute("dir") || document.body.getAttribute("dir")) === "rtl" ? "rtl" : "ltr";
}
function la(e, t, r, a) {
  return r === "center" ? e.left + (e.width - t) / 2 : a === "rtl" ? r === "start" ? e.right - t : e.left : r === "start" ? e.left : e.right - t;
}
function ia(e, t, r) {
  return r === "center" ? e.top + (e.height - t) / 2 : r === "start" ? e.top : e.bottom - t;
}
function cn(e) {
  const t = Fa();
  return {
    left: e,
    top: e,
    right: t.width - e,
    bottom: t.height - e
  };
}
function sn(e, t, r, a, o, c, s, h, u, b) {
  let f = 0, w = 0;
  e === "bottom" && (f = t.bottom + s, w = la(t, r, o, c)), e === "top" && (f = t.top - s - a, w = la(t, r, o, c)), e === "right" && (w = t.right + s, f = ia(t, a, o)), e === "left" && (w = t.left - s - r, f = ia(t, a, o)), w += h, f += u;
  const x = na(w, b.left, b.right - r), k = na(f, b.top, b.bottom - a), N = w >= b.left && w <= b.right - r && f >= b.top && f <= b.bottom - a, j = Math.max(0, Math.min(w + r, b.right) - Math.max(w, b.left)), F = Math.max(0, Math.min(f + a, b.bottom) - Math.max(f, b.top)), B = j * F;
  return {
    placement: e,
    top: f,
    left: w,
    topClamped: k,
    leftClamped: x,
    fits: N,
    visibleArea: B
  };
}
function ca(e, t, r, a) {
  const o = r === "width" ? `calc(100vw - ${a * 2}px)` : `calc(100vh - ${a * 2}px)`, c = [];
  return e !== void 0 && c.push(Zr(e) ?? o), t !== void 0 && Number.isFinite(t) && c.push(`${t}px`), c.push(o), c.length === 1 ? c[0] : `min(${c.join(", ")})`;
}
function sa(e, t, r) {
  if (e === void 0)
    return;
  const a = t === "width" ? `calc(100vw - ${r * 2}px)` : `calc(100vh - ${r * 2}px)`;
  return `min(${Zr(e)}, ${a})`;
}
function dn(e, t, r) {
  if (e === void 0)
    return;
  const a = `calc(100vw - ${r * 2}px)`;
  return `min(${Zr(e)}, ${a})`;
}
function da(e) {
  const t = [
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    'input:not([disabled]):not([type="hidden"])',
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ];
  return Array.from(e.querySelectorAll(t.join(","))).filter((r) => !r.hasAttribute("disabled") && !r.getAttribute("aria-hidden"));
}
const Rr = W.forwardRef(function(t, r) {
  var gt, ft;
  const {
    children: a,
    className: o,
    style: c,
    zIndex: s,
    portalTarget: h,
    matchAnchorWidth: u,
    width: b,
    minWidth: f,
    maxWidth: w,
    minHeight: x,
    maxHeight: k,
    screenPadding: N,
    closeOnEscape: j,
    closeOnOutsidePointerDown: F,
    outsidePointerDownStrategy: B,
    ignoreAnchorPointerDown: A,
    outsidePointerDownIgnore: P,
    autoCloseAfterMs: Y,
    autoFocus: X,
    restoreFocus: oe,
    trapFocus: G,
    containerProps: S,
    elementRef: Z,
    stackingScopeId: We,
    onRequestClose: be,
    ...ee
  } = t, q = me(`flare-popup-${en++}`), T = me(null), L = me(null), ke = me(null), te = me(null), ce = me(null), we = me(null), Fe = me(0), De = me(!1), [Ee, Me] = Ne(!1), [Be, qe] = Ne(!1), [Xe, xe] = Ne("translate3d(0px, 0px, 0)"), [ue, Ve] = Ne({}), [Oe, st] = Ne(null), Pe = N ?? tn, dt = s ?? rn, ut = We ?? "default", Q = ze(
    () => ca(w, ue.maxWidthPx, "width", Pe),
    [w, ue.maxWidthPx, Pe]
  ), se = ze(
    () => ca(k, ue.maxHeightPx, "height", Pe),
    [k, ue.maxHeightPx, Pe]
  ), re = ze(
    () => dn(b, "width", Pe),
    [b, Pe]
  ), p = ze(
    () => sa(f, "width", Pe),
    [f, Pe]
  ), z = ze(
    () => sa(x, "height", Pe),
    [x, Pe]
  ), V = R(
    ($) => {
      we.current && (window.clearTimeout(we.current), we.current = null), !(!$ || $ <= 0) && (we.current = window.setTimeout(() => {
        le("timeout") && ie();
      }, $));
    },
    []
  ), le = R(
    ($) => be ? be($) !== !1 : !0,
    [be]
  ), he = R(() => {
    const $ = ir.get(ut) ?? [];
    return $[$.length - 1] === q.current;
  }, [ut]), ie = R(() => {
    if (De.current && (De.current = !1, Me(!1), qe(!1), L.current = null, Ve({}), st(null), Fe.current = 0, we.current && (window.clearTimeout(we.current), we.current = null), oe && ce.current)) {
      const $ = ce.current;
      document.contains($) && $.focus(), ce.current = null;
    }
  }, [oe]), rt = R(() => {
    var l, v;
    if (!De.current)
      return;
    const $ = T.current, K = L.current;
    if (!$ || !K)
      return;
    if (K.anchor && !K.anchor.isConnected) {
      le("anchor-gone") && ie();
      return;
    }
    const je = cn(Pe), C = je.right - je.left, J = je.bottom - je.top, ve = $.getBoundingClientRect(), Te = ve.width, Ae = ve.height, vt = K.anchor ? K.anchor.getBoundingClientRect() : new DOMRect(
      ((l = K.point) == null ? void 0 : l.x) ?? 0,
      ((v = K.point) == null ? void 0 : v.y) ?? 0,
      0,
      0
    ), _t = ln(K.anchor), g = K.matchAnchorWidth && K.anchor ? K.anchor.getBoundingClientRect().width : null;
    g !== Oe && st(g);
    const D = [
      K.placement,
      Ia(K.placement),
      ...on(K.placement)
    ].map(
      (i) => sn(
        i,
        vt,
        Te,
        Ae,
        K.align,
        _t,
        K.offset,
        K.offsetX,
        K.offsetY,
        je
      )
    ), I = oa(f) ?? an, Ce = oa(x) ?? nn, Le = D[0], Je = Te > C || Ae > J;
    if (Fe.current === 0) {
      const i = D.find((m) => m.fits);
      if (K.policy === "cursor") {
        const m = Le.left + Te > je.right, U = Le.top + Ae > je.bottom;
        if ((m || U) && !Je) {
          const de = m ? Math.max(0, je.right - Le.left) : void 0, fe = U ? Math.max(0, je.bottom - Le.top) : void 0, Re = de === void 0 || de >= I, bt = fe === void 0 || fe >= Ce;
          if (Re && bt && (de !== void 0 || fe !== void 0)) {
            const Qe = {
              maxWidthPx: de ?? ue.maxWidthPx,
              maxHeightPx: fe ?? ue.maxHeightPx
            };
            if (Qe.maxWidthPx !== ue.maxWidthPx || Qe.maxHeightPx !== ue.maxHeightPx) {
              Fe.current = 1, Ve(Qe), qe(!1);
              return;
            }
          }
        }
      }
      if (Je) {
        const m = {
          maxWidthPx: Math.max(0, C),
          maxHeightPx: Math.max(0, J)
        };
        if (m.maxWidthPx !== ue.maxWidthPx || m.maxHeightPx !== ue.maxHeightPx) {
          Fe.current = 1, Ve(m), qe(!1);
          return;
        }
      }
      if (i && !K.preferPlacement) {
        const m = i.left, U = i.top;
        xe(`translate3d(${m}px, ${U}px, 0)`), qe(!0), Fe.current = 0;
        return;
      }
    }
    const Ge = D.filter((i) => {
      const m = Te >= I || i.visibleArea > 0, U = Ae >= Ce || i.visibleArea > 0;
      return m && U;
    }), Ze = Ge.length > 0 ? Ge : D, E = K.preferPlacement ? Le : Ze.reduce((i, m) => !i || m.fits && !i.fits || m.fits === i.fits && m.visibleArea > i.visibleArea ? m : i, null);
    E && (xe(`translate3d(${E.leftClamped}px, ${E.topClamped}px, 0)`), qe(!0), Fe.current = 0);
  }, [
    Oe,
    ie,
    le,
    x,
    f,
    Pe,
    ue.maxHeightPx,
    ue.maxWidthPx
  ]), He = R(() => {
    De.current && (te.current || (te.current = window.requestAnimationFrame(() => {
      te.current = null, rt();
    })));
  }, [rt]), ae = R(
    ($) => {
      var H, D, I, Ce, Le, Je;
      const K = ($ == null ? void 0 : $.placement) ?? ((H = L.current) == null ? void 0 : H.placement) ?? "bottom", je = ($ == null ? void 0 : $.align) ?? ((D = L.current) == null ? void 0 : D.align) ?? "start", C = ($ == null ? void 0 : $.offset) ?? ((I = L.current) == null ? void 0 : I.offset) ?? 0, J = ($ == null ? void 0 : $.offsetX) ?? ((Ce = L.current) == null ? void 0 : Ce.offsetX) ?? 0, ve = ($ == null ? void 0 : $.offsetY) ?? ((Le = L.current) == null ? void 0 : Le.offsetY) ?? 0, Te = ($ == null ? void 0 : $.matchAnchorWidth) ?? u ?? !1, Ae = ($ == null ? void 0 : $.preferPlacement) ?? ((Je = L.current) == null ? void 0 : Je.preferPlacement) ?? !1;
      let vt = $ == null ? void 0 : $.anchor, _t = $ == null ? void 0 : $.point, g = "cursor";
      if (vt && (g = "anchor"), !vt && !_t) {
        const Ge = ke.current;
        if (Ge)
          _t = Ge;
        else {
          const Ze = Fa();
          _t = { x: Ze.width / 2, y: Ze.height / 2 };
        }
      }
      if (vt && (_t = void 0), L.current = {
        anchor: vt,
        point: _t,
        placement: K,
        align: je,
        offset: C,
        offsetX: J,
        offsetY: ve,
        matchAnchorWidth: Te,
        preferPlacement: Ae,
        policy: g
      }, Fe.current = 0, Ve({}), qe(!1), De.current || (De.current = !0, Me(!0)), oe) {
        const Ge = document.activeElement;
        Ge && Ge instanceof HTMLElement && (ce.current = Ge);
      }
      V(Y ?? null), He();
    },
    [Y, u, oe, V, He]
  );
  _r(r, () => ({
    open: ae,
    close: ie,
    updatePosition: He
  })), pe(() => {
    if (typeof document > "u")
      return;
    const $ = (K) => {
      ke.current = { x: K.clientX, y: K.clientY };
    };
    return document.addEventListener("pointermove", $, { capture: !0 }), document.addEventListener("pointerdown", $, { capture: !0 }), () => {
      document.removeEventListener("pointermove", $, { capture: !0 }), document.removeEventListener("pointerdown", $, { capture: !0 });
    };
  }, []), pe(() => {
    if (!Ee)
      return;
    const $ = ir.get(ut) ?? [];
    return $.push(q.current), ir.set(ut, $), () => {
      const K = ir.get(ut) ?? [], je = K.indexOf(q.current);
      je >= 0 && K.splice(je, 1), K.length === 0 ? ir.delete(ut) : ir.set(ut, K);
    };
  }, [Ee, ut]), Na(() => {
    Ee && rt();
  }, [Ee, se, Q, z, p, rt]), pe(() => {
    if (!Ee)
      return;
    const $ = () => {
      He();
    }, K = () => {
      He();
    };
    return window.addEventListener("resize", $), window.addEventListener("scroll", K, !0), window.visualViewport && (window.visualViewport.addEventListener("resize", $), window.visualViewport.addEventListener("scroll", $)), () => {
      window.removeEventListener("resize", $), window.removeEventListener("scroll", K, !0), window.visualViewport && (window.visualViewport.removeEventListener("resize", $), window.visualViewport.removeEventListener("scroll", $));
    };
  }, [Ee, He]), pe(() => {
    if (!Ee || !T.current || typeof ResizeObserver > "u")
      return;
    const $ = new ResizeObserver(() => {
      He();
    });
    return $.observe(T.current), () => {
      $.disconnect();
    };
  }, [Ee, He]), pe(() => {
    if (!Ee || !j)
      return;
    const $ = (K) => {
      he() && K.key === "Escape" && le("escape") && ie();
    };
    return document.addEventListener("keydown", $, { capture: !0 }), () => {
      document.removeEventListener("keydown", $, { capture: !0 });
    };
  }, [ie, le, Ee, he, j]), pe(() => {
    if (!Ee || !G)
      return;
    const $ = (K) => {
      if (!he() || K.key !== "Tab")
        return;
      const je = T.current;
      if (!je)
        return;
      const C = da(je);
      if (C.length === 0) {
        K.preventDefault(), je.focus();
        return;
      }
      const J = C[0], ve = C[C.length - 1], Te = document.activeElement;
      K.shiftKey ? (Te === J || Te === je) && (K.preventDefault(), ve.focus()) : Te === ve && (K.preventDefault(), J.focus());
    };
    return document.addEventListener("keydown", $, { capture: !0 }), () => {
      document.removeEventListener("keydown", $, { capture: !0 });
    };
  }, [Ee, he, G]), pe(() => {
    if (!Ee || !F)
      return;
    const $ = B === "click" ? "click" : "pointerdown", K = (je) => {
      var Ae;
      if (!he())
        return;
      const C = je.target;
      if (!C)
        return;
      const J = T.current;
      if (J && J.contains(C))
        return;
      const ve = (Ae = L.current) == null ? void 0 : Ae.anchor;
      if (A !== !1 && ve && ve.contains(C) || P && P(je.target))
        return;
      le("outside") && ie();
    };
    return document.addEventListener($, K, { capture: !0 }), () => {
      document.removeEventListener($, K, { capture: !0 });
    };
  }, [
    ie,
    le,
    Ee,
    he,
    F,
    A,
    P,
    B
  ]), pe(() => {
    if (!Ee || !X)
      return;
    const $ = T.current;
    if (!$)
      return;
    const K = () => {
      const C = da($);
      C.length > 0 ? C[0].focus() : $.focus();
    }, je = window.requestAnimationFrame(K);
    return () => {
      window.cancelAnimationFrame(je);
    };
  }, [Ee, X]), pe(() => {
    Ee && V(Y ?? null);
  }, [Ee, Y, V]), pe(() => () => {
    we.current && (window.clearTimeout(we.current), we.current = null), te.current && (window.cancelAnimationFrame(te.current), te.current = null);
  }, []);
  const ye = ze(() => ({
    ...ee,
    ...S
  }), [S, ee]), Ke = R(($) => {
    T.current = $, typeof Z == "function" ? Z($) : Z && (Z.current = $);
  }, [Z]), $e = [aa["flare-popup"], o, S == null ? void 0 : S.className].filter(Boolean).join(" "), Ue = {
    position: "fixed",
    top: 0,
    left: 0,
    transform: Xe,
    zIndex: dt,
    opacity: Be ? 1 : 0,
    pointerEvents: Be ? "auto" : "none"
  }, xt = {
    ...S == null ? void 0 : S.style,
    ...c,
    ...Ue
  }, nt = Oe !== null ? `${Oe}px` : void 0, Ye = {
    // Keep popup at least as wide as its anchor but allow it to grow when menu items are wider.
    minWidth: re ?? nt ?? p,
    maxWidth: re ?? Q,
    width: re,
    minHeight: z,
    maxHeight: se
  }, mt = h ?? (typeof document < "u" ? ((ft = (gt = L.current) == null ? void 0 : gt.anchor) == null ? void 0 : ft.closest(".flare-ui-theme")) ?? document.body : null);
  return !mt || !Ee ? null : Xr(
    /* @__PURE__ */ n.jsx(
      "div",
      {
        ...ye,
        ref: Ke,
        className: $e,
        style: xt,
        tabIndex: (S == null ? void 0 : S.tabIndex) ?? t.tabIndex ?? -1,
        children: /* @__PURE__ */ n.jsx("div", { className: aa["flare-popup-content"], style: Ye, children: a })
      }
    ),
    mt
  );
});
function un(e, t) {
  const r = [];
  if (t.required && (e == null || typeof e == "string" && e.trim() === "" || Array.isArray(e) && e.length === 0) && r.push("This field is required"), t.customValidation && r.length === 0) {
    const a = Array.isArray(t.customValidation) ? t.customValidation : [t.customValidation];
    for (const o of a)
      try {
        const c = o({ value: e, checked: e });
        c && r.push(c);
      } catch (c) {
        console.error("Validation error:", c), r.push("Validation error occurred");
      }
  }
  return r.length > 0 ? { isValid: !1, error: r.join("; ") } : { isValid: !0, error: null };
}
function ar(e) {
  const [t, r] = Ne(null), [a, o] = Ne(null), [c, s] = Ne(!1), h = (F) => {
    const B = Array.isArray(e.customValidation) ? e.customValidation.length > 0 : !!e.customValidation;
    if (!(!!e.required || B))
      return t !== null && r(null), c && s(!1), !0;
    const P = un(F, {
      required: e.required,
      customValidation: e.customValidation
    });
    return P.isValid ? (r(null), s(!0), !0) : (r(P.error ?? null), s(!1), !1);
  };
  _r(e.refHandle, () => ({
    onChange: (F) => {
      o(F);
    },
    validate: (F) => h(F),
    isValid: () => (e.validationError ?? t) === null && c
  }));
  const u = e.validationError ?? t, b = !u && c, f = () => {
    if (u)
      return /* @__PURE__ */ n.jsx("div", { className: "container-validation-error", children: /* @__PURE__ */ n.jsx("span", { children: u }) });
  }, w = () => {
    if (!(!e.required || b))
      return /* @__PURE__ */ n.jsx("span", { className: "required-field-asterisk", children: "*" });
  }, x = () => {
    if (b)
      return /* @__PURE__ */ n.jsx("span", { className: "validation-valid-icon", "aria-hidden": "true", children: "✓" });
  }, k = ["flare-input-wrapper"];
  u && k.push("validation-error"), b && k.push("validation-valid");
  const N = k.filter((F) => F == null ? void 0 : F.trim().length).join(" "), j = [
    "container-label",
    u ? "validation-error" : "",
    b ? "validation-valid" : ""
  ].filter((F) => F == null ? void 0 : F.trim().length).join(" ");
  return /* @__PURE__ */ n.jsxs("div", { className: N, children: [
    !e.hideLabel && /* @__PURE__ */ n.jsxs("div", { className: j, children: [
      x(),
      w(),
      e.label
    ] }),
    /* @__PURE__ */ n.jsx("div", { className: "container-input", children: e.children }),
    f()
  ] });
}
function nr(e, t, r, a) {
  const o = Za(), c = me(null);
  pe(() => {
    if (!(!o || !e))
      return c.current && c.current !== e && o.unregisterField(c.current), o.registerField(e, () => t(), r, a), c.current = e, () => {
        c.current === e && (o.unregisterField(e), c.current = null);
      };
  }, [e, t, r, a, o]);
}
const pt = {
  "flare-auto-complete": "_flare-auto-complete_1bny6_1",
  "flare-auto-complete-field": "_flare-auto-complete-field_1bny6_70",
  "is-disabled": "_is-disabled_1bny6_92",
  "flare-auto-complete-input": "_flare-auto-complete-input_1bny6_97",
  "flare-auto-complete-icon": "_flare-auto-complete-icon_1bny6_119",
  "flare-auto-complete-popup": "_flare-auto-complete-popup_1bny6_131",
  "flare-auto-complete-menu": "_flare-auto-complete-menu_1bny6_135",
  "flare-auto-complete-item": "_flare-auto-complete-item_1bny6_165",
  "is-active": "_is-active_1bny6_182",
  "flare-auto-complete-item-icon": "_flare-auto-complete-item-icon_1bny6_191",
  "flare-auto-complete-item-label": "_flare-auto-complete-item-label_1bny6_198",
  "flare-auto-complete-item-description": "_flare-auto-complete-item-description_1bny6_205",
  "flare-auto-complete-item-disabled": "_flare-auto-complete-item-disabled_1bny6_210",
  "flare-auto-complete-match": "_flare-auto-complete-match_1bny6_215",
  "flare-auto-complete-empty": "_flare-auto-complete-empty_1bny6_220"
}, xr = (...e) => e.filter(Boolean).join(" ");
function ua(e) {
  if (e !== void 0)
    return typeof e == "number" ? `${e}px` : e;
}
function fn(e, t) {
  if (!t.trim())
    return e;
  const r = t.toLowerCase().split(/\s+/).map((a) => a.trim()).filter(Boolean);
  return r.length ? e.filter((a) => {
    const c = (typeof a == "string" ? a : a.displayText).toLowerCase();
    return r.every((s) => c.includes(s));
  }) : e;
}
function mn(e, t) {
  if (!t.trim())
    return [{ value: e, match: !1 }];
  const r = t.trim().split(/\s+/).map((s) => s.trim()).filter(Boolean);
  if (!r.length)
    return [{ value: e, match: !1 }];
  const a = r.map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")), o = new RegExp(`(${a.join("|")})`, "gi");
  return e.split(o).filter((s) => s.length > 0).map((s) => ({
    value: s,
    match: r.some((h) => h.toLowerCase() === s.toLowerCase())
  }));
}
function Oo(e) {
  const [t, r] = Ne(() => e.value !== void 0 ? e.value : typeof e.defaultValue == "string" ? e.defaultValue : ""), [a, o] = Ne(!1), [c, s] = Ne(!1), [h, u] = Ne([]), [b, f] = Ne(-1), w = me(null), x = me(null), k = me(null), N = me([]), j = me(0), F = W.useRef(null), B = Rt(), A = e.id ?? Rt(), P = e.value !== void 0 ? e.value : t, Y = e.minQueryLength ?? 0, X = P.trim().length >= Y, oe = e.filterItems ?? fn;
  pe(() => {
    e.value !== void 0 && e.value !== t && r(e.value);
  }, [e.value, t]);
  const G = R((E) => {
    var l, v, i;
    e.value === void 0 && r(E), (l = F.current) == null || l.onChange(E), (v = F.current) == null || v.validate(E), (i = e.onChange) == null || i.call(e, E);
  }, [e.onChange, e.value]), S = R(() => P, [P]), Z = R(() => {
    var E;
    return ((E = F.current) == null ? void 0 : E.validate(S())) ?? !0;
  }, [S]), We = R(() => {
    var E, l;
    e.value === void 0 && r(""), (E = F.current) == null || E.onChange(""), (l = F.current) == null || l.validate("");
  }, [e.value]);
  nr(e.name, Z, S, We);
  const be = R(() => {
    f(-1);
  }, []), ee = R(() => {
    o(!1), be();
  }, [be]), q = R(() => {
    e.disabled || o(!0);
  }, [e.disabled]);
  pe(() => {
    var E;
    (E = e.onOpenChange) == null || E.call(e, a);
  }, [a, e.onOpenChange]), pe(() => {
    const E = w.current, l = x.current;
    if (E) {
      if (!a) {
        E.close();
        return;
      }
      l && E.open({
        anchor: l,
        placement: e.popupPlacement ?? "bottom",
        align: e.popupAlign ?? "start",
        offset: e.popupOffset ?? 8,
        matchAnchorWidth: e.matchPopupWidth ?? !0
      });
    }
  }, [a, e.matchPopupWidth, e.popupAlign, e.popupOffset, e.popupPlacement]), pe(() => {
    if (!e.fetchItems && e.items) {
      if (!X) {
        u([]), be();
        return;
      }
      const i = oe(e.items, P);
      u(i), be();
      return;
    }
    if (!e.fetchItems) {
      u([]), be();
      return;
    }
    if (!X) {
      u([]), be(), s(!1);
      return;
    }
    const E = j.current + 1;
    j.current = E;
    let l = null;
    const v = () => {
      var i;
      s(!0), (i = e.fetchItems) == null || i.call(e, P).then((m) => {
        j.current === E && (u(oe(m, P)), be());
      }).catch(() => {
        j.current === E && (u([]), be());
      }).finally(() => {
        j.current === E && s(!1);
      });
    };
    return e.debounceMs && e.debounceMs > 0 ? l = window.setTimeout(v, e.debounceMs) : v(), () => {
      l !== null && window.clearTimeout(l);
    };
  }, [
    oe,
    X,
    e.debounceMs,
    e.fetchItems,
    e.items,
    be,
    P
  ]);
  const T = R((E) => typeof E == "string" ? !1 : !!E.disabled, []), L = R((E, l) => {
    if (!h.length)
      return -1;
    let v = E;
    for (let i = 0; i < h.length; i += 1)
      if (v = (v + l + h.length) % h.length, !T(h[v]))
        return v;
    return -1;
  }, [h, T]);
  pe(() => {
    if (a) {
      if (!h.length) {
        f(-1);
        return;
      }
      f((E) => E >= 0 && E < h.length && !T(h[E]) ? E : L(-1, 1));
    }
  }, [h, L, T, a]), pe(() => {
    var E;
    b < 0 || (E = N.current[b]) == null || E.scrollIntoView({ block: "nearest" });
  }, [b]);
  const ke = R(() => (ee(), !0), [ee]), te = (E) => {
    G(E.target.value), q();
  }, ce = (E) => {
    var l;
    (l = e.onFocus) == null || l.call(e, E), (e.openOnFocus ?? !0) && q();
  }, we = (E) => {
    var l;
    (l = e.onClick) == null || l.call(e, E), (e.openOnFocus ?? !0) && q();
  }, Fe = (E) => {
    var l;
    (l = e.onBlur) == null || l.call(e, E);
  }, De = R((E) => {
    var v;
    if (T(E))
      return;
    const l = typeof E == "string" ? E : E.displayText;
    G(l), (v = e.onSelect) == null || v.call(e, E), ee();
  }, [ee, T, e.onSelect, G]), Ee = (E) => {
    var l;
    if ((l = e.onKeyDown) == null || l.call(e, E), !E.defaultPrevented) {
      if (!a && (E.key === "ArrowDown" || E.key === "ArrowUp")) {
        q(), E.preventDefault();
        return;
      }
      switch (E.key) {
        case "ArrowDown":
          E.preventDefault(), f((v) => {
            const i = v < 0 ? -1 : v;
            return L(i, 1);
          });
          break;
        case "ArrowUp":
          E.preventDefault(), f((v) => {
            const i = v < 0 ? 0 : v;
            return L(i, -1);
          });
          break;
        case "PageDown":
          E.preventDefault(), f((v) => {
            const i = Math.min(v + 5, h.length - 1);
            return T(h[i]) ? L(i, 1) : i;
          });
          break;
        case "PageUp":
          E.preventDefault(), f((v) => {
            const i = Math.max(v - 5, 0);
            return T(h[i]) ? L(i, -1) : i;
          });
          break;
        case "Enter":
          if (E.preventDefault(), b >= 0 && b < h.length) {
            De(h[b]);
            return;
          }
          e.allowCustomValue && P.trim().length > 0 && De(P);
          break;
        case "Escape":
          E.preventDefault(), ee();
          break;
        case "Tab":
          ee();
          break;
      }
    }
  }, Me = R((E) => mn(E, P).map((v, i) => v.match ? /* @__PURE__ */ n.jsx("span", { className: pt["flare-auto-complete-match"], children: v.value }, `${v.value}-${i}`) : /* @__PURE__ */ n.jsx(W.Fragment, { children: v.value }, `${v.value}-${i}`)), [P]), Be = R((E, l) => typeof E == "string" ? /* @__PURE__ */ n.jsx("span", { className: pt["flare-auto-complete-item-label"], children: Me(E) }) : /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    E.icon && /* @__PURE__ */ n.jsx("span", { className: pt["flare-auto-complete-item-icon"], "aria-hidden": !0, children: E.icon }),
    /* @__PURE__ */ n.jsx("span", { className: pt["flare-auto-complete-item-label"], children: Me(E.displayText) }),
    E.description && /* @__PURE__ */ n.jsx("span", { className: pt["flare-auto-complete-item-description"], children: E.description }),
    l.disabled && /* @__PURE__ */ n.jsx("span", { className: pt["flare-auto-complete-item-disabled"], children: "Disabled" })
  ] }), [Me]), qe = ze(() => X ? e.noResultsText ?? "No results found." : e.emptyStateText ?? "Start typing to search.", [X, e.emptyStateText, e.noResultsText]), Xe = !c && a && h.length === 0, xe = a && h.length > 0, ue = ze(() => {
    if (!(e.popupMinWidth === void 0 && e.popupMaxHeight === void 0))
      return {
        "--flare-auto-complete-menu-min-width": ua(e.popupMinWidth),
        "--flare-auto-complete-menu-max-height": ua(e.popupMaxHeight)
      };
  }, [e.popupMaxHeight, e.popupMinWidth]), Ve = ze(
    () => xr(pt["flare-auto-complete"], e.className),
    [e.className]
  ), Oe = ze(
    () => xr(
      pt["flare-auto-complete-field"],
      e.disabled && pt["is-disabled"]
    ),
    [e.disabled]
  ), st = ze(
    () => xr(pt["flare-auto-complete-input"], e.inputClassName),
    [e.inputClassName]
  ), Pe = `${B}-listbox`, dt = b >= 0 ? `${Pe}-item-${b}` : void 0;
  _r(e.controller, () => ({
    clear: () => {
      G(""), ee();
    },
    focus: () => {
      var E;
      (E = k.current) == null || E.focus();
    },
    open: () => {
      q();
    },
    close: () => {
      ee();
    }
  }), [ee, q, G]);
  const {
    items: ut,
    fetchItems: Q,
    value: se,
    onChange: re,
    onSelect: p,
    onOpenChange: z,
    label: V,
    icon: le,
    placeholder: he,
    direction: ie,
    className: rt,
    inputClassName: He,
    disabled: ae,
    matchPopupWidth: ye,
    popupPlacement: Ke,
    popupAlign: $e,
    popupOffset: Ue,
    popupMinWidth: xt,
    popupMaxHeight: nt,
    openOnFocus: Ye,
    allowCustomValue: mt,
    minQueryLength: gt,
    debounceMs: ft,
    emptyStateText: $,
    noResultsText: K,
    loadingText: je,
    listboxLabel: C,
    filterItems: J,
    renderItem: ve,
    controller: Te,
    onFocus: Ae,
    onBlur: vt,
    onClick: _t,
    onKeyDown: g,
    autoComplete: H,
    defaultValue: D,
    required: I,
    validationError: Ce,
    refForward: Le,
    customValidation: Je,
    allowEmpty: Ge,
    ...Ze
  } = e;
  return /* @__PURE__ */ n.jsx(
    ar,
    {
      label: e.label,
      refHandle: F,
      validationError: Ce,
      required: I,
      customValidation: Je,
      children: /* @__PURE__ */ n.jsxs(
        "div",
        {
          className: Ve,
          ref: x,
          dir: ie === "auto" || ie == null ? void 0 : ie,
          children: [
            /* @__PURE__ */ n.jsxs("div", { className: Oe, children: [
              e.icon && /* @__PURE__ */ n.jsx("span", { className: pt["flare-auto-complete-icon"], children: e.icon }),
              /* @__PURE__ */ n.jsx(
                "input",
                {
                  ...Ze,
                  id: A,
                  ref: k,
                  type: e.type ?? "text",
                  value: P,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  dir: ie === "auto" || ie == null ? void 0 : ie,
                  className: st,
                  onChange: te,
                  onFocus: ce,
                  onBlur: Fe,
                  onClick: we,
                  onKeyDown: Ee,
                  role: "combobox",
                  "aria-autocomplete": "list",
                  "aria-expanded": a,
                  "aria-controls": Pe,
                  "aria-activedescendant": dt,
                  autoComplete: H ?? "off"
                }
              )
            ] }),
            /* @__PURE__ */ n.jsx(
              Rr,
              {
                ref: w,
                className: pt["flare-auto-complete-popup"],
                closeOnEscape: !0,
                closeOnOutsidePointerDown: !0,
                ignoreAnchorPointerDown: !0,
                onRequestClose: ke,
                dir: ie === "auto" || ie == null ? void 0 : ie,
                matchAnchorWidth: e.matchPopupWidth ?? !0,
                minWidth: e.popupMinWidth ?? "var(--flare-auto-complete-menu-min-width)",
                maxHeight: e.popupMaxHeight ?? "var(--flare-auto-complete-menu-max-height)",
                children: /* @__PURE__ */ n.jsxs(
                  "div",
                  {
                    className: pt["flare-auto-complete-menu"],
                    role: "listbox",
                    id: Pe,
                    dir: ie === "auto" || ie == null ? void 0 : ie,
                    "aria-label": C,
                    "aria-busy": c || void 0,
                    style: ue,
                    children: [
                      xe && h.map((E, l) => {
                        const v = l === b, i = `${Pe}-item-${l}`, m = T(E), U = { active: v, disabled: m }, de = xr(
                          pt["flare-auto-complete-item"],
                          v && pt["is-active"],
                          m && pt["is-disabled"]
                        );
                        return /* @__PURE__ */ n.jsx(
                          "div",
                          {
                            id: i,
                            role: "option",
                            "aria-selected": v,
                            "aria-disabled": m || void 0,
                            className: de,
                            ref: (fe) => {
                              N.current[l] = fe;
                            },
                            onMouseEnter: () => f(l),
                            onMouseDown: (fe) => {
                              fe.preventDefault(), De(E);
                            },
                            children: ve ? ve(E, P, U) : Be(E, U)
                          },
                          i
                        );
                      }),
                      c && /* @__PURE__ */ n.jsx("div", { className: pt["flare-auto-complete-empty"], role: "status", children: je ?? "Loading suggestions..." }),
                      Xe && !c && /* @__PURE__ */ n.jsx("div", { className: pt["flare-auto-complete-empty"], role: "status", children: qe })
                    ]
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
}
const Dt = {
  "flare-amount-range-picker": "_flare-amount-range-picker_bry8u_1",
  "flare-amount-range-picker-clear": "_flare-amount-range-picker-clear_bry8u_44",
  "flare-amount-range-picker-row": "_flare-amount-range-picker-row_bry8u_48",
  "flare-amount-range-picker-field": "_flare-amount-range-picker-field_bry8u_56",
  "flare-amount-range-picker-field-label": "_flare-amount-range-picker-field-label_bry8u_63",
  "flare-amount-range-picker-field-box": "_flare-amount-range-picker-field-box_bry8u_69",
  "is-disabled": "_is-disabled_bry8u_88",
  "flare-amount-range-picker-prefix": "_flare-amount-range-picker-prefix_bry8u_94",
  "flare-amount-range-picker-input": "_flare-amount-range-picker-input_bry8u_100",
  "flare-amount-range-picker-separator": "_flare-amount-range-picker-separator_bry8u_121",
  "flare-amount-range-picker-hint": "_flare-amount-range-picker-hint_bry8u_155"
};
function Qt(...e) {
  return e.filter(Boolean).join(" ");
}
function Br(e) {
  const t = e == null ? void 0 : e.trim();
  if (!t) return null;
  const r = t.replace(/\s+/g, "").replace(/,/g, ".");
  return r.length ? r : null;
}
function fa(e) {
  if (!e) return null;
  const t = Number(e);
  return Number.isFinite(t) ? t : null;
}
function cr(e) {
  const t = Br((e == null ? void 0 : e.from) ?? null), r = Br((e == null ? void 0 : e.to) ?? null);
  return { from: t, to: r };
}
function hn(e) {
  const t = fa(e.from), r = fa(e.to);
  return e.from && e.to && t != null && r != null && t > r ? { from: e.to, to: e.from } : e;
}
function yr(e) {
  return e.from || e.to ? e : null;
}
function gn(e) {
  return !e.from && !e.to;
}
function Ao(e) {
  const t = Rt(), r = Rt(), a = me(null), o = me(null), c = me(null), [s, h] = Ne(() => cr(e.defaultValue)), u = e.value === void 0 ? cr(s) : cr(e.value), b = yr(u);
  pe(() => {
    e.value !== void 0 && h(cr(e.value));
  }, [e.value]);
  const f = R((xe) => {
    var Oe, st, Pe;
    const ue = cr({ ...u, ...xe });
    e.value === void 0 && h(ue);
    const Ve = yr(ue);
    (Oe = c.current) == null || Oe.onChange(Ve), (st = c.current) == null || st.validate(Ve), (Pe = e.onChange) == null || Pe.call(e, ue);
  }, [e, u]), w = (xe) => {
    var Ve, Oe, st;
    const ue = hn(u);
    if (ue.from !== u.from || ue.to !== u.to) {
      e.value === void 0 && h(ue);
      const Pe = yr(ue);
      (Ve = c.current) == null || Ve.onChange(Pe), (Oe = c.current) == null || Oe.validate(Pe), (st = e.onChange) == null || st.call(e, ue);
    }
    Y == null || Y(xe);
  }, x = R(() => {
    var xe;
    return ((xe = c.current) == null ? void 0 : xe.validate(b)) ?? !0;
  }, [b]), k = R(() => b, [b]), N = R(() => {
    var Ve, Oe;
    const xe = cr(e.defaultValue);
    e.value === void 0 && h(xe);
    const ue = yr(xe);
    (Ve = c.current) == null || Ve.onChange(ue), (Oe = c.current) == null || Oe.validate(ue);
  }, [e.defaultValue, e.value]);
  nr(e.name, x, k, N);
  const j = R((xe, ue) => {
    f({ [xe]: Br(ue) });
  }, [f]), F = (xe) => {
    var ue;
    (ue = e.onKeyDown) == null || ue.call(e, xe);
  }, {
    value: B,
    defaultValue: A,
    onChange: P,
    onBlur: Y,
    onFocus: X,
    onKeyDown: oe,
    label: G,
    fromLabel: S,
    toLabel: Z,
    fromPlaceholder: We,
    toPlaceholder: be,
    currencyPrefix: ee,
    clearable: q,
    required: T,
    validationError: L,
    className: ke,
    inputClassName: te,
    fieldClassName: ce,
    hint: we,
    inputMode: Fe,
    step: De,
    name: Ee,
    disabled: Me,
    readOnly: Be,
    customValidation: qe,
    ...Xe
  } = e;
  return /* @__PURE__ */ n.jsx(
    ar,
    {
      label: G,
      refHandle: c,
      required: T,
      validationError: L,
      customValidation: qe,
      children: /* @__PURE__ */ n.jsxs("div", { className: Qt(Dt["flare-amount-range-picker"], ke), children: [
        /* @__PURE__ */ n.jsxs("div", { className: Dt["flare-amount-range-picker-row"], children: [
          /* @__PURE__ */ n.jsxs("label", { className: Qt(Dt["flare-amount-range-picker-field"], ce), children: [
            /* @__PURE__ */ n.jsx("span", { className: Dt["flare-amount-range-picker-field-label"], children: S ?? "From" }),
            /* @__PURE__ */ n.jsxs("span", { className: Qt(Dt["flare-amount-range-picker-field-box"], Me && Dt["is-disabled"]), children: [
              ee && /* @__PURE__ */ n.jsx("span", { className: Dt["flare-amount-range-picker-prefix"], "aria-hidden": "true", children: ee }),
              /* @__PURE__ */ n.jsx(
                "input",
                {
                  ...Xe,
                  id: t,
                  ref: a,
                  className: Qt(Dt["flare-amount-range-picker-input"], te),
                  type: "text",
                  inputMode: Fe ?? "decimal",
                  step: De,
                  dir: "ltr",
                  value: u.from ?? "",
                  placeholder: We ?? "0.00",
                  disabled: Me,
                  readOnly: Be,
                  "aria-label": typeof S == "string" ? S : "From amount",
                  onChange: (xe) => j("from", xe.target.value),
                  onBlur: w,
                  onFocus: X,
                  onKeyDown: F
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ n.jsx("div", { className: Dt["flare-amount-range-picker-separator"], "aria-hidden": "true", children: "—" }),
          /* @__PURE__ */ n.jsxs("label", { className: Qt(Dt["flare-amount-range-picker-field"], ce), children: [
            /* @__PURE__ */ n.jsx("span", { className: Dt["flare-amount-range-picker-field-label"], children: Z ?? "To" }),
            /* @__PURE__ */ n.jsxs("span", { className: Qt(Dt["flare-amount-range-picker-field-box"], Me && Dt["is-disabled"]), children: [
              ee && /* @__PURE__ */ n.jsx("span", { className: Dt["flare-amount-range-picker-prefix"], "aria-hidden": "true", children: ee }),
              /* @__PURE__ */ n.jsx(
                "input",
                {
                  ...Xe,
                  id: r,
                  ref: o,
                  className: Qt(Dt["flare-amount-range-picker-input"], te),
                  type: "text",
                  inputMode: Fe ?? "decimal",
                  step: De,
                  dir: "ltr",
                  value: u.to ?? "",
                  placeholder: be ?? "0.00",
                  disabled: Me,
                  readOnly: Be,
                  "aria-label": typeof Z == "string" ? Z : "To amount",
                  onChange: (xe) => j("to", xe.target.value),
                  onBlur: w,
                  onFocus: X,
                  onKeyDown: F
                }
              )
            ] })
          ] }),
          q && !gn(u) && !Me && !Be && /* @__PURE__ */ n.jsx(
            "button",
            {
              type: "button",
              className: Dt["flare-amount-range-picker-clear"],
              "aria-label": "Clear selected amount range",
              onClick: () => f({ from: null, to: null }),
              children: "×"
            }
          )
        ] }),
        we && /* @__PURE__ */ n.jsx("div", { className: Dt["flare-amount-range-picker-hint"], children: we })
      ] })
    }
  );
}
function bn() {
  var a;
  const e = typeof process < "u" && typeof process.env < "u" && process.env.NODE_ENV === "production", t = typeof import.meta < "u" ? import.meta : void 0, r = !!((a = t == null ? void 0 : t.env) != null && a.PROD);
  return e || r;
}
function vn() {
  var o;
  const e = typeof process < "u" && typeof process.env < "u" ? process.env.FLARE_LOG_ENABLE : void 0, t = typeof import.meta < "u" ? import.meta : void 0, r = (o = t == null ? void 0 : t.env) == null ? void 0 : o.FLARE_LOG_ENABLE, a = e ?? r;
  return a === "true" || a === "1";
}
function _n(e) {
  const t = `${e.getMonth() + 1}`.padStart(2, "0"), r = `${e.getDate()}`.padStart(2, "0"), a = `${e.getFullYear() % 100}`.padStart(2, "0"), o = `${e.getHours()}`.padStart(2, "0"), c = `${e.getMinutes()}`.padStart(2, "0"), s = `${e.getSeconds()}`.padStart(2, "0");
  return `${t}/${r}/${a} ${o}:${c}:${s}`;
}
function wn(e) {
  return e.length > 15 ? e.slice(0, 15) : e.padEnd(15, " ");
}
const ma = { debug: 10, info: 20, warn: 30, error: 40 };
class xn {
  constructor(t, r = "info", a = console, o) {
    this.moduleName = t, this.level = r, this.writer = a, this.production = bn(), this.allowProductionLogging = !!(o != null && o.allowProductionLogging) || vn();
  }
  setLevel(t) {
    this.level = t;
  }
  debug(t, ...r) {
    this.log("debug", t, ...r);
  }
  info(t, ...r) {
    this.log("info", t, ...r);
  }
  warn(t, ...r) {
    this.log("warn", t, ...r);
  }
  error(t, ...r) {
    this.log("error", t, ...r);
  }
  log(t, r, ...a) {
    if (this.production && !this.allowProductionLogging || !this.shouldLog(t))
      return;
    const c = _n(/* @__PURE__ */ new Date()), s = wn(this.moduleName), h = `${c} @${s}: ${r}`;
    switch (t) {
      case "debug":
        this.writer.debug(h, ...a);
        break;
      case "info":
        this.writer.info(h, ...a);
        break;
      case "warn":
        this.writer.warn(h, ...a);
        break;
      case "error":
        this.writer.error(h, ...a);
        break;
      default:
        this.writer.info(h, ...a);
        break;
    }
  }
  shouldLog(t) {
    return ma[t] >= ma[this.level];
  }
}
class Et extends Error {
  constructor(t, r) {
    super(t), this.name = "FlareException", this.thrownError = r, Object.setPrototypeOf(this, Et.prototype);
  }
  toString() {
    return this.collectMessages(this, /* @__PURE__ */ new Set()).join(` 
`);
  }
  collectMessages(t, r) {
    if (t == null)
      return [];
    if (r.has(t))
      return ["[circular reference]"];
    if (r.add(t), t instanceof Et) {
      const a = t.message || "FlareException", o = this.collectMessages(t.thrownError, r);
      return [a, ...o];
    }
    if (t instanceof Error) {
      const a = t.message || t.name || "Error", o = t.cause, c = this.collectMessages(o, r);
      return [a, ...c];
    }
    if (typeof t == "string")
      return [t];
    try {
      return [JSON.stringify(t)];
    } catch {
      return ["[unserializable error]"];
    }
  }
}
const pr = {
  "flare-button": "_flare-button_119e7_1",
  "flare-button-disabled": "_flare-button-disabled_119e7_46",
  "flare-button-primary": "_flare-button-primary_119e7_65",
  "flare-button-secondary": "_flare-button-secondary_119e7_71"
}, yn = new xn("FlareButton");
function Lo(e) {
  const { label: t, onClick: r, variant: a = "primary", disabled: o, className: c, ...s } = e, h = () => {
    if (!o)
      try {
        yn.debug("Button clicked"), r && r();
      } catch (f) {
        throw new Et("Failed to raise onClick event", f);
      }
  }, u = () => {
    try {
      const f = pr["flare-button"], x = pr[`flare-button-${a ?? "primary"}`] ?? pr["flare-button-primary"], k = o ? pr["flare-button-disabled"] : "";
      return [f, x, k, c].filter(Boolean).join(" ");
    } catch (f) {
      throw new Et("Failed to compose FlareButton className", f);
    }
  };
  return (() => {
    try {
      const f = u();
      return /* @__PURE__ */ n.jsx(
        "button",
        {
          className: f,
          onClick: h,
          disabled: o,
          "aria-disabled": o,
          ...s,
          children: t
        }
      );
    } catch (f) {
      throw new Et("Failed to render FlareButton", f);
    }
  })();
}
const At = {
  "flare-check-box": "_flare-check-box_1544q_1",
  "flare-check-box__box": "_flare-check-box__box_1544q_34",
  "flare-check-box__label": "_flare-check-box__label_1544q_77",
  "flare-check-box__required": "_flare-check-box__required_1544q_81",
  "flare-check-box__icon": "_flare-check-box__icon_1544q_86",
  "flare-check-box--checked": "_flare-check-box--checked_1544q_93",
  "flare-check-box--indeterminate": "_flare-check-box--indeterminate_1544q_102",
  "flare-check-box--disabled": "_flare-check-box--disabled_1544q_111",
  "flare-check-box--animating": "_flare-check-box--animating_1544q_116"
};
function Ta(e) {
  const [t, r] = Ne(
    e.checked ?? e.defaultChecked ?? !1
  ), [a, o] = Ne(!1), c = W.useRef(null);
  pe(() => {
    e.checked !== void 0 && r(e.checked);
  }, [e.checked]);
  const s = R(() => e.checked !== void 0 ? e.checked : t, [t, e.checked]), h = R(() => {
    var te;
    return ((te = c.current) == null ? void 0 : te.validate(s())) ?? !0;
  }, [s]), u = R(() => {
    var te, ce;
    e.checked === void 0 && r(!1), (te = c.current) == null || te.onChange(!1), (ce = c.current) == null || ce.validate(!1);
  }, [e.checked]);
  nr(e.name, h, s, u), pe(() => {
    if (!a)
      return;
    const te = window.setTimeout(() => o(!1), 260);
    return () => window.clearTimeout(te);
  }, [a]);
  const b = (te) => {
    var we, Fe, De;
    if (te == null || te.stopPropagation(), e.disabled)
      return;
    o(!0);
    const ce = !t;
    e.checked === void 0 && r(ce), (we = c.current) == null || we.onChange(ce), (Fe = c.current) == null || Fe.validate(ce), (De = e.onChange) == null || De.call(e, ce);
  }, f = (te) => {
    var ce;
    (te.key === " " || te.key === "Enter") && (te.preventDefault(), b(te)), (ce = e.onKeyDown) == null || ce.call(e, te);
  }, w = e.checked ?? t, x = !!e.indeterminate, k = ze(
    () => [
      At["flare-check-box"],
      e.className,
      e.disabled && At["flare-check-box--disabled"],
      w && !x && At["flare-check-box--checked"],
      x && At["flare-check-box--indeterminate"],
      a && At["flare-check-box--animating"]
    ].filter(Boolean).join(" "),
    [a, w, x, e.className, e.disabled]
  ), N = e.role ?? "checkbox", j = e.tabIndex ?? (e.disabled ? -1 : 0), F = e.indeterminate ? "mixed" : w, {
    onChange: B,
    onClick: A,
    onKeyDown: P,
    defaultChecked: Y,
    indeterminate: X,
    checked: oe,
    disabled: G,
    className: S,
    label: Z,
    icon: We,
    required: be,
    validationError: ee,
    refForward: q,
    customValidation: T,
    ...L
  } = e, ke = (te) => {
    b(te), A == null || A(te);
  };
  return Z ? /* @__PURE__ */ n.jsx(
    ar,
    {
      label: Z,
      hideLabel: !0,
      refHandle: c,
      validationError: ee,
      required: be,
      customValidation: T,
      children: /* @__PURE__ */ n.jsxs(
        "div",
        {
          ...L,
          className: k,
          role: N,
          tabIndex: j,
          "aria-checked": F,
          "aria-disabled": G,
          onClick: ke,
          onKeyDown: f,
          children: [
            /* @__PURE__ */ n.jsx("span", { className: At["flare-check-box__box"] }),
            We && /* @__PURE__ */ n.jsx("span", { className: At["flare-check-box__icon"], children: We }),
            Z && /* @__PURE__ */ n.jsxs("span", { className: At["flare-check-box__label"], children: [
              Z,
              be && /* @__PURE__ */ n.jsx("span", { className: At["flare-check-box__required"], children: "*" })
            ] })
          ]
        }
      )
    }
  ) : /* @__PURE__ */ n.jsxs(
    "div",
    {
      ...L,
      className: k,
      role: N,
      tabIndex: j,
      "aria-checked": F,
      "aria-disabled": G,
      onClick: ke,
      onKeyDown: f,
      children: [
        /* @__PURE__ */ n.jsx("span", { className: At["flare-check-box__box"] }),
        We && /* @__PURE__ */ n.jsx("span", { className: At["flare-check-box__icon"], children: We })
      ]
    }
  );
}
const pn = /^\d{4}-\d{2}-\d{2}$/;
function Qr(e) {
  return `${e.getUTCFullYear().toString().padStart(4, "0")}-${(e.getUTCMonth() + 1).toString().padStart(2, "0")}-${e.getUTCDate().toString().padStart(2, "0")}`;
}
function ct(e) {
  if (!e || !pn.test(e)) return null;
  const [t, r, a] = e.split("-").map(Number), o = new Date(Date.UTC(t, r - 1, a));
  return Qr(o) === e ? o : null;
}
function yt(e, t) {
  const r = ct(e);
  return r ? (r.setUTCDate(r.getUTCDate() + t), Qr(r)) : e;
}
function Mt(e, t) {
  const r = ct(e);
  if (!r) return e;
  const a = r.getUTCDate();
  r.setUTCDate(1), r.setUTCMonth(r.getUTCMonth() + t);
  const o = new Date(Date.UTC(r.getUTCFullYear(), r.getUTCMonth() + 1, 0)).getUTCDate();
  return r.setUTCDate(Math.min(a, o)), Qr(r);
}
function Ct(e) {
  const t = ct(e) ?? /* @__PURE__ */ new Date();
  return `${t.getUTCFullYear().toString().padStart(4, "0")}-${(t.getUTCMonth() + 1).toString().padStart(2, "0")}-01`;
}
function qt() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear().toString().padStart(4, "0")}-${(e.getMonth() + 1).toString().padStart(2, "0")}-${e.getDate().toString().padStart(2, "0")}`;
}
function Ma(e) {
  var t;
  try {
    const r = new Intl.Locale(e), a = (t = r.getWeekInfo) == null ? void 0 : t.call(r).firstDay;
    return a === void 0 ? 0 : a % 7;
  } catch {
    return 0;
  }
}
function Zt(e, t) {
  return e.localeCompare(t);
}
function Jt({
  direction: e,
  double: t = !1
}) {
  const r = e === "previous", a = r ? "M14 6l-6 6 6 6" : "M10 6l6 6-6 6", o = r ? "M20 6l-6 6 6 6" : "M4 6l6 6-6 6";
  return /* @__PURE__ */ n.jsxs("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: [
    /* @__PURE__ */ n.jsx("path", { d: a }),
    t ? /* @__PURE__ */ n.jsx("path", { d: o }) : null
  ] });
}
const wt = {
  "flare-date-picker": "_flare-date-picker_bn8g8_1",
  "flare-date-picker-clear": "_flare-date-picker-clear_bn8g8_45",
  "flare-date-picker-field": "_flare-date-picker-field_bn8g8_49",
  "is-disabled": "_is-disabled_bn8g8_68",
  "flare-date-picker-input": "_flare-date-picker-input_bn8g8_75",
  "flare-date-picker-nav": "_flare-date-picker-nav_bn8g8_120",
  "flare-date-picker-day": "_flare-date-picker-day_bn8g8_121",
  "flare-date-picker-popup": "_flare-date-picker-popup_bn8g8_126",
  "flare-date-picker-calendar": "_flare-date-picker-calendar_bn8g8_135",
  "flare-date-picker-header": "_flare-date-picker-header_bn8g8_139",
  "flare-date-picker-month": "_flare-date-picker-month_bn8g8_147",
  "flare-date-picker-weekdays": "_flare-date-picker-weekdays_bn8g8_189",
  "flare-date-picker-grid": "_flare-date-picker-grid_bn8g8_190",
  "flare-date-picker-weekday": "_flare-date-picker-weekday_bn8g8_189",
  "is-focused": "_is-focused_bn8g8_219",
  "is-today": "_is-today_bn8g8_223",
  "is-selected": "_is-selected_bn8g8_227",
  "is-outside": "_is-outside_bn8g8_237"
};
function kr(...e) {
  return e.filter(Boolean).join(" ");
}
function $o(e) {
  const { languageTag: t, messages: r } = fr(), a = Rt(), o = Rt(), c = me(null), s = me(null), h = me(null), u = me(null), [b, f] = Ne(e.defaultValue ?? null), [w, x] = Ne(!1), [k, N] = Ne(() => Ct(e.value ?? e.defaultValue ?? qt())), [j, F] = Ne(() => e.value ?? e.defaultValue ?? qt()), B = e.locale ?? t, A = e.value === void 0 ? b : e.value, P = e.firstDayOfWeek ?? Ma(B);
  pe(() => {
    e.value !== void 0 && f(e.value);
  }, [e.value]);
  const Y = ze(() => new Intl.DateTimeFormat(B, { dateStyle: "medium", timeZone: "UTC" }), [B]), X = ze(() => new Intl.DateTimeFormat(B, { month: "long", year: "numeric", timeZone: "UTC" }), [B]), oe = ze(() => new Intl.DateTimeFormat(B, { weekday: "short", timeZone: "UTC" }), [B]), G = A && ct(A) ? Y.format(ct(A)) : "";
  ct(A);
  const S = R((C) => {
    var J, ve;
    return !ct(C) || e.min && C < e.min || e.max && C > e.max || (J = e.disabledDates) != null && J.includes(C) ? !0 : ((ve = e.isDateDisabled) == null ? void 0 : ve.call(e, C)) ?? !1;
  }, [e.disabledDates, e.isDateDisabled, e.max, e.min]), Z = R((C) => {
    var J, ve, Te;
    e.value === void 0 && f(C), (J = u.current) == null || J.onChange(C), (ve = u.current) == null || ve.validate(C), (Te = e.onChange) == null || Te.call(e, C);
  }, [e]), We = R(() => {
    var C;
    return ((C = u.current) == null ? void 0 : C.validate(A)) ?? !0;
  }, [A]), be = R(() => A, [A]), ee = R(() => {
    var J, ve;
    e.value === void 0 && f(e.defaultValue ?? null);
    const C = e.defaultValue ?? null;
    (J = u.current) == null || J.onChange(C), (ve = u.current) == null || ve.validate(C);
  }, [e.defaultValue, e.value]);
  nr(e.name, We, be, ee);
  const q = R((C) => {
    var J;
    x(C), (J = e.onOpenChange) == null || J.call(e, C);
  }, [e]), T = R(() => {
    var C;
    (C = h.current) == null || C.close(), q(!1);
  }, [q]), L = R(() => {
    if (e.disabled || e.readOnly || !c.current) return;
    const C = A && ct(A) ? A : qt();
    N(Ct(C)), F(C), q(!0);
  }, [e.disabled, e.readOnly, q, A]);
  pe(() => {
    var C;
    !w || !c.current || (C = h.current) == null || C.open({
      anchor: c.current,
      placement: e.popupPlacement ?? "bottom",
      align: e.popupAlign ?? "start",
      offset: e.popupOffset ?? 4,
      matchAnchorWidth: !0
    });
  }, [w, e.popupAlign, e.popupOffset, e.popupPlacement]), pe(() => {
    if (!w) return;
    const C = window.setTimeout(() => {
      var J;
      (J = document.querySelector(`[data-flare-date-picker-day="${j}"]`)) == null || J.focus();
    }, 0);
    return () => window.clearTimeout(C);
  }, [j, w, k]);
  const ke = R((C) => {
    var J;
    S(C) || (Z(C), F(C), N(Ct(C)), T(), (J = s.current) == null || J.focus());
  }, [T, S, Z]), te = R((C) => {
    F(C), N(Ct(C));
  }, []), ce = R((C, J) => {
    let ve = C;
    for (let Te = 0; Te < 366; Te += 1) {
      if (!S(ve)) return ve;
      ve = yt(ve, J);
    }
    return C;
  }, [S]), we = (C) => {
    var ve, Te, Ae;
    let J = null;
    if (C.key === "ArrowLeft" && (J = yt(j, -1)), C.key === "ArrowRight" && (J = yt(j, 1)), C.key === "ArrowUp" && (J = yt(j, -7)), C.key === "ArrowDown" && (J = yt(j, 7)), C.key === "PageUp" && (J = Mt(j, C.shiftKey ? -12 : -1)), C.key === "PageDown" && (J = Mt(j, C.shiftKey ? 12 : 1)), C.key === "Home" && (J = yt(j, -((((ve = ct(j)) == null ? void 0 : ve.getUTCDay()) ?? 0) - P + 7) % 7)), C.key === "End" && (J = yt(j, 6 - ((((Te = ct(j)) == null ? void 0 : Te.getUTCDay()) ?? 0) - P + 7) % 7)), J) {
      C.preventDefault(), te(ce(J, J >= j ? 1 : -1));
      return;
    }
    if (C.key === "Enter" || C.key === " ") {
      C.preventDefault(), ke(j);
      return;
    }
    C.key === "Escape" && (C.preventDefault(), T(), (Ae = s.current) == null || Ae.focus());
  }, Fe = (C) => {
    var J;
    (J = e.onKeyDown) == null || J.call(e, C), !C.defaultPrevented && ((C.key === "ArrowDown" || C.key === "Enter" || C.key === " ") && (C.preventDefault(), L()), C.key === "Escape" && w && (C.preventDefault(), T()));
  }, De = ze(() => {
    const J = (ct(k).getUTCDay() - P + 7) % 7, ve = yt(k, -J);
    return Array.from({ length: 42 }, (Te, Ae) => yt(ve, Ae));
  }, [P, k]), Ee = ze(() => Array.from({ length: 7 }, (C, J) => new Date(Date.UTC(2024, 0, 7 + (P + J) % 7))), [P]), Me = ct(k).getUTCMonth(), Be = Mt(k, -1), qe = Mt(k, 1), Xe = Mt(k, -12), xe = Mt(k, 12), ue = !e.min || Be >= Ct(e.min), Ve = !e.max || qe <= Ct(e.max), Oe = !e.min || Xe >= Ct(e.min), st = !e.max || xe <= Ct(e.max), {
    value: Pe,
    defaultValue: dt,
    onChange: ut,
    onBlur: Q,
    onFocus: se,
    onKeyDown: re,
    onClick: p,
    label: z,
    placeholder: V,
    locale: le,
    firstDayOfWeek: he,
    min: ie,
    max: rt,
    disabledDates: He,
    isDateDisabled: ae,
    clearable: ye,
    required: Ke,
    validationError: $e,
    className: Ue,
    inputClassName: xt,
    popupPlacement: nt,
    popupAlign: Ye,
    popupOffset: mt,
    onOpenChange: gt,
    disabled: ft,
    readOnly: $,
    ...K
  } = e, je = e.customValidation;
  return /* @__PURE__ */ n.jsx(
    ar,
    {
      label: z,
      refHandle: u,
      validationError: $e,
      required: Ke,
      customValidation: je ? (C) => {
        if (Array.isArray(je))
          for (const J of je) {
            const ve = J(C);
            if (ve) return ve;
          }
        else {
          const J = je(C);
          if (J) return J;
        }
        return null;
      } : void 0,
      children: /* @__PURE__ */ n.jsxs("div", { className: kr(wt["flare-date-picker"], Ue), ref: c, children: [
        /* @__PURE__ */ n.jsxs("div", { className: kr(wt["flare-date-picker-field"], ft && wt["is-disabled"]), children: [
          /* @__PURE__ */ n.jsx(
            "input",
            {
              ...K,
              ref: s,
              id: e.id ?? a,
              className: kr(wt["flare-date-picker-input"], xt),
              value: G,
              placeholder: V ?? r.datePicker.selectDate,
              disabled: ft,
              readOnly: !0,
              role: "combobox",
              "aria-autocomplete": "none",
              "aria-controls": o,
              "aria-expanded": w,
              "aria-haspopup": "dialog",
              "aria-required": Ke || void 0,
              onClick: (C) => {
                p == null || p(C), L();
              },
              onFocus: se,
              onBlur: Q,
              onKeyDown: Fe
            }
          ),
          ye && A && !ft && !$ && /* @__PURE__ */ n.jsx(
            "button",
            {
              type: "button",
              className: wt["flare-date-picker-clear"],
              "aria-label": r.datePicker.clearDate,
              onClick: () => Z(null),
              children: "×"
            }
          )
        ] }),
        /* @__PURE__ */ n.jsx(
          Rr,
          {
            ref: h,
            className: wt["flare-date-picker-popup"],
            closeOnEscape: !0,
            closeOnOutsidePointerDown: !0,
            ignoreAnchorPointerDown: !0,
            restoreFocus: !1,
            onRequestClose: () => {
              q(!1);
            },
            children: /* @__PURE__ */ n.jsxs("div", { className: wt["flare-date-picker-calendar"], id: o, role: "dialog", "aria-label": r.datePicker.chooseDate, children: [
              /* @__PURE__ */ n.jsxs("div", { className: wt["flare-date-picker-header"], children: [
                /* @__PURE__ */ n.jsx("button", { type: "button", className: wt["flare-date-picker-nav"], "aria-label": r.datePicker.previousYear, disabled: !Oe, onClick: () => N(Xe), children: /* @__PURE__ */ n.jsx(Jt, { direction: "previous", double: !0 }) }),
                /* @__PURE__ */ n.jsx("button", { type: "button", className: wt["flare-date-picker-nav"], "aria-label": r.datePicker.previousMonth, disabled: !ue, onClick: () => N(Be), children: /* @__PURE__ */ n.jsx(Jt, { direction: "previous" }) }),
                /* @__PURE__ */ n.jsx("div", { className: wt["flare-date-picker-month"], "aria-live": "polite", children: X.format(ct(k)) }),
                /* @__PURE__ */ n.jsx("button", { type: "button", className: wt["flare-date-picker-nav"], "aria-label": r.datePicker.nextMonth, disabled: !Ve, onClick: () => N(qe), children: /* @__PURE__ */ n.jsx(Jt, { direction: "next" }) }),
                /* @__PURE__ */ n.jsx("button", { type: "button", className: wt["flare-date-picker-nav"], "aria-label": r.datePicker.nextYear, disabled: !st, onClick: () => N(xe), children: /* @__PURE__ */ n.jsx(Jt, { direction: "next", double: !0 }) })
              ] }),
              /* @__PURE__ */ n.jsx("div", { className: wt["flare-date-picker-weekdays"], "aria-hidden": "true", children: Ee.map((C) => /* @__PURE__ */ n.jsx("span", { className: wt["flare-date-picker-weekday"], children: oe.format(C) }, C.toISOString())) }),
              /* @__PURE__ */ n.jsx("div", { className: wt["flare-date-picker-grid"], role: "grid", "aria-label": X.format(ct(k)), children: De.map((C) => {
                const J = ct(C), ve = J.getUTCMonth() !== Me, Te = S(C), Ae = C === A, vt = C === j;
                return /* @__PURE__ */ n.jsx(
                  "button",
                  {
                    type: "button",
                    "data-flare-date-picker-day": C,
                    className: kr(wt["flare-date-picker-day"], ve && wt["is-outside"], Ae && wt["is-selected"], C === qt() && wt["is-today"], vt && wt["is-focused"]),
                    role: "gridcell",
                    "aria-label": Y.format(J),
                    "aria-selected": Ae,
                    disabled: Te,
                    tabIndex: vt ? 0 : -1,
                    onClick: () => ke(C),
                    onKeyDown: we,
                    children: J.getUTCDate()
                  },
                  C
                );
              }) })
            ] })
          }
        )
      ] })
    }
  );
}
const tt = {
  "flare-date-range-picker": "_flare-date-range-picker_anac9_1",
  "flare-date-range-picker-clear": "_flare-date-range-picker-clear_anac9_49",
  "flare-date-range-picker-field": "_flare-date-range-picker-field_anac9_53",
  "is-disabled": "_is-disabled_anac9_72",
  "flare-date-range-picker-input": "_flare-date-range-picker-input_anac9_79",
  "flare-date-range-picker-nav": "_flare-date-range-picker-nav_anac9_124",
  "flare-date-range-picker-day": "_flare-date-range-picker-day_anac9_125",
  "flare-date-range-picker-popup": "_flare-date-range-picker-popup_anac9_130",
  "flare-date-range-picker-calendar": "_flare-date-range-picker-calendar_anac9_139",
  "flare-date-range-picker-quick-actions": "_flare-date-range-picker-quick-actions_anac9_143",
  "flare-date-range-picker-quick-actions-title": "_flare-date-range-picker-quick-actions-title_anac9_149",
  "flare-date-range-picker-quick-actions-grid": "_flare-date-range-picker-quick-actions-grid_anac9_158",
  "flare-date-range-picker-quick-action": "_flare-date-range-picker-quick-action_anac9_143",
  "flare-date-range-picker-quick-action-label": "_flare-date-range-picker-quick-action-label_anac9_189",
  "flare-date-range-picker-quick-action-meta": "_flare-date-range-picker-quick-action-meta_anac9_194",
  "flare-date-range-picker-header": "_flare-date-range-picker-header_anac9_199",
  "flare-date-range-picker-month": "_flare-date-range-picker-month_anac9_207",
  "flare-date-range-picker-weekdays": "_flare-date-range-picker-weekdays_anac9_249",
  "flare-date-range-picker-grid": "_flare-date-range-picker-grid_anac9_250",
  "flare-date-range-picker-weekday": "_flare-date-range-picker-weekday_anac9_249",
  "is-focused": "_is-focused_anac9_279",
  "is-today": "_is-today_anac9_283",
  "is-in-range": "_is-in-range_anac9_287",
  "is-selected": "_is-selected_anac9_297",
  "is-outside": "_is-outside_anac9_307",
  "flare-date-range-picker-hint": "_flare-date-range-picker-hint_anac9_317"
};
function Cr(...e) {
  return e.filter(Boolean).join(" ");
}
function kn() {
  return { from: null, to: null };
}
function Yt(e) {
  const t = ct((e == null ? void 0 : e.from) ?? null) ? (e == null ? void 0 : e.from) ?? null : null, r = ct((e == null ? void 0 : e.to) ?? null) ? (e == null ? void 0 : e.to) ?? null : null;
  return !t || !r ? { from: t, to: r } : Zt(t, r) <= 0 ? { from: t, to: r } : { from: r, to: t };
}
function Cn(e, t) {
  const r = ct(e.from), a = ct(e.to);
  return !r && !a ? "" : r && a ? `${t.format(r)} — ${t.format(a)}` : r ? `${t.format(r)} — …` : `… — ${t.format(a)}`;
}
function Sn(e, t, r) {
  if (!e || !t) return !1;
  const a = Zt(e, t) <= 0 ? e : t, o = a === e ? t : e;
  return Zt(r, a) >= 0 && Zt(r, o) <= 0;
}
function Ir(e) {
  return e.to ?? e.from ?? qt();
}
function jn(e) {
  const t = qt();
  return { from: yt(t, -(e - 1)), to: t };
}
function Nn(e, t) {
  if (!e.from || !e.to) return !1;
  const r = Zt(e.from, e.to) <= 0 ? e.from : e.to, a = r === e.from ? e.to : e.from;
  if (t(r) || t(a)) return !1;
  let o = r;
  for (let c = 0; c < 366; c += 1) {
    if (Zt(o, a) > 0) return !0;
    o = yt(o, 1);
  }
  return !1;
}
function Dn(e) {
  return e.toLowerCase().startsWith("he") ? {
    title: "טווחים מהירים",
    dayUnit: "ימים",
    presets: {
      last7Days: "7 הימים האחרונים",
      last30Days: "30 הימים האחרונים",
      last90Days: "90 הימים האחרונים",
      last365Days: "365 הימים האחרונים"
    }
  } : {
    title: "Quick ranges",
    dayUnit: "days",
    presets: {
      last7Days: "Last 7 days",
      last30Days: "Last 30 days",
      last90Days: "Last 90 days",
      last365Days: "Last 365 days"
    }
  };
}
function Wo(e) {
  const { languageTag: t, messages: r } = fr(), a = Rt(), o = Rt(), c = me(null), s = me(null), h = me(null), u = me(null), [b, f] = Ne(() => Yt(e.defaultValue)), [w, x] = Ne(!1), [k, N] = Ne(() => Ct(Ir(Yt(e.value ?? e.defaultValue)))), [j, F] = Ne(() => Ir(Yt(e.value ?? e.defaultValue))), [B, A] = Ne(null), [P, Y] = Ne(null), [X, oe] = Ne(null), G = e.locale ?? t, S = e.value === void 0 ? Yt(b) : Yt(e.value), Z = e.firstDayOfWeek ?? Ma(G);
  pe(() => {
    e.value !== void 0 && f(Yt(e.value));
  }, [e.value]);
  const We = ze(() => new Intl.DateTimeFormat(G, { dateStyle: "medium", timeZone: "UTC" }), [G]), be = ze(() => new Intl.DateTimeFormat(G, { month: "long", year: "numeric", timeZone: "UTC" }), [G]), ee = ze(() => new Intl.DateTimeFormat(G, { weekday: "short", timeZone: "UTC" }), [G]), q = ze(() => Dn(G), [G]), T = R((i) => {
    var m, U;
    return !ct(i) || e.min && i < e.min || e.max && i > e.max || (m = e.disabledDates) != null && m.includes(i) ? !0 : ((U = e.isDateDisabled) == null ? void 0 : U.call(e, i)) ?? !1;
  }, [e.disabledDates, e.isDateDisabled, e.max, e.min]), L = ze(() => [
    { key: "last7Days", days: 7, label: q.presets.last7Days },
    { key: "last30Days", days: 30, label: q.presets.last30Days },
    { key: "last90Days", days: 90, label: q.presets.last90Days },
    { key: "last365Days", days: 365, label: q.presets.last365Days }
  ].map((i) => {
    const m = jn(i.days);
    return {
      ...i,
      range: m,
      disabled: !Nn(m, T),
      meta: `${i.days} ${q.dayUnit}`
    };
  }), [T, q]), ke = ze(() => {
    var i;
    return ((i = L.find((m) => m.key === X)) == null ? void 0 : i.label) ?? null;
  }, [L, X]), te = Cn(S, We), ce = e.rangeLabelMode === "dates" ? te : ke ?? te, we = R((i) => {
    var U, de, fe;
    const m = Yt(i);
    e.value === void 0 && f(m), (U = u.current) == null || U.onChange(m), (de = u.current) == null || de.validate(m), (fe = e.onChange) == null || fe.call(e, m);
  }, [e]), Fe = R(() => {
    var i;
    return ((i = u.current) == null ? void 0 : i.validate(S)) ?? !0;
  }, [S]), De = R(() => S, [S]), Ee = R(() => {
    var m, U;
    const i = Yt(e.defaultValue);
    e.value === void 0 && f(i), (m = u.current) == null || m.onChange(i), (U = u.current) == null || U.validate(i), A(i.from && !i.to ? i.from : null), Y(null), oe(null);
  }, [e.defaultValue, e.value]);
  nr(e.name, Fe, De, Ee);
  const Me = R((i) => {
    var m;
    x(i), (m = e.onOpenChange) == null || m.call(e, i);
  }, [e]), Be = R(() => {
    var i;
    (i = h.current) == null || i.close(), Me(!1);
  }, [Me]), qe = R(() => {
    if (e.disabled || e.readOnly || !c.current) return;
    const i = Ir(S);
    oe(null), A(S.from && !S.to ? S.from : null), Y(null), N(Ct(i)), F(i), Me(!0);
  }, [e.disabled, e.readOnly, Me, S]);
  pe(() => {
    var i;
    !w || !c.current || (i = h.current) == null || i.open({
      anchor: c.current,
      placement: e.popupPlacement ?? "bottom",
      align: e.popupAlign ?? "start",
      offset: e.popupOffset ?? 4,
      matchAnchorWidth: !0
    });
  }, [w, e.popupAlign, e.popupOffset, e.popupPlacement]), pe(() => {
    if (!w) return;
    const i = window.setTimeout(() => {
      var m;
      (m = document.querySelector(`[data-flare-date-range-picker-day="${j}"]`)) == null || m.focus();
    }, 0);
    return () => window.clearTimeout(i);
  }, [j, w, k]);
  const Xe = R((i) => {
    F(i), N(Ct(i));
  }, []), xe = R((i, m) => {
    let U = i;
    for (let de = 0; de < 366; de += 1) {
      if (!T(U)) return U;
      U = yt(U, m);
    }
    return i;
  }, [T]), ue = R((i, m) => {
    var de, fe;
    const U = Zt(i, m) <= 0 ? { from: i, to: m } : { from: m, to: i };
    we(U), A(null), Y(null), (e.closeOnSelection ?? !0) && (Be(), (de = s.current) == null || de.focus()), (fe = e.onRangeComplete) == null || fe.call(e, U);
  }, [Be, e, we]), Ve = R((i) => {
    if (!T(i)) {
      if (!B) {
        oe(null), A(i), Y(null), we({ from: i, to: null }), F(i), N(Ct(i));
        return;
      }
      ue(B, i), F(i), N(Ct(i));
    }
  }, [ue, T, B, we]), Oe = (i) => {
    var U, de, fe;
    let m = null;
    if (i.key === "ArrowLeft" && (m = yt(j, -1)), i.key === "ArrowRight" && (m = yt(j, 1)), i.key === "ArrowUp" && (m = yt(j, -7)), i.key === "ArrowDown" && (m = yt(j, 7)), i.key === "PageUp" && (m = Mt(j, i.shiftKey ? -12 : -1)), i.key === "PageDown" && (m = Mt(j, i.shiftKey ? 12 : 1)), i.key === "Home" && (m = yt(j, -((((U = ct(j)) == null ? void 0 : U.getUTCDay()) ?? 0) - Z + 7) % 7)), i.key === "End" && (m = yt(j, 6 - ((((de = ct(j)) == null ? void 0 : de.getUTCDay()) ?? 0) - Z + 7) % 7)), m) {
      i.preventDefault(), Xe(xe(m, Zt(m, j) >= 0 ? 1 : -1));
      return;
    }
    if (i.key === "Enter" || i.key === " ") {
      i.preventDefault(), Ve(j);
      return;
    }
    i.key === "Escape" && (i.preventDefault(), Be(), (fe = s.current) == null || fe.focus());
  }, st = (i) => {
    var m;
    (m = e.onKeyDown) == null || m.call(e, i), !i.defaultPrevented && ((i.key === "ArrowDown" || i.key === "Enter" || i.key === " ") && (i.preventDefault(), qe()), i.key === "Escape" && w && (i.preventDefault(), Be()));
  }, Pe = ze(() => {
    const m = (ct(k).getUTCDay() - Z + 7) % 7, U = yt(k, -m);
    return Array.from({ length: 42 }, (de, fe) => yt(U, fe));
  }, [Z, k]), dt = ze(() => Array.from({ length: 7 }, (i, m) => new Date(Date.UTC(2024, 0, 7 + (Z + m) % 7))), [Z]), ut = ct(k).getUTCMonth(), Q = Mt(k, -1), se = Mt(k, 1), re = Mt(k, -12), p = Mt(k, 12), z = !e.min || Q >= Ct(e.min), V = !e.max || se <= Ct(e.max), le = !e.min || re >= Ct(e.min), he = !e.max || p <= Ct(e.max), ie = S.from, rt = S.to, He = B ?? ie, ae = B ? P ?? j : rt;
  pe(() => {
    if (!X) return;
    const i = L.find((m) => m.key === X);
    (!i || i.range.from !== S.from || i.range.to !== S.to) && oe(null);
  }, [L, X, S.from, S.to]);
  const ye = R((i, m) => {
    var U, de;
    we(m), oe(i), A(null), Y(null), F(m.to ?? m.from ?? qt()), N(Ct(m.to ?? m.from ?? qt())), (e.closeOnSelection ?? !0) && (Be(), (U = s.current) == null || U.focus()), (de = e.onRangeComplete) == null || de.call(e, { from: m.from, to: m.to });
  }, [Be, e, we]), {
    value: Ke,
    defaultValue: $e,
    onChange: Ue,
    onRangeComplete: xt,
    onBlur: nt,
    onFocus: Ye,
    onKeyDown: mt,
    onClick: gt,
    label: ft,
    placeholder: $,
    locale: K,
    firstDayOfWeek: je,
    min: C,
    max: J,
    disabledDates: ve,
    isDateDisabled: Te,
    clearable: Ae,
    closeOnSelection: vt,
    rangeLabelMode: _t,
    required: g,
    validationError: H,
    className: D,
    inputClassName: I,
    popupPlacement: Ce,
    popupAlign: Le,
    popupOffset: Je,
    onOpenChange: Ge,
    disabled: Ze,
    readOnly: E,
    ...l
  } = e, v = e.customValidation;
  return /* @__PURE__ */ n.jsx(
    ar,
    {
      label: ft,
      refHandle: u,
      validationError: H,
      required: g,
      customValidation: v ? (i) => {
        if (Array.isArray(v))
          for (const m of v) {
            const U = m(i);
            if (U) return U;
          }
        else {
          const m = v(i);
          if (m) return m;
        }
        return null;
      } : void 0,
      children: /* @__PURE__ */ n.jsxs("div", { className: Cr(tt["flare-date-range-picker"], D), ref: c, children: [
        /* @__PURE__ */ n.jsxs("div", { className: Cr(tt["flare-date-range-picker-field"], Ze && tt["is-disabled"]), children: [
          /* @__PURE__ */ n.jsx(
            "input",
            {
              ...l,
              ref: s,
              id: e.id ?? a,
              className: Cr(tt["flare-date-range-picker-input"], I),
              value: ce,
              placeholder: $ ?? r.datePicker.selectDateRange,
              disabled: Ze,
              readOnly: !0,
              role: "combobox",
              "aria-autocomplete": "none",
              "aria-controls": o,
              "aria-expanded": w,
              "aria-haspopup": "dialog",
              "aria-required": g || void 0,
              onClick: (i) => {
                gt == null || gt(i), qe();
              },
              onFocus: Ye,
              onBlur: nt,
              onKeyDown: st
            }
          ),
          Ae && (S.from || S.to) && !Ze && !E && /* @__PURE__ */ n.jsx(
            "button",
            {
              type: "button",
              className: tt["flare-date-range-picker-clear"],
              "aria-label": r.datePicker.clearDateRange,
              onClick: () => {
                we(kn()), A(null), Y(null);
              },
              children: "×"
            }
          )
        ] }),
        /* @__PURE__ */ n.jsx(
          Rr,
          {
            ref: h,
            className: tt["flare-date-range-picker-popup"],
            closeOnEscape: !0,
            closeOnOutsidePointerDown: !0,
            ignoreAnchorPointerDown: !0,
            restoreFocus: !1,
            onRequestClose: () => {
              Me(!1);
            },
            children: /* @__PURE__ */ n.jsxs("div", { className: tt["flare-date-range-picker-calendar"], id: o, role: "dialog", "aria-label": r.datePicker.chooseDateRange, children: [
              /* @__PURE__ */ n.jsxs("div", { className: tt["flare-date-range-picker-quick-actions"], "aria-label": "Quick date range presets", children: [
                /* @__PURE__ */ n.jsx("div", { className: tt["flare-date-range-picker-quick-actions-title"], children: q.title }),
                /* @__PURE__ */ n.jsx("div", { className: tt["flare-date-range-picker-quick-actions-grid"], children: L.map((i) => /* @__PURE__ */ n.jsxs(
                  "button",
                  {
                    type: "button",
                    className: tt["flare-date-range-picker-quick-action"],
                    disabled: i.disabled,
                    onClick: () => ye(i.key, i.range),
                    children: [
                      /* @__PURE__ */ n.jsx("span", { className: tt["flare-date-range-picker-quick-action-label"], children: i.label }),
                      /* @__PURE__ */ n.jsx("span", { className: tt["flare-date-range-picker-quick-action-meta"], children: i.meta })
                    ]
                  },
                  i.label
                )) })
              ] }),
              /* @__PURE__ */ n.jsxs("div", { className: tt["flare-date-range-picker-header"], children: [
                /* @__PURE__ */ n.jsx("button", { type: "button", className: tt["flare-date-range-picker-nav"], "aria-label": r.datePicker.previousYear, disabled: !le, onClick: () => N(re), children: /* @__PURE__ */ n.jsx(Jt, { direction: "previous", double: !0 }) }),
                /* @__PURE__ */ n.jsx("button", { type: "button", className: tt["flare-date-range-picker-nav"], "aria-label": r.datePicker.previousMonth, disabled: !z, onClick: () => N(Q), children: /* @__PURE__ */ n.jsx(Jt, { direction: "previous" }) }),
                /* @__PURE__ */ n.jsx("div", { className: tt["flare-date-range-picker-month"], "aria-live": "polite", children: be.format(ct(k)) }),
                /* @__PURE__ */ n.jsx("button", { type: "button", className: tt["flare-date-range-picker-nav"], "aria-label": r.datePicker.nextMonth, disabled: !V, onClick: () => N(se), children: /* @__PURE__ */ n.jsx(Jt, { direction: "next" }) }),
                /* @__PURE__ */ n.jsx("button", { type: "button", className: tt["flare-date-range-picker-nav"], "aria-label": r.datePicker.nextYear, disabled: !he, onClick: () => N(p), children: /* @__PURE__ */ n.jsx(Jt, { direction: "next", double: !0 }) })
              ] }),
              /* @__PURE__ */ n.jsx("div", { className: tt["flare-date-range-picker-weekdays"], "aria-hidden": "true", children: dt.map((i) => /* @__PURE__ */ n.jsx("span", { className: tt["flare-date-range-picker-weekday"], children: ee.format(i) }, i.toISOString())) }),
              /* @__PURE__ */ n.jsx("div", { className: tt["flare-date-range-picker-grid"], role: "grid", "aria-label": be.format(ct(k)), children: Pe.map((i) => {
                const m = ct(i), U = m.getUTCMonth() !== ut, de = T(i), fe = i === He, Re = i === rt, bt = fe || Re, Qe = !!(fe && Re), ot = Sn(He, ae, i) && !Qe, St = i === j;
                return /* @__PURE__ */ n.jsx(
                  "button",
                  {
                    type: "button",
                    "data-flare-date-range-picker-day": i,
                    className: Cr(
                      tt["flare-date-range-picker-day"],
                      U && tt["is-outside"],
                      ot && tt["is-in-range"],
                      bt && tt["is-selected"],
                      i === qt() && tt["is-today"],
                      St && tt["is-focused"]
                    ),
                    role: "gridcell",
                    "aria-label": We.format(m),
                    "aria-selected": bt || ot,
                    disabled: de,
                    tabIndex: St ? 0 : -1,
                    onClick: () => Ve(i),
                    onMouseEnter: () => {
                      B && Y(i);
                    },
                    onKeyDown: Oe,
                    children: m.getUTCDate()
                  },
                  i
                );
              }) }),
              /* @__PURE__ */ n.jsx("small", { className: tt["flare-date-range-picker-hint"], children: B ? "Select an end date to complete the range." : "Select a start date, then an end date." })
            ] })
          }
        )
      ] })
    }
  );
}
const lt = {
  "flare-drop-down-list": "_flare-drop-down-list_1ttvi_1",
  "flare-drop-down-list__selection": "_flare-drop-down-list__selection_1ttvi_79",
  "flare-drop-down-list__selection--open": "_flare-drop-down-list__selection--open_1ttvi_104",
  "flare-drop-down-list__selection-icon": "_flare-drop-down-list__selection-icon_1ttvi_109",
  "flare-drop-down-list__selection-value": "_flare-drop-down-list__selection-value_1ttvi_116",
  "flare-drop-down-list__selection-value-icon": "_flare-drop-down-list__selection-value-icon_1ttvi_124",
  "flare-drop-down-list__selection-text": "_flare-drop-down-list__selection-text_1ttvi_129",
  "flare-drop-down-list__selection-text--placeholder": "_flare-drop-down-list__selection-text--placeholder_1ttvi_138",
  "flare-drop-down-list__search": "_flare-drop-down-list__search_1ttvi_142",
  "flare-drop-down-list__clear": "_flare-drop-down-list__clear_1ttvi_158",
  "flare-drop-down-list__caret": "_flare-drop-down-list__caret_1ttvi_168",
  "flare-drop-down-list__caret--open": "_flare-drop-down-list__caret--open_1ttvi_177",
  "flare-drop-down-list__popup": "_flare-drop-down-list__popup_1ttvi_181",
  "flare-drop-down-list__menu": "_flare-drop-down-list__menu_1ttvi_197",
  "flare-drop-down-list__bulk-actions": "_flare-drop-down-list__bulk-actions_1ttvi_208",
  "flare-drop-down-list__bulk-action": "_flare-drop-down-list__bulk-action_1ttvi_208",
  "flare-drop-down-list__options": "_flare-drop-down-list__options_1ttvi_244",
  "flare-drop-down-list__item": "_flare-drop-down-list__item_1ttvi_254",
  "flare-drop-down-list__item--highlighted": "_flare-drop-down-list__item--highlighted_1ttvi_270",
  "flare-drop-down-list__item--selected": "_flare-drop-down-list__item--selected_1ttvi_275",
  "flare-drop-down-list__item--disabled": "_flare-drop-down-list__item--disabled_1ttvi_280",
  "flare-drop-down-list__item-icon": "_flare-drop-down-list__item-icon_1ttvi_285",
  "flare-drop-down-list__item-label": "_flare-drop-down-list__item-label_1ttvi_292",
  "flare-drop-down-list__empty": "_flare-drop-down-list__empty_1ttvi_298",
  "flare-drop-down-list--disabled": "_flare-drop-down-list--disabled_1ttvi_312",
  "flare-drop-down-list--rtl": "_flare-drop-down-list--rtl_1ttvi_320"
}, qr = {
  "flare-card": "_flare-card_ao6t8_1",
  "flare-card--compact": "_flare-card--compact_ao6t8_20",
  "flare-card--outline": "_flare-card--outline_ao6t8_24"
};
function Vo({ className: e, children: t, padding: r, style: a, type: o = "default", ...c }) {
  const s = En(o), h = [qr["flare-card"], s, e].filter(Boolean).join(" "), u = r !== void 0 ? { ...a, "--flare-card-padding": zn(r) } : a;
  return /* @__PURE__ */ n.jsx("div", { className: h, style: u, ...c, children: t });
}
function En(e) {
  switch (e) {
    case "compact":
      return qr["flare-card--compact"];
    case "outline":
      return qr["flare-card--outline"];
    default:
      return;
  }
}
function zn(e) {
  if (e != null)
    return typeof e == "number" ? `${e}px` : e;
}
const Pt = {
  "flare-layout": "_flare-layout_r74jj_1",
  "flare-layout-header": "_flare-layout-header_r74jj_28",
  "flare-layout-subheader": "_flare-layout-subheader_r74jj_29",
  "flare-layout-footer": "_flare-layout-footer_r74jj_30",
  "flare-layout-body": "_flare-layout-body_r74jj_35",
  "is-grid": "_is-grid_r74jj_43",
  "is-sidebar-hidden": "_is-sidebar-hidden_r74jj_48",
  "is-stack": "_is-stack_r74jj_52",
  "is-horizontal": "_is-horizontal_r74jj_56",
  "is-vertical": "_is-vertical_r74jj_60",
  "flare-layout-sidebar": "_flare-layout-sidebar_r74jj_76",
  "flare-layout-main": "_flare-layout-main_r74jj_84",
  "flare-layout-content": "_flare-layout-content_r74jj_92",
  "flare-layout-sticky-top": "_flare-layout-sticky-top_r74jj_97",
  "flare-layout-sticky-bottom": "_flare-layout-sticky-bottom_r74jj_98"
};
function Pn(e) {
  const { className: t, children: r, ...a } = e, o = [Pt["flare-layout-header"], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsx("header", { className: o, ...a, children: r });
}
function Rn(e) {
  const { className: t, children: r, ...a } = e, o = [Pt["flare-layout-subheader"], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsx("div", { className: o, ...a, children: r });
}
function In(e) {
  const {
    className: t,
    style: r,
    children: a,
    visible: o = !0,
    width: c,
    minWidth: s,
    maxWidth: h,
    height: u,
    minHeight: b,
    maxHeight: f,
    ...w
  } = e;
  if (c !== void 0 && (s !== void 0 || h !== void 0))
    throw new Et("FlareLayoutSideBar: width cannot be combined with minWidth/maxWidth.");
  if (u !== void 0 && (b !== void 0 || f !== void 0))
    throw new Et("FlareLayoutSideBar: height cannot be combined with minHeight/maxHeight.");
  if (!o)
    return null;
  const x = { ...r }, k = sr(c), N = sr(s), j = sr(h), F = sr(u), B = sr(b), A = sr(f);
  k ? x.width = k : (N && (x.minWidth = N), j && (x.maxWidth = j)), F ? x.height = F : (B && (x.minHeight = B), A && (x.maxHeight = A));
  const P = [Pt["flare-layout-sidebar"], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsx("aside", { className: P, style: x, ...w, children: a });
}
function sr(e) {
  if (e != null)
    return typeof e == "number" ? `${e}px` : e;
}
function Fn(e) {
  const { className: t, children: r, ...a } = e, o = [Pt["flare-layout-sticky-top"], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsx("div", { className: o, ...a, children: r });
}
function Tn(e) {
  const { className: t, children: r, ...a } = e, o = [Pt["flare-layout-content"], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsx("section", { className: o, ...a, children: r });
}
function Mn(e) {
  const { className: t, children: r, ...a } = e, o = [Pt["flare-layout-sticky-bottom"], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsx("div", { className: o, ...a, children: r });
}
function On(e) {
  const { className: t, children: r, ...a } = e, o = [Pt["flare-layout-footer"], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsx("footer", { className: o, ...a, children: r });
}
function Ho(e) {
  try {
    return An(e);
  } catch (t) {
    throw t instanceof Et ? t : new Et("Failed to render FlareLayout", t);
  }
}
function An(e) {
  var P;
  const {
    className: t,
    children: r,
    gap: a,
    height: o,
    margin: c,
    maxWidth: s,
    maxHeight: h,
    minHeight: u,
    style: b,
    type: f,
    direction: w,
    ...x
  } = e;
  if (f === "grid" && w !== void 0)
    throw new Et('FlareLayout: `direction` is only supported when type="stack".');
  const k = f === "stack" ? w ?? "horizontal" : void 0, N = Ln(r), j = (P = N.sideBar) == null ? void 0 : P.props;
  j && $n(j);
  const F = j ? j.visible !== !1 : !1, B = [
    Pt["flare-layout"],
    f === "grid" ? Pt["is-grid"] : Pt["is-stack"],
    f === "stack" && k === "horizontal" ? Pt["is-horizontal"] : void 0,
    f === "stack" && k === "vertical" ? Pt["is-vertical"] : void 0,
    F ? void 0 : Pt["is-sidebar-hidden"],
    t
  ].filter(Boolean).join(" "), A = {
    ...b,
    "--flare-layout-gap": `${a ?? 0}px`,
    "--flare-layout-height": Sr(o),
    "--flare-layout-max-width": Sr(s),
    "--flare-layout-max-height": Sr(h),
    "--flare-layout-min-height": Sr(u),
    "--flare-layout-margin": Wn(c)
  };
  return /* @__PURE__ */ n.jsxs("div", { className: B, style: A, ...x, children: [
    N.header,
    N.subHeader,
    /* @__PURE__ */ n.jsxs("div", { className: Pt["flare-layout-body"], children: [
      F ? N.sideBar : null,
      /* @__PURE__ */ n.jsxs("main", { className: Pt["flare-layout-main"], children: [
        N.topSticky,
        N.content,
        N.bottomSticky
      ] })
    ] }),
    N.footer
  ] });
}
function Ln(e) {
  const t = {}, r = W.Children.toArray(e);
  for (const a of r) {
    if (!W.isValidElement(a))
      throw new Et(
        "FlareLayout: invalid child. Only FlareLayoutHeader/SubHeader/SideBar/TopSticky/Content/BottomSticky/Footer are supported."
      );
    switch (a.type) {
      case Pn:
        er(t.header, "FlareLayoutHeader"), t.header = a;
        break;
      case Rn:
        er(t.subHeader, "FlareLayoutSubHeader"), t.subHeader = a;
        break;
      case In:
        er(t.sideBar, "FlareLayoutSideBar"), t.sideBar = a;
        break;
      case Fn:
        er(t.topSticky, "FlareLayoutTopSticky"), t.topSticky = a;
        break;
      case Tn:
        er(t.content, "FlareLayoutContent"), t.content = a;
        break;
      case Mn:
        er(t.bottomSticky, "FlareLayoutBottomSticky"), t.bottomSticky = a;
        break;
      case On:
        er(t.footer, "FlareLayoutFooter"), t.footer = a;
        break;
      default:
        throw new Et(
          "FlareLayout: invalid child. Only FlareLayoutHeader/SubHeader/SideBar/TopSticky/Content/BottomSticky/Footer are supported."
        );
    }
  }
  if (!t.content)
    throw new Et("FlareLayout: exactly one FlareLayoutContent is required.");
  return t;
}
function er(e, t) {
  if (e)
    throw new Et(`FlareLayout: only one ${t} is allowed.`);
}
function $n(e) {
  if (e.width !== void 0 && (e.minWidth !== void 0 || e.maxWidth !== void 0))
    throw new Et("FlareLayoutSideBar: width cannot be combined with minWidth/maxWidth.");
  if (e.height !== void 0 && (e.minHeight !== void 0 || e.maxHeight !== void 0))
    throw new Et("FlareLayoutSideBar: height cannot be combined with minHeight/maxHeight.");
}
function Sr(e) {
  if (e != null)
    return typeof e == "number" ? `${e}px` : e;
}
function Wn(e) {
  if (e != null)
    return typeof e == "number" ? `${e}px` : e;
}
const Xt = {
  "flare-split-view": "_flare-split-view_wsuhh_1",
  "is-horizontal": "_is-horizontal_wsuhh_25",
  "is-vertical": "_is-vertical_wsuhh_29",
  "is-dragging": "_is-dragging_wsuhh_33",
  "flare-split-view-pane": "_flare-split-view-pane_wsuhh_41",
  "flare-split-view-splitter": "_flare-split-view-splitter_wsuhh_50",
  "is-active": "_is-active_wsuhh_93"
};
function ha(e) {
  const t = [Xt["flare-split-view-pane"], e.className].filter(Boolean).join(" "), {
    className: r,
    style: a,
    children: o,
    minSize: c,
    maxSize: s,
    initialSize: h,
    ...u
  } = e;
  return /* @__PURE__ */ n.jsx("div", { className: t, style: a, ...u, children: o });
}
function Bo(e) {
  const t = me(null), r = me(null), a = me(0), o = me(null), [c, s] = Ne(void 0), [h, u] = Ne(0), [b, f] = Ne([]), [w, x] = Ne(!1), [k, N] = Ne(null), j = e.direction ?? "horizontal", F = e.gap ?? 0, B = e.splitterSize ?? 1, A = Math.max(B, 20), P = e.draggable ?? !0, Y = e.keyboardStep ?? 10, X = Array.isArray(e.sizes) && e.sizes.length > 0, oe = !X && e.id ? `flare-ui/split-view/${e.id}/sizes` : null;
  pe(() => {
    let p = null;
    Array.isArray(e.sizes) && e.sizes.length === 0 ? p = "FlareSplitView: `sizes` is an empty array; falling back to uncontrolled. Use `initialSizes` or provide non-empty controlled sizes." : Array.isArray(e.sizes) && e.sizes.length > 0 && !e.onResize && !e.onResizeEnd && (p = "FlareSplitView: `sizes` provided without `onResize`/`onResizeEnd`. Component is controlled; parent must update sizes for drag to reflect."), p && p !== o.current && (console.warn(p), o.current = p);
  }, [e.onResize, e.onResizeEnd, e.sizes]);
  const G = W.Children.toArray(e.children), S = G.length, Z = ze(() => G.map((p) => W.isValidElement(p) ? { isPane: p.type === ha, props: p.props } : { isPane: !1, props: void 0 }), [G]);
  pe(() => {
    const p = t.current;
    if (!p)
      return;
    const z = () => {
      const le = p.getBoundingClientRect();
      u(j === "horizontal" ? le.width : le.height);
    };
    z();
    const V = new ResizeObserver(z);
    return V.observe(p), () => V.disconnect();
  }, [j]);
  const We = S + Math.max(S - 1, 0), be = F * Math.max(We - 1, 0), ee = B * Math.max(S - 1, 0), q = Math.max(h - be - ee, 0), T = ze(() => Z.map((p) => {
    var V;
    const z = (V = p.props) == null ? void 0 : V.minSize;
    return Kr(z, q) ?? 0;
  }), [Z, q]), L = ze(() => Z.map((p, z) => {
    var ie;
    const V = (ie = p.props) == null ? void 0 : ie.maxSize, le = Kr(V, q), he = T[z] ?? 0;
    return le === void 0 || Number.isNaN(le) ? Number.POSITIVE_INFINITY : le < he ? he : le;
  }), [Z, q, T]);
  pe(() => {
    if (!oe || c === oe || q <= 0 || S === 0)
      return;
    const z = Hn(oe, S) ?? Fr(Z, e.initialSizes), V = Tr(z, S, q, T, L);
    f(V), a.current = q, s(oe);
  }, [q, c, L, T, S, Z, oe, e.initialSizes]);
  const ke = R((p) => {
    if (!(!oe || q <= 0 || p.length !== S || typeof window > "u"))
      try {
        const z = p.map((V) => `${Number((V / q * 100).toFixed(4))}%`);
        window.localStorage.setItem(oe, JSON.stringify({ paneCount: S, sizes: z }));
      } catch {
      }
  }, [q, S, oe]);
  pe(() => {
    if (X || S === 0 || q <= 0 || oe && c !== oe || b.length === S)
      return;
    const p = Fr(Z, e.initialSizes), z = Tr(p, S, q, T, L);
    f(z), a.current = q;
  }, [q, b.length, X, c, L, T, S, Z, oe, e.initialSizes]), pe(() => {
    if (X || S === 0 || b.length !== S || q <= 0)
      return;
    const p = a.current;
    if (a.current = q, p <= 0 || Math.abs(p - q) < 1)
      return;
    const z = q / p, V = b.map((he) => he * z), le = Oa(V, T, L, q);
    f(le);
  }, [q, b, X, L, T, S]);
  const te = ze(() => {
    if (S === 0)
      return [];
    const p = X ? e.sizes : b, z = Fr(Z, e.initialSizes), V = p && p.length > 0 ? p : z;
    return Tr(V, S, q, T, L);
  }, [q, b, X, L, T, S, Z, e.initialSizes, e.sizes]), ce = R(
    (p) => {
      var ie;
      const z = r.current;
      if (!z)
        return;
      let le = (z.direction === "horizontal" ? p.clientX : p.clientY) - z.startPos;
      z.direction === "horizontal" && z.isRtl && (le = -le);
      const he = Mr(
        z.startSizes,
        z.index,
        le,
        z.minSizes,
        z.maxSizes
      );
      X || f(he), (ie = e.onResize) == null || ie.call(e, he);
    },
    [X, e]
  ), we = R((p) => {
    var ie;
    const z = r.current;
    if (!z)
      return;
    let le = (z.direction === "horizontal" ? p.clientX : p.clientY) - z.startPos;
    z.direction === "horizontal" && z.isRtl && (le = -le);
    const he = Mr(
      z.startSizes,
      z.index,
      le,
      z.minSizes,
      z.maxSizes
    );
    r.current = null, x(!1), N(null), document.body.style.userSelect = "", window.removeEventListener("pointermove", ce), window.removeEventListener("pointerup", we), window.removeEventListener("mousemove", ce), window.removeEventListener("mouseup", we), (ie = e.onResizeEnd) == null || ie.call(e, he), ke(he);
  }, [ce, ke, e]), Fe = R(
    (p, z) => {
      var ie;
      if (!P || S < 2 || r.current)
        return;
      z.preventDefault(), z.stopPropagation();
      const V = t.current, le = V ? window.getComputedStyle(V).direction === "rtl" : !1, he = j === "horizontal" ? z.clientX : z.clientY;
      r.current = {
        index: p,
        startPos: he,
        startSizes: te,
        minSizes: T,
        maxSizes: L,
        totalAvailable: q,
        direction: j,
        isRtl: le
      }, x(!0), N(p), document.body.style.userSelect = "none", window.addEventListener("pointermove", ce), window.addEventListener("pointerup", we), window.addEventListener("mousemove", ce), window.addEventListener("mouseup", we), (ie = e.onResizeStart) == null || ie.call(e, p);
    },
    [q, j, P, ce, we, L, T, S, e, te]
  ), De = R(
    (p, z) => {
      var rt;
      if (!P)
        return;
      const V = Bn(z.key, j, Y);
      if (V === 0)
        return;
      z.preventDefault();
      const le = j === "horizontal" ? window.getComputedStyle(t.current ?? document.body).direction === "rtl" : !1, he = j === "horizontal" && le ? -V : V, ie = Mr(
        te,
        p,
        he,
        T,
        L
      );
      X || f(ie), (rt = e.onResize) == null || rt.call(e, ie), ke(ie);
    },
    [j, P, X, Y, L, T, ke, e, te]
  ), Ee = [
    Xt["flare-split-view"],
    j === "horizontal" ? Xt["is-horizontal"] : Xt["is-vertical"],
    w ? Xt["is-dragging"] : null,
    e.className
  ].filter(Boolean).join(" "), Me = {
    ...e.style,
    "--flare-split-view-gap": `${F}px`,
    "--flare-split-view-splitter-size": `${B}px`,
    "--flare-split-view-splitter-hit-area": `${A}px`
  }, {
    className: Be,
    style: qe,
    children: Xe,
    direction: xe,
    gap: ue,
    splitterSize: Ve,
    draggable: Oe,
    keyboardStep: st,
    sizes: Pe,
    initialSizes: dt,
    onResizeStart: ut,
    onResize: Q,
    onResizeEnd: se,
    ...re
  } = e;
  return /* @__PURE__ */ n.jsx("div", { ref: t, className: Ee, style: Me, ...re, children: G.map((p, z) => {
    var Ke, $e;
    const V = (Ke = Z[z]) == null ? void 0 : Ke.props, le = [Xt["flare-split-view-pane"], V == null ? void 0 : V.className].filter(Boolean).join(" "), he = te[z], ie = Number.isFinite(he), rt = Vn(ie ? he : void 0), He = {
      ...V == null ? void 0 : V.style,
      ...rt
    }, ae = ($e = Z[z]) != null && $e.isPane && W.isValidElement(p) ? W.cloneElement(p, {
      className: le,
      style: He
    }) : /* @__PURE__ */ n.jsx(ha, { className: le, style: He, children: p }), ye = z < S - 1 ? /* @__PURE__ */ n.jsx(
      "div",
      {
        role: "separator",
        "aria-orientation": j,
        "aria-valuenow": Math.round(he ?? 0),
        "aria-valuemin": Math.round(T[z] ?? 0),
        "aria-valuemax": Number.isFinite(L[z]) ? Math.round(L[z]) : void 0,
        tabIndex: P ? 0 : -1,
        className: [
          Xt["flare-split-view-splitter"],
          k === z ? Xt["is-active"] : null
        ].filter(Boolean).join(" "),
        onPointerDown: (Ue) => Fe(z, Ue),
        onMouseDown: (Ue) => Fe(z, Ue),
        onKeyDown: (Ue) => De(z, Ue)
      },
      `splitter-${z}`
    ) : null;
    return /* @__PURE__ */ n.jsxs(W.Fragment, { children: [
      ae,
      ye
    ] }, `pane-${z}`);
  }) });
}
function Vn(e) {
  return {
    flexGrow: e === void 0 ? 1 : 0,
    flexShrink: e === void 0 ? 1 : 0,
    flexBasis: e === void 0 ? "auto" : `${e}px`
  };
}
function Kr(e, t) {
  if (e == null)
    return;
  if (typeof e == "number")
    return e;
  if (e.endsWith("%")) {
    const a = Number.parseFloat(e);
    return Number.isNaN(a) ? void 0 : a / 100 * t;
  }
  if (e.endsWith("px")) {
    const a = Number.parseFloat(e);
    return Number.isNaN(a) ? void 0 : a;
  }
  const r = Number.parseFloat(e);
  return Number.isNaN(r) ? void 0 : r;
}
function Fr(e, t) {
  return e.map((r, a) => {
    var o;
    return ((o = r.props) == null ? void 0 : o.initialSize) ?? (t == null ? void 0 : t[a]);
  });
}
function Hn(e, t) {
  if (typeof window > "u")
    return null;
  try {
    const r = window.localStorage.getItem(e);
    if (!r)
      return null;
    const a = JSON.parse(r);
    if (a.paneCount !== t || !Array.isArray(a.sizes))
      return null;
    const o = a.sizes, c = (s) => {
      if (typeof s == "number")
        return Number.isFinite(s) && s >= 0;
      if (typeof s != "string" || !s.endsWith("%"))
        return !1;
      const h = Number.parseFloat(s);
      return Number.isFinite(h) && h >= 0;
    };
    return o.length === t && o.every(c) ? o : null;
  } catch {
    return null;
  }
}
function Tr(e, t, r, a, o) {
  if (t === 0)
    return [];
  const c = new Array(t).fill(void 0);
  let s = 0;
  for (let f = 0; f < t; f += 1) {
    const w = e[f];
    if (w !== void 0) {
      const x = Kr(w, r);
      x !== void 0 && !Number.isNaN(x) && (c[f] = x, s += x);
    }
  }
  const h = c.map((f, w) => f === void 0 ? w : -1).filter((f) => f >= 0), u = r - s;
  if (h.length > 0) {
    const f = r > 0 ? r / t : 0, w = u > 0 ? u / h.length : f;
    h.forEach((x) => {
      c[x] = w;
    });
  }
  const b = c.map((f) => f ?? 0);
  return Oa(b, a, o, r);
}
function Oa(e, t, r, a) {
  if (a <= 0)
    return e.map(() => 0);
  let o = e.map((s, h) => zr(s, t[h] ?? 0, r[h] ?? Number.POSITIVE_INFINITY)), c = o.reduce((s, h) => s + h, 0);
  if (c > a) {
    const s = c - a, h = o.map((u, b) => ({
      index: b,
      amount: Math.max(u - (t[b] ?? 0), 0)
    })).filter((u) => u.amount > 0);
    if (h.length > 0) {
      const u = h.reduce((b, f) => b + f.amount, 0);
      h.forEach((b) => {
        const f = u > 0 ? b.amount / u * s : 0;
        o[b.index] = o[b.index] - f;
      });
    }
  } else if (c < a) {
    const s = a - c, h = o.map((u, b) => r[b] === Number.POSITIVE_INFINITY ? b : -1).filter((u) => u >= 0);
    if (h.length > 0) {
      const u = s / h.length;
      h.forEach((b) => {
        o[b] += u;
      });
    } else {
      const u = o.map((f, w) => ({
        index: w,
        amount: Math.max((r[w] ?? f) - f, 0)
      })).filter((f) => f.amount > 0), b = u.reduce((f, w) => f + w.amount, 0);
      u.forEach((f) => {
        const w = b > 0 ? f.amount / b * s : 0;
        o[f.index] = o[f.index] + w;
      });
    }
  }
  if (o = o.map((s, h) => zr(s, t[h] ?? 0, r[h] ?? Number.POSITIVE_INFINITY)), c = o.reduce((s, h) => s + h, 0), Math.abs(c - a) > 1 && c > 0) {
    const s = a / c;
    o = o.map((h) => h * s);
  }
  return o.map((s) => Number.isFinite(s) ? s : 0);
}
function Mr(e, t, r, a, o) {
  const c = [...e], s = e[t], h = e[t + 1], u = s + h;
  let b = a[t] ?? 0, f = a[t + 1] ?? 0, w = o[t] ?? Number.POSITIVE_INFINITY, x = o[t + 1] ?? Number.POSITIVE_INFINITY;
  u < b + f && (b = 0, f = 0), Number.isFinite(w) && Number.isFinite(x) && u > w + x && (w = Number.POSITIVE_INFINITY, x = Number.POSITIVE_INFINITY);
  let k = zr(s + r, b, w), N = u - k;
  return N < f && (N = f, k = u - N), N > x && (N = x, k = u - N), k = zr(k, b, w), N = u - k, c[t] = k, c[t + 1] = N, c;
}
function zr(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function Bn(e, t, r) {
  if (t === "horizontal") {
    if (e === "ArrowLeft")
      return -r;
    if (e === "ArrowRight")
      return r;
  } else if (t === "vertical") {
    if (e === "ArrowUp")
      return -r;
    if (e === "ArrowDown")
      return r;
  }
  return e === "Home" ? -Number.MAX_SAFE_INTEGER : e === "End" ? Number.MAX_SAFE_INTEGER : 0;
}
const Ft = {
  "flare-scroll-pane": "_flare-scroll-pane_knzlv_1",
  "flare-scroll-pane-viewport": "_flare-scroll-pane-viewport_knzlv_17",
  "flare-scroll-pane-content": "_flare-scroll-pane-content_knzlv_30",
  "axis-vertical": "_axis-vertical_knzlv_35",
  "axis-horizontal": "_axis-horizontal_knzlv_40",
  "axis-both": "_axis-both_knzlv_45",
  "flare-scroll-pane-track-vertical": "_flare-scroll-pane-track-vertical_knzlv_49",
  "flare-scroll-pane-track-horizontal": "_flare-scroll-pane-track-horizontal_knzlv_50",
  "has-vertical-scrollbar": "_has-vertical-scrollbar_knzlv_81",
  "has-horizontal-scrollbar": "_has-horizontal-scrollbar_knzlv_85",
  "flare-scroll-pane-thumb-vertical": "_flare-scroll-pane-thumb-vertical_knzlv_89",
  "flare-scroll-pane-thumb-horizontal": "_flare-scroll-pane-thumb-horizontal_knzlv_90",
  "is-dragging": "_is-dragging_knzlv_115"
}, Aa = 28, qn = 44, Kn = 180;
function ga(e) {
  if (e !== void 0)
    return typeof e == "number" ? `${e}px` : e;
}
function Un(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function ba(e, t) {
  return e === "both" || e === t;
}
function Or(e) {
  return {
    clientWidth: e.clientWidth,
    clientHeight: e.clientHeight,
    scrollWidth: e.scrollWidth,
    scrollHeight: e.scrollHeight,
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
const qo = ja(
  function({
    axis: t = "vertical",
    scrollbarVisibility: r = "auto",
    scrollbarSize: a,
    trackColor: o,
    trackBorderColor: c,
    thumbColor: s,
    thumbHoverColor: h,
    thumbRadius: u,
    id: b,
    className: f,
    style: w,
    children: x,
    onScroll: k,
    ...N
  }, j) {
    var dt, ut;
    const F = me(null), B = me(null), A = me(null), P = me(null), Y = me(null), X = me(null), oe = Rt(), G = b ? `${b}-viewport` : oe, [S, Z] = Ne(null), [We, be] = Ne(!1), [ee, q] = Ne({
      clientWidth: 0,
      clientHeight: 0,
      scrollWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0
    });
    _r(j, () => {
      if (!F.current)
        throw new Error("FlareScrollPane viewport is unavailable.");
      return F.current;
    }, []);
    const T = R(() => {
      const Q = F.current;
      Q && q(Or(Q));
    }, []), L = R(() => {
      X.current !== null && (window.cancelAnimationFrame(X.current), X.current = null);
    }, []), ke = R((Q, se, re = !1) => {
      const p = F.current;
      if (!p)
        return;
      const z = Math.max(Q === "vertical" ? p.scrollHeight - p.clientHeight : p.scrollWidth - p.clientWidth, 0), V = Un(se, 0, z);
      if (!(re && typeof window.matchMedia == "function" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches)) {
        L(), Q === "vertical" ? p.scrollTop = V : p.scrollLeft = V;
        return;
      }
      L();
      const he = Q === "vertical" ? p.scrollTop : p.scrollLeft, ie = V - he;
      if (Math.abs(ie) < 1)
        return;
      const rt = performance.now(), He = (ae) => {
        const ye = Math.min((ae - rt) / Kn, 1), Ke = 1 - (1 - ye) ** 3, $e = he + ie * Ke;
        if (Q === "vertical" ? p.scrollTop = $e : p.scrollLeft = $e, ye < 1) {
          X.current = window.requestAnimationFrame(He);
          return;
        }
        X.current = null;
      };
      X.current = window.requestAnimationFrame(He);
    }, [L]);
    pe(() => {
      T();
      const Q = F.current, se = B.current;
      if (!Q || !se)
        return;
      const re = new ResizeObserver(T);
      return re.observe(Q), re.observe(se), () => re.disconnect();
    }, [x, T]), pe(() => {
      if (typeof window.matchMedia != "function")
        return;
      const Q = window.matchMedia("(pointer: coarse)"), se = () => be(Q.matches);
      return se(), typeof Q.addEventListener == "function" ? (Q.addEventListener("change", se), () => Q.removeEventListener("change", se)) : (Q.addListener(se), () => Q.removeListener(se));
    }, []);
    const te = R((Q) => {
      const se = Y.current, re = F.current;
      if (!se || !re)
        return;
      const p = se.axis === "vertical";
      if (Q.pointerId !== se.pointerId)
        return;
      const z = Or(re), V = p ? A.current : P.current, le = p ? (V == null ? void 0 : V.clientHeight) ?? z.clientHeight : (V == null ? void 0 : V.clientWidth) ?? z.clientWidth, he = p ? z.scrollHeight : z.scrollWidth, ie = p ? z.clientHeight : z.clientWidth, rt = Math.max(he - ie, 0), He = jr(le, ie, he), ae = Math.max(le - He, 1), ye = p ? Q.clientY : Q.clientX, Ke = se.startScrollPosition + (ye - se.startPosition) / ae * rt;
      ke(se.axis, Ke), T();
    }, [ke, T]), ce = R(() => {
      Y.current = null, Z(null), window.removeEventListener("pointermove", te), window.removeEventListener("pointerup", ce), window.removeEventListener("pointercancel", ce);
    }, [te]);
    pe(() => () => {
      window.removeEventListener("pointermove", te), window.removeEventListener("pointerup", ce), window.removeEventListener("pointercancel", ce), L();
    }, [L, te, ce]);
    const we = R((Q, se) => {
      const re = F.current;
      re && (L(), se.preventDefault(), se.stopPropagation(), Z(Q), Y.current = {
        axis: Q,
        pointerId: se.pointerId,
        startPosition: Q === "vertical" ? se.clientY : se.clientX,
        startScrollPosition: Q === "vertical" ? re.scrollTop : re.scrollLeft
      }, window.addEventListener("pointermove", te), window.addEventListener("pointerup", ce), window.addEventListener("pointercancel", ce));
    }, [L, te, ce]), Fe = R((Q, se) => {
      if (se.target !== se.currentTarget)
        return;
      const re = F.current;
      if (!re)
        return;
      const p = se.currentTarget.getBoundingClientRect(), z = Q === "vertical", V = z ? p.height : p.width, le = Or(re), he = z ? le.scrollHeight : le.scrollWidth, ie = z ? le.clientHeight : le.clientWidth, rt = Math.max(he - ie, 0), He = jr(V, ie, he), ye = ((z ? se.clientY - p.top : se.clientX - p.left) - He / 2) / Math.max(V - He, 1) * rt;
      ke(Q, ye, !0);
    }, [ke]), De = R((Q, se) => {
      const re = F.current;
      if (!re)
        return;
      const p = Q === "vertical", z = p ? "ArrowUp" : "ArrowLeft", V = p ? "ArrowDown" : "ArrowRight", le = p ? re.clientHeight : re.clientWidth;
      let he = null;
      se.key === z && (he = (p ? re.scrollTop : re.scrollLeft) - 40), se.key === V && (he = (p ? re.scrollTop : re.scrollLeft) + 40), se.key === "PageUp" && (he = (p ? re.scrollTop : re.scrollLeft) - le), se.key === "PageDown" && (he = (p ? re.scrollTop : re.scrollLeft) + le), se.key === "Home" && (he = 0), se.key === "End" && (he = p ? re.scrollHeight - re.clientHeight : re.scrollWidth - re.clientWidth), he !== null && (se.preventDefault(), ke(Q, he, !0));
    }, [ke]), Ee = ba(t, "vertical") && (r === "always" || ee.scrollHeight > ee.clientHeight), Me = ba(t, "horizontal") && (r === "always" || ee.scrollWidth > ee.clientWidth), Be = We ? qn : Aa, qe = ((dt = A.current) == null ? void 0 : dt.clientHeight) ?? ee.clientHeight, Xe = ((ut = P.current) == null ? void 0 : ut.clientWidth) ?? ee.clientWidth, xe = jr(qe, ee.clientHeight, ee.scrollHeight, Be), ue = jr(Xe, ee.clientWidth, ee.scrollWidth, Be), Ve = va(ee.scrollTop, ee.clientHeight, ee.scrollHeight, qe, xe), Oe = va(ee.scrollLeft, ee.clientWidth, ee.scrollWidth, Xe, ue), st = {
      ...w,
      "--flare-scroll-pane-size": ga(a),
      "--flare-scroll-pane-track": o,
      "--flare-scroll-pane-track-border": c,
      "--flare-scroll-pane-thumb": s,
      "--flare-scroll-pane-thumb-hover": h,
      "--flare-scroll-pane-radius": ga(u)
    }, Pe = [
      Ft["flare-scroll-pane"],
      Ft[`axis-${t}`],
      r === "always" ? Ft["always-visible"] : null,
      Ee ? Ft["has-vertical-scrollbar"] : null,
      Me ? Ft["has-horizontal-scrollbar"] : null,
      f
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.jsxs("div", { id: b, className: Pe, style: st, ...N, children: [
      /* @__PURE__ */ n.jsx(
        "div",
        {
          ref: F,
          id: G,
          className: Ft["flare-scroll-pane-viewport"],
          onScroll: (Q) => {
            T(), k == null || k(Q);
          },
          children: /* @__PURE__ */ n.jsx("div", { ref: B, className: Ft["flare-scroll-pane-content"], children: x })
        }
      ),
      Ee ? /* @__PURE__ */ n.jsx(
        "div",
        {
          ref: A,
          className: Ft["flare-scroll-pane-track-vertical"],
          role: "scrollbar",
          "aria-controls": G,
          "aria-orientation": "vertical",
          "aria-valuemin": 0,
          "aria-valuemax": Math.max(ee.scrollHeight - ee.clientHeight, 0),
          "aria-valuenow": Math.round(ee.scrollTop),
          tabIndex: 0,
          onPointerDown: (Q) => Fe("vertical", Q),
          onKeyDown: (Q) => De("vertical", Q),
          children: /* @__PURE__ */ n.jsx(
            "div",
            {
              className: [
                Ft["flare-scroll-pane-thumb-vertical"],
                S === "vertical" ? Ft["is-dragging"] : null
              ].filter(Boolean).join(" "),
              style: { height: `${xe}px`, transform: `translateY(${Ve}px)` },
              onPointerDown: (Q) => we("vertical", Q)
            }
          )
        }
      ) : null,
      Me ? /* @__PURE__ */ n.jsx(
        "div",
        {
          ref: P,
          className: Ft["flare-scroll-pane-track-horizontal"],
          role: "scrollbar",
          "aria-controls": G,
          "aria-orientation": "horizontal",
          "aria-valuemin": 0,
          "aria-valuemax": Math.max(ee.scrollWidth - ee.clientWidth, 0),
          "aria-valuenow": Math.round(ee.scrollLeft),
          tabIndex: 0,
          onPointerDown: (Q) => Fe("horizontal", Q),
          onKeyDown: (Q) => De("horizontal", Q),
          children: /* @__PURE__ */ n.jsx(
            "div",
            {
              className: [
                Ft["flare-scroll-pane-thumb-horizontal"],
                S === "horizontal" ? Ft["is-dragging"] : null
              ].filter(Boolean).join(" "),
              style: { width: `${ue}px`, transform: `translateX(${Oe}px)` },
              onPointerDown: (Q) => we("horizontal", Q)
            }
          )
        }
      ) : null
    ] });
  }
);
function jr(e, t, r, a = Aa) {
  return !e || !t || !r ? 0 : Math.min(e, Math.max(a, t / r * e));
}
function va(e, t, r, a, o) {
  const c = Math.max(r - t, 0), s = Math.max(a - o, 0);
  return c ? e / c * s : 0;
}
const Wt = {
  "flare-popup-menu": "_flare-popup-menu_m1n5j_1",
  "flare-popup-menu__content": "_flare-popup-menu__content_m1n5j_13",
  "flare-popup-menu__title": "_flare-popup-menu__title_m1n5j_26",
  "flare-popup-menu__item": "_flare-popup-menu__item_m1n5j_34",
  "flare-popup-menu__item--disabled": "_flare-popup-menu__item--disabled_m1n5j_57",
  "flare-popup-menu__label": "_flare-popup-menu__label_m1n5j_62",
  "flare-popup-menu__checkbox": "_flare-popup-menu__checkbox_m1n5j_66",
  "flare-popup-menu__divider": "_flare-popup-menu__divider_m1n5j_73"
}, vr = (...e) => e.filter(Boolean).join(" "), La = W.forwardRef(function(t, r) {
  const { children: a, className: o, contentClassName: c, ...s } = t;
  return /* @__PURE__ */ n.jsx(
    Rr,
    {
      ...s,
      ref: r,
      className: vr(Wt["flare-popup-menu"], o),
      children: /* @__PURE__ */ n.jsx("div", { className: vr(Wt["flare-popup-menu__content"], c), children: a })
    }
  );
});
function Ar(e) {
  const {
    as: t = "button",
    className: r,
    disabled: a,
    children: o,
    ...c
  } = e, s = vr(
    Wt["flare-popup-menu__item"],
    a && Wt["flare-popup-menu__item--disabled"],
    r
  ), h = (f, w) => {
    if (a) {
      f.preventDefault(), f.stopPropagation();
      return;
    }
    w == null || w(f);
  };
  if (t === "div") {
    const { onClick: f, ...w } = c;
    return /* @__PURE__ */ n.jsx(
      "div",
      {
        ...w,
        className: s,
        "aria-disabled": a,
        onClick: (x) => h(x, f),
        children: o
      }
    );
  }
  const { onClick: u, ...b } = c;
  return /* @__PURE__ */ n.jsx(
    "button",
    {
      ...b,
      type: "button",
      className: s,
      onClick: (f) => h(f, u),
      disabled: a,
      children: o
    }
  );
}
function Yn(e) {
  const { label: t, checked: r, disabled: a, onChange: o } = e;
  return /* @__PURE__ */ n.jsx(
    "div",
    {
      className: vr(
        Wt["flare-popup-menu__item"],
        a && Wt["flare-popup-menu__item--disabled"]
      ),
      role: "menuitemcheckbox",
      "aria-checked": r,
      "aria-disabled": a,
      children: /* @__PURE__ */ n.jsx(
        Ta,
        {
          className: Wt["flare-popup-menu__checkbox"],
          label: /* @__PURE__ */ n.jsx("span", { className: Wt["flare-popup-menu__label"], children: t }),
          checked: r,
          disabled: a,
          onChange: o
        }
      )
    }
  );
}
function Gn() {
  return /* @__PURE__ */ n.jsx("div", { className: Wt["flare-popup-menu__divider"] });
}
function Xn(e) {
  const { className: t, children: r, ...a } = e;
  return /* @__PURE__ */ n.jsx(
    "div",
    {
      ...a,
      className: vr(Wt["flare-popup-menu__title"], t),
      children: r
    }
  );
}
const Jn = "_rtl_rcjaq_106", Zn = "_bordered_rcjaq_130", Qn = "_compact_rcjaq_133", eo = "_sticky_rcjaq_138", to = "_loading_rcjaq_141", ro = "_sortable_rcjaq_198", ao = "_dragging_rcjaq_208", no = "_stub_rcjaq_223", oo = "_none_rcjaq_260", lo = "_asc_rcjaq_264", io = "_desc_rcjaq_268", co = "_interactive_rcjaq_300", so = "_open_rcjaq_345", ge = {
  "data-grid": "_data-grid_rcjaq_64",
  rtl: Jn,
  "data-grid-cell": "_data-grid-cell_rcjaq_113",
  "data-grid-header-cell": "_data-grid-header-cell_rcjaq_114",
  "data-grid-header-button": "_data-grid-header-button_rcjaq_115",
  bordered: Zn,
  compact: Qn,
  sticky: eo,
  "data-grid-head": "_data-grid-head_rcjaq_114",
  loading: to,
  "data-grid-viewport": "_data-grid-viewport_rcjaq_147",
  "data-grid-header": "_data-grid-header_rcjaq_114",
  "data-grid-table": "_data-grid-table_rcjaq_165",
  "last-column": "_last-column_rcjaq_185",
  sortable: ro,
  dragging: ao,
  "drag-over": "_drag-over_rcjaq_213",
  stub: no,
  "data-grid-header-label": "_data-grid-header-label_rcjaq_233",
  "data-grid-sort-indicator": "_data-grid-sort-indicator_rcjaq_253",
  none: oo,
  asc: lo,
  desc: io,
  "data-grid-column-resizer": "_data-grid-column-resizer_rcjaq_275",
  "data-grid-body": "_data-grid-body_rcjaq_291",
  "data-grid-row": "_data-grid-row_rcjaq_291",
  interactive: co,
  "zebra-odd": "_zebra-odd_rcjaq_303",
  "zebra-even": "_zebra-even_rcjaq_306",
  "data-grid-details-row": "_data-grid-details-row_rcjaq_345",
  open: so,
  "data-grid-details-cell": "_data-grid-details-cell_rcjaq_348",
  "data-grid-details": "_data-grid-details_rcjaq_345",
  "data-grid-details-loading": "_data-grid-details-loading_rcjaq_373",
  "data-grid-empty": "_data-grid-empty_rcjaq_382",
  "data-grid-footer": "_data-grid-footer_rcjaq_391",
  "data-grid-footer-summary": "_data-grid-footer-summary_rcjaq_400",
  "data-grid-pager": "_data-grid-pager_rcjaq_403",
  "data-grid-pager-button": "_data-grid-pager-button_rcjaq_408",
  "data-grid-page": "_data-grid-page_rcjaq_403",
  "data-grid-spinner": "_data-grid-spinner_rcjaq_439",
  "data-grid-overlay": "_data-grid-overlay_rcjaq_447"
}, tr = 60, gr = 120, Lr = "flare-data-grid", Bt = typeof window < "u" && typeof window.localStorage < "u", uo = {
  noData: "No data",
  rows: "rows",
  of: "of",
  firstPage: "First page",
  previousPage: "Previous page",
  nextPage: "Next page",
  lastPage: "Last page",
  columnsMenu: "Columns menu",
  columns: "Columns",
  showAllColumns: "Show all",
  autoSizeColumns: "Auto size columns",
  hideColumn: (e) => `Hide “${e}”`,
  sortColumn: (e, t) => `Sort by ${e}${t ? `, currently ${t}` : ""}`,
  resizeColumn: (e) => `Resize column ${e}`,
  activateRow: "Row: press Enter to activate"
}, $r = (e) => {
  if (!Bt)
    return null;
  try {
    const t = window.localStorage.getItem(e);
    return t ? JSON.parse(t) : null;
  } catch (t) {
    return console.warn("FlareDataGrid storage read failed.", t), null;
  }
}, Wr = (e, t) => {
  if (Bt)
    try {
      window.localStorage.setItem(e, JSON.stringify(t));
    } catch (r) {
      console.warn("FlareDataGrid storage write failed.", r);
    }
}, Lt = (...e) => e.filter(Boolean).join(" ");
function Ko(e) {
  var or, wr;
  const { messages: t } = fr(), r = W.useRef(null), [a, o] = W.useState(e.direction === "rtl" ? "rtl" : "ltr"), c = W.useMemo(() => ({ ...uo, ...t.dataGrid, ...e.labels }), [t.dataGrid, e.labels]), [s, h] = W.useState(e.initialSort ?? null), [u, b] = W.useState(e.initialPage ?? 1), [f, w] = W.useState(() => e.initialRemoteState ?? { data: [] }), x = W.useRef(e.initialRemoteState != null), [k, N] = W.useState(!1), [j, F] = W.useState({}), [B, A] = W.useState(!1), [P, Y] = W.useState(!1), [X, oe] = W.useState({}), G = e.fetchPage ?? null, S = G !== null, Z = e.pageSize ?? 20, We = e.loading ?? (S ? k : !1), be = W.useRef(null), ee = W.useMemo(() => e.id ? `${Lr}/${e.id}/column-widths` : null, [e.id]), q = W.useMemo(() => e.id ? `${Lr}/${e.id}/column-order` : null, [e.id]), T = W.useMemo(() => e.id ? `${Lr}/${e.id}/column-visibility` : null, [e.id]);
  W.useLayoutEffect(() => {
    if (e.direction === "ltr" || e.direction === "rtl") {
      o(e.direction);
      return;
    }
    const d = r.current, _ = d ? getComputedStyle(d).direction : document.documentElement.dir;
    o(_ === "rtl" ? "rtl" : "ltr");
  }, [e.direction]);
  const L = W.useMemo(() => {
    if (e.columns && e.columns.length)
      return e.columns;
    const d = (e.data ?? []).slice(0, 20), _ = /* @__PURE__ */ new Set();
    return d.forEach((M) => Object.keys(M ?? {}).forEach((O) => _.add(O))), Array.from(_).map((M) => ({ key: M, displayText: M, sortable: !S }));
  }, [e.columns, e.data, S]), ke = W.useMemo(() => {
    const d = {};
    return L.forEach((_) => {
      const y = String(_.key);
      d[y] = _.hidden !== !0;
    }), d;
  }, [L]), [te, ce] = W.useState(ke), [we, Fe] = W.useState(
    () => !T || !Bt
  );
  W.useEffect(() => {
    ce((d) => {
      const _ = {};
      let y = !1;
      if (Object.entries(ke).forEach(([M, O]) => {
        Object.prototype.hasOwnProperty.call(d, M) ? _[M] = d[M] : (_[M] = O, y = !0);
      }), Object.keys(d).length !== Object.keys(_).length && (y = !0), !y) {
        for (const M of Object.keys(_))
          if (d[M] !== _[M]) {
            y = !0;
            break;
          }
      }
      return y ? _ : d;
    });
  }, [ke]), W.useEffect(() => {
    let d = !1;
    if (!T || !Bt)
      return Fe(!0), () => {
        d = !0;
      };
    Fe(!1);
    const _ = $r(T);
    return !d && _ && ce((y) => {
      let M = !1;
      const O = { ...y };
      return Object.keys(O).forEach((ne) => {
        Object.prototype.hasOwnProperty.call(ke, ne) || (delete O[ne], M = !0);
      }), Object.entries(ke).forEach(([ne, _e]) => {
        const Se = _[ne];
        typeof Se == "boolean" ? O[ne] !== Se && (O[ne] = Se, M = !0) : Object.prototype.hasOwnProperty.call(O, ne) || (O[ne] = _e, M = !0);
      }), M ? O : y;
    }), d || Fe(!0), () => {
      d = !0;
    };
  }, [T, ke]), W.useEffect(() => {
    !T || !Bt || !we || Wr(T, te);
  }, [te, T, we]);
  const De = W.useMemo(() => {
    const d = {};
    return L.forEach((_) => {
      const y = String(_.key), M = j[y] ?? (typeof _.width == "number" ? _.width : void 0), O = typeof M == "number" ? M : Number(M), ne = Number.isFinite(O) ? O : gr;
      d[y] = Math.max(tr, Math.round(ne));
    }), d;
  }, [L, j]);
  W.useEffect(() => {
    let d = !1;
    if (A(!1), F((y) => Object.keys(y).length === 0 ? y : {}), !ee || !Bt)
      return A(!0), () => {
        d = !0;
      };
    const _ = $r(ee);
    if (!d && _) {
      const y = {};
      Object.entries(_).forEach(([M, O]) => {
        const ne = typeof O == "number" ? O : Number(O);
        if (!Number.isNaN(ne)) {
          const _e = Math.max(tr, Math.round(ne));
          y[M] = _e;
        }
      }), F((M) => Object.keys(M).length === Object.keys(y).length && Object.entries(y).every(([_e, Se]) => M[_e] === Se) ? M : y);
    }
    return d || A(!0), () => {
      d = !0;
    };
  }, [ee]), W.useEffect(() => {
    const d = new Set(L.map((_) => String(_.key)));
    F((_) => {
      let y = !1;
      const M = {};
      return Object.entries(_).forEach(([O, ne]) => {
        d.has(O) ? M[O] = ne : y = !0;
      }), y ? M : _;
    });
  }, [L]), W.useEffect(() => {
    !ee || !Bt || !B || P || Wr(ee, j);
  }, [j, ee, B, P]);
  const Ee = W.useRef(0);
  W.useEffect(() => {
    if (!S || !G)
      return;
    let d = !1;
    const _ = ++Ee.current;
    return (async () => {
      try {
        N(!0);
        const M = await G({ pageIndex: u, pageSize: Z, sort: s ?? void 0 });
        !d && _ === Ee.current && (w(M ?? { data: [] }), x.current = !0);
      } catch (M) {
        console.error("FlareDataGrid failed to fetch data.", M);
      } finally {
        !d && _ === Ee.current && N(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [S, G, u, Z, s]);
  const Me = W.useRef(null), Be = W.useRef(null), qe = W.useRef(null), Xe = W.useRef(null), xe = W.useRef(null), [ue, Ve] = W.useState(0), [Oe, st] = W.useState(0), Pe = () => {
    Me.current && (Me.current(), Me.current = null);
  }, dt = W.useRef(null), ut = () => {
    if (typeof document > "u")
      return null;
    if (dt.current)
      return dt.current;
    const d = document.createElement("div");
    d.className = ge["data-grid"], d.style.position = "absolute", d.style.visibility = "hidden", d.style.pointerEvents = "none", d.style.overflow = "hidden", d.style.top = "0", d.style.left = "0", d.style.height = "0", d.style.width = "auto", d.style.maxWidth = "none", d.style.minWidth = "0", d.style.zIndex = "-2147483648";
    const _ = document.createElement("table");
    _.className = ge["data-grid-table"], _.style.width = "auto", _.style.minWidth = "0", _.style.maxWidth = "none", _.style.tableLayout = "auto";
    const y = document.createElement("thead");
    y.className = ge["data-grid-head"];
    const M = document.createElement("tr");
    y.appendChild(M);
    const O = document.createElement("tbody");
    O.className = ge["data-grid-body"];
    const ne = document.createElement("tr");
    return O.appendChild(ne), _.appendChild(y), _.appendChild(O), d.appendChild(_), document.body.appendChild(d), dt.current = { wrapper: d, headRow: M, bodyRow: ne }, dt.current;
  }, Q = () => {
    dt.current && (dt.current.wrapper.remove(), dt.current = null);
  }, se = (d) => {
    var _e;
    if (typeof document > "u") {
      const Se = (_e = d.getBoundingClientRect) == null ? void 0 : _e.call(d);
      return Math.ceil((Se == null ? void 0 : Se.width) ?? tr);
    }
    const _ = ut();
    if (!_)
      return Math.ceil(d.getBoundingClientRect().width);
    const M = !!d.closest("thead") ? _.headRow : _.bodyRow, O = d.cloneNode(!0);
    O.querySelectorAll(`.${ge["data-grid-column-resizer"]}`).forEach((Se) => Se.remove()), O.style.width = "auto", O.style.minWidth = "0", O.style.maxWidth = "none", O.style.position = "static", O.style.left = "0", O.style.right = "auto", O.style.top = "auto", O.style.bottom = "auto", M.replaceChildren(O);
    const ne = O.getBoundingClientRect().width;
    return M.replaceChildren(), !Number.isFinite(ne) || ne <= 0 ? Math.ceil(d.getBoundingClientRect().width) : Math.ceil(ne);
  }, re = (d, _) => {
    const y = (at) => {
      if (!at)
        return [];
      const Nt = d.cellIndex;
      if (Nt < 0)
        return [];
      const Tt = [];
      return Array.from(at.rows).forEach((et) => {
        let It = 0;
        Array.from(et.cells).some((zt) => {
          const Ot = zt.colSpan || 1, lr = It, Ut = It + Ot;
          return It = Ut, Nt >= lr && Nt < Ut ? (Ot === 1 && Tt.push(zt), !0) : !1;
        });
      }), Tt;
    }, M = Xe.current ?? d.closest("table"), O = y(M), ne = y(_ ?? null), _e = O.length ? O : ne;
    if (!_e.length)
      return null;
    const Se = _e.map((at) => se(at)), Ie = Math.max(...Se);
    return !Number.isFinite(Ie) || Ie <= 0 ? null : Math.max(tr, Math.round(Ie));
  }, p = (d, _) => {
    var Nt, Tt, et;
    d.preventDefault();
    const y = d.currentTarget.parentElement, M = y.getBoundingClientRect(), O = getComputedStyle(y).direction === "rtl" || (document == null ? void 0 : document.dir) === "rtl" || ((Nt = document == null ? void 0 : document.documentElement) == null ? void 0 : Nt.dir) === "rtl", ne = De[_] ?? Math.max(tr, Math.round(M.width));
    be.current = { key: _, pointerId: d.pointerId, colLeft: M.left, colRight: M.right, rtl: O, width: ne, active: !0 }, Y(!0), (et = (Tt = d.currentTarget).setPointerCapture) == null || et.call(Tt, d.pointerId);
    const _e = (It) => {
      const zt = be.current, Ot = zt.rtl ? zt.colRight - It : It - zt.colLeft;
      return Math.max(tr, Math.round(Ot));
    };
    let Se = 0;
    const Ie = (It) => {
      var zt;
      (zt = be.current) != null && zt.active && (Se || (Se = requestAnimationFrame(() => {
        var lr;
        if (Se = 0, !((lr = be.current) != null && lr.active)) return;
        const Ot = _e(It.clientX);
        be.current.width = Ot, F((Ut) => Ut[_] === Ot ? Ut : { ...Ut, [_]: Ot });
      })));
    }, at = () => {
      var It;
      (It = be.current) != null && It.active && e.onColumnResize && e.onColumnResize(be.current.key, be.current.width), Y(!1), be.current = null, Pe(), Se && cancelAnimationFrame(Se);
    };
    window.addEventListener("pointermove", Ie, { passive: !0 }), window.addEventListener("pointerup", at, { passive: !0 }), Me.current = () => {
      window.removeEventListener("pointermove", Ie), window.removeEventListener("pointerup", at);
    };
  }, z = (d, _) => {
    const M = d.currentTarget.parentElement;
    if (!M)
      return;
    const O = re(M, qe.current);
    O && F((ne) => {
      var _e;
      return ne[_] === O ? ne : ((_e = e.onColumnResize) == null || _e.call(e, _, O), { ...ne, [_]: O });
    });
  }, [V, le] = W.useState(
    L.map((d) => String(d.key))
  ), [he, ie] = W.useState(!1), [rt, He] = W.useState(null), [ae, ye] = W.useState(null), Ke = W.useRef(null), [$e, Ue] = W.useState(null), xt = W.useRef(null), nt = W.useMemo(() => V.filter((d) => te[d] !== !1), [V, te]), Ye = W.useMemo(() => {
    if (nt.length > 0)
      return nt;
    if (!V.length)
      return [];
    const d = V[0];
    return d ? [d] : [];
  }, [nt, V]);
  W.useEffect(() => {
    if (!V.length || nt.length > 0)
      return;
    const _ = V[0];
    _ && ce((y) => y[_] === !0 ? y : { ...y, [_]: !0 });
  }, [V, nt]), W.useEffect(() => {
    let d = !1;
    if (ie(!1), !q || !Bt)
      return ie(!0), () => {
        d = !0;
      };
    const _ = $r(q);
    if (!d && _) {
      const y = L.map((_e) => String(_e.key));
      if (!y.length)
        return;
      const M = /* @__PURE__ */ new Set(), ne = _.map((_e) => String(_e)).filter((_e) => !y.includes(_e) || M.has(_e) ? !1 : (M.add(_e), !0)).concat(y.filter((_e) => !M.has(_e)));
      if (!ne.length)
        return;
      le((_e) => _e.length === ne.length && _e.every((at, Nt) => at === ne[Nt]) ? _e : ne);
    }
    return d || ie(!0), () => {
      d = !0;
    };
  }, [q, L]);
  const mt = W.useMemo(() => Ye.length ? Ye.reduce((d, _) => {
    const y = De[_], M = typeof y == "number" && Number.isFinite(y) ? y : gr;
    return d + M;
  }, 0) : 0, [Ye, De]), gt = W.useMemo(() => {
    const d = Ye.length * tr;
    return !Number.isFinite(mt) || mt <= 0 ? d : Math.max(mt, d);
  }, [mt, Ye.length]), ft = W.useMemo(() => gt + Oe, [gt, Oe]), $ = W.useMemo(() => {
    if (!(!Number.isFinite(ft) || ft <= 0))
      return { width: `${ft}px`, minWidth: `${ft}px` };
  }, [ft]);
  W.useLayoutEffect(() => {
    const d = xe.current;
    if (!d || typeof window > "u")
      return;
    const _ = () => {
      const M = d.offsetWidth - d.clientWidth, O = d.clientWidth;
      Ve((_e) => _e === M ? _e : Math.max(0, M));
      const ne = Math.max(0, O - gt);
      st((_e) => _e === ne ? _e : ne);
    };
    _();
    const y = new ResizeObserver(_);
    return y.observe(d), window.addEventListener("resize", _), () => {
      y.disconnect(), window.removeEventListener("resize", _);
    };
  }, [gt]), W.useEffect(() => {
    const d = L.map((_) => String(_.key));
    le((_) => {
      const y = _.filter((Se) => d.includes(Se)), M = d.filter((Se) => !y.includes(Se)), O = y.concat(M);
      return _.length === O.length && _.every((Se, Ie) => Se === O[Ie]) ? _ : O;
    });
  }, [L]), W.useEffect(() => {
    !q || !Bt || !he || Wr(q, V);
  }, [V, q, he]);
  const K = W.useMemo(() => {
    if (!$e)
      return null;
    const d = $e.targetKey, _ = nt.length, y = nt.includes(d), M = _ <= 1 && y, O = L.find((Ie) => String(Ie.key) === d), ne = (O == null ? void 0 : O.displayText) ?? String(d), _e = V.every((Ie) => te[Ie] !== !1), Se = V.map((Ie) => {
      const at = L.find((et) => String(et.key) === Ie);
      if (!at)
        return null;
      const Nt = te[Ie] !== !1, Tt = Nt && _ <= 1;
      return {
        key: Ie,
        label: at.displayText,
        visible: Nt,
        disabled: Tt
      };
    }).filter((Ie) => Ie != null);
    return {
      ...$e,
      targetKey: d,
      targetDisplayText: ne,
      hideDisabled: M,
      allColumnsVisible: _e,
      columnItems: Se
    };
  }, [$e, V, te, L, nt]);
  W.useEffect(() => {
    const d = xt.current;
    d && ($e ? d.open({
      anchor: $e.anchor,
      placement: "bottom",
      align: "start",
      offset: 6
    }) : d.close());
  }, [$e]), W.useEffect(() => {
    Ue(null);
  }, [L, V]), W.useEffect(() => {
    x.current || e.initialRemoteState && (w(e.initialRemoteState), x.current = !0);
  }, [e.initialRemoteState]);
  const je = (d, _) => {
    Ke.current = _, ye(_), d.dataTransfer.effectAllowed = "move";
    try {
      d.dataTransfer.setData("text/plain", _);
    } catch (y) {
      console.warn("FlareDataGrid failed to set data on drag start.", y);
    }
  }, C = (d, _) => {
    d.preventDefault(), He(_);
  }, J = (d, _) => {
    d.preventDefault();
    const y = Ke.current;
    !y || y === _ || (le((M) => {
      var _e;
      const O = M.filter((Se) => Se !== y), ne = O.indexOf(_);
      return O.splice(ne, 0, y), (_e = e.onColumnReorder) == null || _e.call(e, O), O;
    }), Ke.current = null, He(null));
  }, ve = () => {
    He(null), Ke.current = null, ye(null);
  };
  W.useEffect(() => () => {
    Pe(), Q();
  }, []), W.useEffect(() => {
    e.initialPage != null && b(e.initialPage);
  }, [e.initialPage]), W.useEffect(() => {
    e.initialSort && h(e.initialSort);
  }, [(or = e.initialSort) == null ? void 0 : or.key, (wr = e.initialSort) == null ? void 0 : wr.direction]);
  const Te = W.useMemo(() => {
    const d = e.data ?? [];
    if (!s) return d;
    const _ = L.find((O) => String(O.key) === s.key);
    if (!_) return d;
    const y = _.accessor ? _.accessor : (O) => _a(O, String(_.key)), M = d.slice();
    return M.sort((O, ne) => {
      const _e = mo(y(O), y(ne));
      return s.direction === "asc" ? _e : -_e;
    }), M;
  }, [e.data, s, L]), Ae = S ? f.data ?? [] : Te, vt = Math.max(1, Math.ceil(Te.length / Z)), _t = e.totalRows ?? f.total, g = _t != null ? Math.max(1, Math.ceil(_t / Z)) : void 0, H = S ? g ?? void 0 : vt, D = W.useMemo(() => {
    if (S) return Ae;
    const d = (u - 1) * Z;
    return Ae.slice(d, d + Z);
  }, [S, Ae, u, Z]);
  W.useImperativeHandle(e.controllerRef, () => ({ data: Ae }), [Ae, e.controllerRef]);
  const I = (d) => {
    var M;
    const _ = String(d.currentTarget.dataset.key || "");
    d.currentTarget.dataset.sortable !== "false" && (h(
      (O) => !O || O.key !== _ ? { key: _, direction: "asc" } : { key: _, direction: O.direction === "asc" ? "desc" : "asc" }
    ), S && ((M = e.onPageChange) == null || M.call(e, 1)));
  }, Ce = W.useMemo(() => S ? g != null ? u < g : f.hasMore != null ? !!f.hasMore : ((Ae == null ? void 0 : Ae.length) ?? 0) === Z : u < H, [S, u, H, g, f.hasMore, Ae, Z]), Le = () => {
    var d;
    u !== 1 && (b(1), (d = e.onPageChange) == null || d.call(e, 1));
  }, Je = () => {
    var _;
    const d = Math.max(1, u - 1);
    d !== u && (b(d), (_ = e.onPageChange) == null || _.call(e, d));
  }, Ge = () => {
    var _;
    if (!Ce) return;
    const d = u + 1;
    b(d), (_ = e.onPageChange) == null || _.call(e, d);
  }, Ze = () => {
    var _;
    if (H == null) return;
    const d = H;
    u !== d && (b(d), (_ = e.onPageChange) == null || _.call(e, d));
  }, E = (d, _) => {
    d.preventDefault(), d.stopPropagation(), Ue({ anchor: d.currentTarget, targetKey: _ });
  }, l = () => {
    Ue(null);
  }, v = W.useRef(!1);
  W.useEffect(() => {
    var M, O;
    if (!S) return;
    const d = (((M = f.data) == null ? void 0 : M.length) ?? 0) === 0, _ = g == null, y = f.total != null || f.hasMore != null;
    if (u > 1 && d && _ && y && f.hasMore !== !0 && !v.current) {
      v.current = !0;
      const ne = u - 1;
      b(ne), (O = e.onPageChange) == null || O.call(e, ne);
    } else d || (v.current = !1);
  }, [S, f.data, f.total, f.hasMore, g, u]);
  const i = (d) => {
    var O;
    const _ = d.currentTarget.dataset.index;
    if (!_) return;
    const y = Number(_), M = S ? Ae[y] : Te[y];
    if (M != null) {
      if (e.rowDetails) {
        const ne = (u - 1) * Z + y, _e = e.rowKey ? e.rowKey(M, ne) : ne, Se = String(_e), Ie = X[Se];
        Ie != null && Ie.open ? oe((at) => ({ ...at, [Se]: { ...at[Se], open: !1 } })) : (oe((at) => ({ ...at, [Se]: { open: !0, loading: !(Ie != null && Ie.data), data: Ie == null ? void 0 : Ie.data } })), Ie != null && Ie.data || e.rowDetails.fetch(M).then((at) => {
          oe((Nt) => ({ ...Nt, [Se]: { open: !0, loading: !1, data: at } }));
        }).catch(() => {
          oe((at) => ({ ...at, [Se]: { open: !1, loading: !1 } }));
        }));
      }
      (O = e.onRowClick) == null || O.call(e, M, y);
    }
  }, m = (d) => {
    if (!e.onRowContextMenu) return;
    d.preventDefault(), d.stopPropagation();
    const _ = d.currentTarget.dataset.index;
    if (!_) return;
    const y = Number(_), M = S ? Ae[y] : Te[y];
    M != null && e.onRowContextMenu(M, y, d);
  }, U = (d) => {
    e.onRowClick && (d.key === "Enter" || d.key === " ") && (d.preventDefault(), d.currentTarget.click());
  }, de = () => {
    var _;
    if (!K || K.hideDisabled)
      return;
    const d = K.targetKey;
    (_ = K.columnItems.find((y) => y.key === d)) != null && _.visible && (ce((y) => y[d] === !1 || !V.filter((O) => O !== d && y[O] !== !1).length ? y : { ...y, [d]: !1 }), Ue(null));
  }, fe = () => {
    K && (K.allColumnsVisible || (ce((d) => {
      let _ = !1;
      const y = { ...d };
      return V.forEach((M) => {
        y[M] !== !0 && (y[M] = !0, _ = !0);
      }), _ ? y : d;
    }), Ue(null)));
  }, Re = (d, _) => {
    ce((y) => !_ && !V.filter((O) => O !== d && y[O] !== !1).length || y[d] === _ ? y : { ...y, [d]: _ });
  }, bt = Lt(
    ge["data-grid"],
    a === "rtl" && ge.rtl,
    e.bordered !== !1 && ge.bordered,
    e.compact && ge.compact,
    e.stickyHeader !== !1 && ge.sticky,
    We && ge.loading,
    e.className
  ), Qe = (() => {
    const d = D.length;
    if (d === 0)
      return `0 ${c.rows}`;
    const _ = (u - 1) * Z + 1, y = _ + d - 1;
    if (S)
      return _t != null ? `${_}–${y} ${c.of} ${_t}` : `${_}–${y}`;
    const M = Te.length;
    return `${_}–${Math.min(u * Z, M)} ${c.of} ${M}`;
  })(), ot = /* @__PURE__ */ n.jsxs("colgroup", { children: [
    Ye.map((d) => {
      const _ = De[String(d)] ?? gr;
      return /* @__PURE__ */ n.jsx(
        "col",
        {
          style: { width: `${_}px` }
        },
        String(d)
      );
    }),
    /* @__PURE__ */ n.jsx("col", { style: { width: `${Math.max(0, Oe)}px` } })
  ] }), St = (d) => {
    $e && l(), Be.current && (Be.current.scrollLeft = d.currentTarget.scrollLeft);
  }, Kt = () => {
    const d = qe.current ?? Xe.current;
    if (!d)
      return;
    const _ = Array.from(d.querySelectorAll("th[data-key]"));
    _.length && (F((y) => {
      let M = !1;
      const O = { ...y };
      return _.forEach((ne) => {
        var Ie;
        const _e = ne.dataset.key;
        if (!_e)
          return;
        const Se = re(ne, qe.current);
        Se && O[_e] !== Se && (O[_e] = Se, M = !0, (Ie = e.onColumnResize) == null || Ie.call(e, _e, Se));
      }), M ? O : y;
    }), Ue(null));
  }, Vt = /* @__PURE__ */ n.jsxs("tr", { children: [
    Ye.map((d, _) => {
      const y = L.find((et) => String(et.key) === d), M = !!(s && s.key === String(y.key)), O = M ? s == null ? void 0 : s.direction : void 0, ne = De[String(y.key)] ?? gr, _e = {
        textAlign: y.align ?? (a === "rtl" ? "right" : "left"),
        width: ne,
        minWidth: ne
      }, Se = y.sortable ?? !S, Ie = Lt(
        ge["data-grid-header-cell"],
        _ === Ye.length - 1 && ge["last-column"],
        Se && ge.sortable,
        rt === String(y.key) && ge["drag-over"],
        ae === String(y.key) && ge.dragging
      ), at = M ? O : "none", Nt = Lt(
        ge["data-grid-sort-indicator"],
        at === "asc" && ge.asc,
        at === "desc" && ge.desc,
        at === "none" && ge.none
      ), Tt = M ? O === "asc" ? "ascending" : "descending" : "none";
      return /* @__PURE__ */ n.jsxs(
        "th",
        {
          "data-key": String(y.key),
          style: _e,
          draggable: !0,
          onDragStart: (et) => je(et, String(y.key)),
          onDragOver: (et) => C(et, String(y.key)),
          onDrop: (et) => J(et, String(y.key)),
          onDragEnd: ve,
          onContextMenu: (et) => E(et, String(y.key)),
          className: Ie,
          "aria-sort": Tt,
          scope: "col",
          children: [
            /* @__PURE__ */ n.jsxs(
              "button",
              {
                type: "button",
                className: ge["data-grid-header-button"],
                "data-key": String(y.key),
                "data-sortable": String(Se),
                onClick: I,
                disabled: !Se,
                "aria-label": Se ? c.sortColumn(y.displayText, M ? O : void 0) : `${y.displayText}`,
                children: [
                  /* @__PURE__ */ n.jsx("span", { className: ge["data-grid-header-label"], children: y.displayText }),
                  Se ? /* @__PURE__ */ n.jsx("span", { className: Nt, "aria-hidden": !0 }) : null
                ]
              }
            ),
            /* @__PURE__ */ n.jsx(
              "div",
              {
                className: ge["data-grid-column-resizer"],
                onPointerDown: (et) => p(et, String(y.key)),
                onDoubleClick: (et) => z(et, String(y.key)),
                role: "separator",
                "aria-orientation": "vertical",
                "aria-label": c.resizeColumn(y.displayText)
              }
            )
          ]
        },
        String(y.key)
      );
    }),
    /* @__PURE__ */ n.jsx(
      "th",
      {
        className: Lt(ge["data-grid-header-cell"], ge.stub),
        "aria-hidden": "true",
        scope: "col",
        style: { width: `${Math.max(0, Oe)}px` }
      }
    )
  ] }), jt = /* @__PURE__ */ n.jsx("thead", { className: ge["data-grid-head"], children: Vt });
  return /* @__PURE__ */ n.jsxs(
    "div",
    {
      ref: r,
      className: bt,
      dir: e.direction === "auto" || e.direction == null ? void 0 : e.direction,
      children: [
        e.stickyHeader === !1 ? null : /* @__PURE__ */ n.jsx(
          "div",
          {
            className: ge["data-grid-header"],
            ref: Be,
            "aria-hidden": "true",
            style: { paddingInlineEnd: ue ? `${ue}px` : void 0 },
            children: /* @__PURE__ */ n.jsxs("table", { ref: qe, className: ge["data-grid-table"], style: $, children: [
              ot,
              jt
            ] })
          }
        ),
        /* @__PURE__ */ n.jsx(
          "div",
          {
            className: ge["data-grid-viewport"],
            ref: xe,
            role: "region",
            "aria-live": "polite",
            onScroll: St,
            children: /* @__PURE__ */ n.jsxs(
              "table",
              {
                ref: Xe,
                className: ge["data-grid-table"],
                style: $,
                "aria-label": e.ariaLabel ?? "Data grid",
                children: [
                  ot,
                  e.stickyHeader === !1 ? jt : null,
                  /* @__PURE__ */ n.jsx("tbody", { className: ge["data-grid-body"], children: D.length === 0 ? /* @__PURE__ */ n.jsx("tr", { children: /* @__PURE__ */ n.jsx("td", { className: ge["data-grid-empty"], colSpan: Math.max(1, Ye.length + 1), children: e.emptyMessage ?? c.noData }) }) : /* @__PURE__ */ n.jsx(n.Fragment, { children: D.map((d, _) => {
                    var at;
                    const y = (u - 1) * Z + _, M = S ? _ : y, O = e.rowKey ? e.rowKey(d, y) : y, ne = X[String(O)], _e = e.zebra === !1 ? null : y % 2 === 0 ? ge["zebra-odd"] : ge["zebra-even"], Se = Lt(
                      ge["data-grid-row"],
                      _e,
                      (e.onRowClick || e.rowDetails) && ge.interactive
                    ), Ie = !!(e.onRowClick || e.rowDetails);
                    return /* @__PURE__ */ n.jsxs(W.Fragment, { children: [
                      /* @__PURE__ */ n.jsxs(
                        "tr",
                        {
                          className: Se,
                          "data-index": String(M),
                          onClick: Ie ? i : void 0,
                          onContextMenu: e.onRowContextMenu ? m : void 0,
                          tabIndex: Ie ? 0 : void 0,
                          onKeyDown: Ie ? U : void 0,
                          "aria-label": Ie ? c.activateRow : void 0,
                          children: [
                            Ye.map((Nt, Tt) => {
                              const et = L.find((Va) => String(Va.key) === Nt), It = et.accessor != null ? et.accessor(d) : _a(d, String(et.key)), zt = et.render != null ? et.render(It, d, y) : It, Ot = De[String(et.key)] ?? gr, lr = {
                                textAlign: et.align ?? (a === "rtl" ? "right" : "left"),
                                width: Ot,
                                minWidth: Ot
                              }, Ut = typeof zt == "string" || typeof zt == "number" || typeof zt == "boolean" ? String(zt) : void 0;
                              return /* @__PURE__ */ n.jsx(
                                "td",
                                {
                                  className: Lt(
                                    ge["data-grid-cell"],
                                    Tt === Ye.length - 1 && ge["last-column"]
                                  ),
                                  style: lr,
                                  title: Ut,
                                  children: zt ?? ""
                                },
                                String(et.key) + "_" + Tt
                              );
                            }),
                            /* @__PURE__ */ n.jsx(
                              "td",
                              {
                                className: Lt(ge["data-grid-cell"], ge.stub),
                                "aria-hidden": "true",
                                style: { width: `${Math.max(0, Oe)}px` }
                              }
                            )
                          ]
                        }
                      ),
                      e.rowDetails && ne ? /* @__PURE__ */ n.jsx(
                        "tr",
                        {
                          className: Lt(
                            ge["data-grid-details-row"],
                            ne.open && ge.open
                          ),
                          children: /* @__PURE__ */ n.jsx(
                            "td",
                            {
                              colSpan: Ye.length + 1,
                              className: Lt(
                                ge["data-grid-details-cell"],
                                ne.open && ge.open
                              ),
                              children: /* @__PURE__ */ n.jsx(
                                "div",
                                {
                                  className: Lt(
                                    ge["data-grid-details"],
                                    ne.open && ge.open
                                  ),
                                  children: ne.loading ? /* @__PURE__ */ n.jsx("div", { className: ge["data-grid-details-loading"], children: /* @__PURE__ */ n.jsx("div", { className: ge["data-grid-spinner"] }) }) : ne.data && ((at = e.rowDetails) != null && at.render) ? e.rowDetails.render(d, ne.data) : null
                                }
                              )
                            }
                          )
                        }
                      ) : null
                    ] }, O);
                  }) }) })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ n.jsxs("div", { className: ge["data-grid-footer"], role: "contentinfo", children: [
          /* @__PURE__ */ n.jsx("div", { className: ge["data-grid-footer-summary"], children: Qe }),
          /* @__PURE__ */ n.jsxs("div", { className: ge["data-grid-pager"], children: [
            /* @__PURE__ */ n.jsx("button", { className: ge["data-grid-pager-button"], onClick: Le, disabled: u === 1, "aria-label": c.firstPage, children: a === "rtl" ? "»" : "«" }),
            /* @__PURE__ */ n.jsx("button", { className: ge["data-grid-pager-button"], onClick: Je, disabled: u === 1, "aria-label": c.previousPage, children: a === "rtl" ? "›" : "‹" }),
            /* @__PURE__ */ n.jsx("span", { className: ge["data-grid-page"], children: H ? `${u} / ${H}` : `${u}` }),
            /* @__PURE__ */ n.jsx("button", { className: ge["data-grid-pager-button"], onClick: Ge, disabled: !Ce, "aria-label": c.nextPage, children: a === "rtl" ? "‹" : "›" }),
            /* @__PURE__ */ n.jsx("button", { className: ge["data-grid-pager-button"], onClick: Ze, disabled: !H || u === H, "aria-label": c.lastPage, children: a === "rtl" ? "«" : "»" })
          ] })
        ] }),
        We ? /* @__PURE__ */ n.jsx("div", { className: ge["data-grid-overlay"], "aria-hidden": !0, children: /* @__PURE__ */ n.jsx("div", { className: ge["data-grid-spinner"] }) }) : null,
        /* @__PURE__ */ n.jsx(
          La,
          {
            ref: xt,
            role: "menu",
            "aria-label": c.columnsMenu,
            closeOnEscape: !0,
            closeOnOutsidePointerDown: !0,
            onRequestClose: () => {
              Ue(null);
            },
            children: K ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
              /* @__PURE__ */ n.jsx(
                Ar,
                {
                  onClick: de,
                  disabled: K.hideDisabled,
                  children: c.hideColumn(K.targetDisplayText)
                }
              ),
              /* @__PURE__ */ n.jsx(Ar, { onClick: Kt, children: c.autoSizeColumns }),
              /* @__PURE__ */ n.jsx(Gn, {}),
              /* @__PURE__ */ n.jsx(Xn, { children: c.columns }),
              /* @__PURE__ */ n.jsx(
                Ar,
                {
                  onClick: fe,
                  disabled: K.allColumnsVisible,
                  children: c.showAllColumns
                }
              ),
              K.columnItems.map((d) => /* @__PURE__ */ n.jsx(
                Yn,
                {
                  label: d.label,
                  checked: d.visible,
                  disabled: d.disabled,
                  onChange: (_) => Re(d.key, _)
                },
                d.key
              ))
            ] }) : null
          }
        )
      ]
    }
  );
}
function fo(e) {
  const t = [], r = /[^.[\]]+|\[(?:([^"'[\]]+)|"((?:[^"\\]|\\.)*)"|'((?:[^'\\]|\\.)*)')\]/g;
  return e.replace(r, (a, o, c, s) => {
    var u, b, f;
    let h = o ?? c ?? s ?? a;
    return h = (f = (u = h.replace) == null ? void 0 : (b = u.call(h, /\\"/g, '"')).replace) == null ? void 0 : f.call(b, /\\'/g, "'"), t.push(h), "";
  }), t;
}
function _a(e, t) {
  return e == null || !t ? e : fo(t).reduce((a, o) => a == null ? a : a[o], e);
}
function mo(e, t) {
  const r = (h) => h == null || h === "";
  if (r(e) && r(t)) return 0;
  if (r(e)) return 1;
  if (r(t)) return -1;
  const a = typeof e == "number" ? e : Number(e), o = typeof t == "number" ? t : Number(t);
  if (!Number.isNaN(a) && !Number.isNaN(o)) return a - o;
  const c = e instanceof Date ? e : new Date(e), s = t instanceof Date ? t : new Date(t);
  return !Number.isNaN(+c) && !Number.isNaN(+s) ? +c - +s : String(e).localeCompare(String(t), void 0, { numeric: !0, sensitivity: "base" });
}
const ht = {
  "flare-floating-window-overlay": "_flare-floating-window-overlay_w32sa_1",
  "flare-floating-window": "_flare-floating-window_w32sa_1",
  "is-dragging": "_is-dragging_w32sa_59",
  "is-resizing": "_is-resizing_w32sa_59",
  "flare-floating-window-titlebar": "_flare-floating-window-titlebar_w32sa_69",
  "is-minimized": "_is-minimized_w32sa_72",
  "flare-floating-window-identity": "_flare-floating-window-identity_w32sa_106",
  "flare-floating-window-controls": "_flare-floating-window-controls_w32sa_107",
  "flare-floating-window-title-icon": "_flare-floating-window-title-icon_w32sa_117",
  "flare-floating-window-title-copy": "_flare-floating-window-title-copy_w32sa_122",
  "flare-floating-window-title": "_flare-floating-window-title_w32sa_69",
  "flare-floating-window-subtitle": "_flare-floating-window-subtitle_w32sa_128",
  "flare-floating-window-control": "_flare-floating-window-control_w32sa_107",
  "flare-floating-window-close": "_flare-floating-window-close_w32sa_193",
  "flare-floating-window-header": "_flare-floating-window-header_w32sa_198",
  "flare-floating-window-footer": "_flare-floating-window-footer_w32sa_199",
  "flare-floating-window-body": "_flare-floating-window-body_w32sa_215",
  "flare-floating-window-resize-handles": "_flare-floating-window-resize-handles_w32sa_223",
  "flare-floating-window-resize-handle": "_flare-floating-window-resize-handle_w32sa_223",
  "is-n": "_is-n_w32sa_244",
  "is-s": "_is-s_w32sa_250",
  "is-e": "_is-e_w32sa_256",
  "is-w": "_is-w_w32sa_262",
  "is-ne": "_is-ne_w32sa_268",
  "is-nw": "_is-nw_w32sa_275",
  "is-se": "_is-se_w32sa_282",
  "is-sw": "_is-sw_w32sa_289"
}, ho = ["n", "s", "e", "w", "ne", "nw", "se", "sw"], go = {
  close: "Close window",
  minimize: "Minimize window",
  maximize: "Maximize window",
  restore: "Restore window",
  resize: "Resize window"
}, Nr = {
  close: /* @__PURE__ */ n.jsx("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: /* @__PURE__ */ n.jsx("path", { d: "M6 6l12 12M18 6L6 18" }) }),
  minimize: /* @__PURE__ */ n.jsx("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: /* @__PURE__ */ n.jsx("path", { d: "M5 12h14" }) }),
  maximize: /* @__PURE__ */ n.jsx("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: /* @__PURE__ */ n.jsx("rect", { x: "5", y: "5", width: "14", height: "14", rx: "1" }) }),
  restore: /* @__PURE__ */ n.jsxs("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: [
    /* @__PURE__ */ n.jsx("rect", { x: "8", y: "5", width: "11", height: "11", rx: "1" }),
    /* @__PURE__ */ n.jsx("path", { d: "M5 8v11h11" })
  ] })
}, $t = [];
function Dr(e) {
  return Number(e.toFixed(3));
}
function bo(e, t) {
  return e.left === t.left && e.top === t.top && e.width === t.width && e.height === t.height;
}
function wa(e) {
  const t = [
    "a[href]",
    "button:not([disabled])",
    'input:not([disabled]):not([type="hidden"])',
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ].join(",");
  return Array.from(e.querySelectorAll(t)).filter(
    (r) => !r.hasAttribute("disabled") && r.getAttribute("aria-hidden") !== "true"
  );
}
function Uo(e) {
  var Ae, vt, _t, g, H;
  const t = Rt().replace(/:/g, ""), r = e.id ?? `flare-floating-window-${t}`, a = `${r}-title`, o = me(null), c = me(null), s = me(null), h = me(e.rect), u = me("normal"), b = me(null), f = me(null), w = me(!1), x = e.minWidth ?? 320, k = e.minHeight ?? 240, N = e.viewportPadding ?? 12, j = e.visibleTitlebarWidth ?? 84, F = e.movable ?? !0, B = e.resizable ?? !0, A = e.minimizable ?? !0, P = e.maximizable ?? !0, Y = e.closable ?? !0, X = e.closeOnEscape ?? !0, oe = e.restoreFocus ?? !0, G = e.trapFocus ?? e.modal ?? !1, S = { ...go, ...e.labels }, Z = {
    close: ((Ae = e.icons) == null ? void 0 : Ae.close) ?? Nr.close,
    minimize: ((vt = e.icons) == null ? void 0 : vt.minimize) ?? Nr.minimize,
    maximize: ((_t = e.icons) == null ? void 0 : _t.maximize) ?? Nr.maximize,
    restore: ((g = e.icons) == null ? void 0 : g.restore) ?? Nr.restore
  }, We = (D) => {
    const I = Math.max(1, window.innerWidth - N), Ce = Math.max(1, window.innerHeight - N), Le = Dr(Math.max(Math.min(x, I), Math.min(I, D.width))), Je = Dr(Math.max(Math.min(k, Ce), Math.min(Ce, D.height))), Ge = Math.min(0, j - Le), Ze = Math.max(0, window.innerWidth - j), E = Math.max(0, window.innerHeight - 48);
    return {
      left: Dr(Math.max(Ge, Math.min(Ze, D.left))),
      top: Dr(Math.max(0, Math.min(E, D.top))),
      width: Le,
      height: Je
    };
  }, be = (D, I, Ce, Le) => {
    let Je = D.left, Ge = D.top, Ze = D.width, E = D.height;
    return I.includes("e") && (Ze += Ce), I.includes("s") && (E += Le), I.includes("w") && (Ze -= Ce, Je += Ce), I.includes("n") && (E -= Le, Ge += Le), Ze < x && (I.includes("w") && (Je -= x - Ze), Ze = x), E < k && (I.includes("n") && (Ge -= k - E), E = k), We({ left: Je, top: Ge, width: Ze, height: E });
  }, ee = (D) => {
    e.onOpenChange(!1, D);
  }, q = () => {
    const D = $t.lastIndexOf(r);
    D >= 0 && $t.splice(D, 1), $t.push(r);
  };
  pe(() => {
    if (e.open)
      return $t.push(r), () => {
        const D = $t.lastIndexOf(r);
        D >= 0 && $t.splice(D, 1);
      };
  }, [e.open, r]), pe(() => {
    var D;
    if (e.open && !w.current) {
      const I = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      b.current = I, f.current = (I == null ? void 0 : I.closest(".flare-ui-theme")) ?? null, e.autoFocus && requestAnimationFrame(() => {
        const Ce = o.current;
        Ce && (wa(Ce)[0] ?? Ce).focus();
      });
    } else !e.open && w.current && oe && ((D = b.current) == null || D.focus());
    w.current = e.open;
  }, [e.open, e.autoFocus, oe]), pe(() => {
    e.mode === "normal" && (h.current = e.rect);
  }, [e.mode, e.rect]), pe(() => {
    if (!e.open || e.mode !== "normal") return;
    const D = () => {
      const I = We(e.rect);
      (I.left !== e.rect.left || I.top !== e.rect.top || I.width !== e.rect.width || I.height !== e.rect.height) && e.onRectChange(I);
    };
    return window.addEventListener("resize", D), () => window.removeEventListener("resize", D);
  }, [
    e.open,
    e.mode,
    e.rect,
    e.onRectChange,
    x,
    k,
    N,
    j
  ]), pe(() => {
    var D;
    return e.open || (D = s.current) == null || D.call(s), () => {
      var I;
      return (I = s.current) == null ? void 0 : I.call(s);
    };
  }, [e.open]), pe(() => {
    if (!e.open) return;
    const D = (I) => {
      var Le;
      if ($t[$t.length - 1] !== r) return;
      if (I.key === "Tab" && G) {
        const Je = o.current;
        if (!Je) return;
        const Ge = wa(Je);
        if (Ge.length === 0) {
          I.preventDefault(), Je.focus();
          return;
        }
        const Ze = Ge[0], E = Ge[Ge.length - 1];
        I.shiftKey && document.activeElement === Ze ? (I.preventDefault(), E.focus()) : !I.shiftKey && document.activeElement === E && (I.preventDefault(), Ze.focus());
        return;
      }
      if (I.key !== "Escape" || I.defaultPrevented || !X) return;
      const Ce = I.target instanceof Element ? I.target.closest('[role="dialog"]') : null;
      Ce && Ce !== o.current || (Le = e.onEscapeKeyDown) != null && Le.call(e, I) || (I.preventDefault(), ee("escape"));
    };
    return document.addEventListener("keydown", D), () => document.removeEventListener("keydown", D);
  }, [e.open, e.onEscapeKeyDown, X, G, r]), pe(() => {
    if (!e.open || !e.closeOnOutsidePointerDown || e.modal) return;
    const D = (I) => {
      var Ce, Le;
      $t[$t.length - 1] === r && ((Ce = o.current) != null && Ce.contains(I.target) || (Le = e.outsidePointerDownIgnore) != null && Le.call(e, I.target) || ee("outside"));
    };
    return document.addEventListener("pointerdown", D), () => document.removeEventListener("pointerdown", D);
  }, [e.open, e.closeOnOutsidePointerDown, e.modal, e.outsidePointerDownIgnore, r]);
  const T = (D, I) => {
    var l, v;
    if (D.button !== 0 || e.mode === "maximized") return;
    const Ce = D.target;
    if (!I && (!F || Ce.closest("button,input,select,textarea,a,[data-flare-window-no-drag]")) || I && (!B || e.mode !== "normal")) return;
    const Le = o.current;
    if (!Le) return;
    D.preventDefault(), I && D.stopPropagation();
    const Je = {
      pointerId: D.pointerId,
      startX: D.clientX,
      startY: D.clientY,
      startRect: e.rect,
      nextRect: e.rect,
      panel: Le,
      handle: D.currentTarget,
      direction: I
    };
    c.current = Je, Le.classList.add(ht[I ? "is-resizing" : "is-dragging"]), (v = (l = D.currentTarget).setPointerCapture) == null || v.call(l, D.pointerId);
    const Ge = (i) => {
      const m = c.current;
      if (!m || m.pointerId !== i.pointerId) return;
      const U = i.clientX - m.startX, de = i.clientY - m.startY;
      m.nextRect = m.direction ? be(m.startRect, m.direction, U, de) : We({
        ...m.startRect,
        left: m.startRect.left + U,
        top: m.startRect.top + de
      }), m.panel.style.left = `${m.nextRect.left}px`, m.panel.style.top = `${m.nextRect.top}px`, m.panel.style.width = `${m.nextRect.width}px`, m.panel.style.height = `${m.nextRect.height}px`;
    }, Ze = () => {
      window.removeEventListener("pointermove", Ge, !0), window.removeEventListener("pointerup", E, !0), window.removeEventListener("pointercancel", E, !0), window.removeEventListener("blur", E, !0), s.current = null;
    }, E = (i) => {
      var U, de;
      const m = c.current;
      !m || i instanceof PointerEvent && i.pointerId !== m.pointerId || (m.panel.classList.remove(ht["is-dragging"], ht["is-resizing"]), (de = (U = m.handle).hasPointerCapture) != null && de.call(U, m.pointerId) && m.handle.releasePointerCapture(m.pointerId), c.current = null, Ze(), h.current = m.nextRect, bo(m.startRect, m.nextRect) || e.onRectChange(m.nextRect));
    };
    s.current = Ze, window.addEventListener("pointermove", Ge, !0), window.addEventListener("pointerup", E, !0), window.addEventListener("pointercancel", E, !0), window.addEventListener("blur", E, !0);
  }, L = (D, I) => {
    if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(I.key)) return;
    I.preventDefault();
    const Ce = I.shiftKey ? 32 : 8, Le = I.key === "ArrowLeft" ? -Ce : I.key === "ArrowRight" ? Ce : 0, Je = I.key === "ArrowUp" ? -Ce : I.key === "ArrowDown" ? Ce : 0, Ge = be(e.rect, D, Le, Je);
    h.current = Ge, e.onRectChange(Ge);
  }, ke = () => {
    if (e.mode === "maximized") {
      e.onRectChange(h.current), e.onModeChange("normal");
      return;
    }
    e.mode === "normal" && (h.current = e.rect), e.onModeChange("maximized");
  }, te = () => {
    if (e.mode === "minimized") {
      const D = u.current;
      D === "normal" && e.onRectChange(h.current), e.onModeChange(D);
      return;
    }
    u.current = e.mode, e.mode === "normal" && (h.current = e.rect), e.onModeChange("minimized");
  };
  if (!e.open || typeof document > "u") return null;
  const {
    open: ce,
    onOpenChange: we,
    title: Fe,
    titleIcon: De,
    subtitle: Ee,
    headerActions: Me,
    header: Be,
    footer: qe,
    children: Xe,
    mode: xe,
    onModeChange: ue,
    rect: Ve,
    onRectChange: Oe,
    minWidth: st,
    minHeight: Pe,
    viewportPadding: dt,
    visibleTitlebarWidth: ut,
    movable: Q,
    resizable: se,
    minimizable: re,
    maximizable: p,
    closable: z,
    modal: V,
    trapFocus: le,
    autoFocus: he,
    restoreFocus: ie,
    closeOnEscape: rt,
    closeOnOutsidePointerDown: He,
    outsidePointerDownIgnore: ae,
    onEscapeKeyDown: ye,
    labels: Ke,
    icons: $e,
    portalTarget: Ue,
    zIndex: xt,
    className: nt,
    style: Ye,
    ...mt
  } = e, gt = [
    ht["flare-floating-window"],
    ht[`is-${xe}`],
    nt
  ].filter(Boolean).join(" "), ft = ((H = c.current) == null ? void 0 : H.nextRect) ?? Ve, $ = xe === "maximized" ? { inset: N, zIndex: xt, ...Ye } : {
    left: ft.left,
    top: ft.top,
    width: ft.width,
    height: xe === "minimized" ? "auto" : ft.height,
    zIndex: xt,
    ...Ye
  }, K = Ue ?? f.current ?? (document.activeElement instanceof Element ? document.activeElement.closest(".flare-ui-theme") : null) ?? document.querySelector(".flare-ui-theme") ?? document.getElementById("root") ?? document.body, je = xe === "minimized" ? S.restore : S.minimize, C = xe === "maximized" ? S.restore : S.maximize, J = xe === "minimized" ? Z.restore : Z.minimize, ve = xe === "maximized" ? Z.restore : Z.maximize, Te = /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    V ? /* @__PURE__ */ n.jsx("div", { className: ht["flare-floating-window-overlay"], "aria-hidden": "true" }) : null,
    /* @__PURE__ */ n.jsxs(
      "section",
      {
        ...mt,
        ref: o,
        id: r,
        className: gt,
        style: $,
        role: "dialog",
        "aria-modal": V ?? !1,
        "aria-labelledby": a,
        tabIndex: -1,
        onPointerDownCapture: (D) => {
          var I;
          q(), (I = mt.onPointerDownCapture) == null || I.call(mt, D);
        },
        onFocusCapture: (D) => {
          var I;
          q(), (I = mt.onFocusCapture) == null || I.call(mt, D);
        },
        children: [
          /* @__PURE__ */ n.jsxs(
            "div",
            {
              className: ht["flare-floating-window-titlebar"],
              onPointerDown: (D) => T(D),
              onDoubleClick: (D) => {
                const I = D.target;
                !P || e.mode === "minimized" || I.closest("button,input,select,textarea,a,[data-flare-window-no-drag]") || ke();
              },
              children: [
                /* @__PURE__ */ n.jsxs("div", { className: ht["flare-floating-window-identity"], children: [
                  De ? /* @__PURE__ */ n.jsx("span", { className: ht["flare-floating-window-title-icon"], children: De }) : null,
                  /* @__PURE__ */ n.jsxs("span", { className: ht["flare-floating-window-title-copy"], children: [
                    /* @__PURE__ */ n.jsx("strong", { id: a, className: ht["flare-floating-window-title"], dir: "auto", children: Fe }),
                    Ee ? /* @__PURE__ */ n.jsx("small", { className: ht["flare-floating-window-subtitle"], dir: "auto", children: Ee }) : null
                  ] })
                ] }),
                /* @__PURE__ */ n.jsxs("div", { className: ht["flare-floating-window-controls"], "data-flare-window-no-drag": !0, children: [
                  Me,
                  A ? /* @__PURE__ */ n.jsx(
                    "button",
                    {
                      type: "button",
                      className: ht["flare-floating-window-control"],
                      onClick: te,
                      "aria-label": je,
                      title: je,
                      children: /* @__PURE__ */ n.jsx("span", { "aria-hidden": "true", children: J })
                    }
                  ) : null,
                  P && xe !== "minimized" ? /* @__PURE__ */ n.jsx(
                    "button",
                    {
                      type: "button",
                      className: ht["flare-floating-window-control"],
                      onClick: ke,
                      "aria-label": C,
                      title: C,
                      children: /* @__PURE__ */ n.jsx("span", { "aria-hidden": "true", children: ve })
                    }
                  ) : null,
                  Y ? /* @__PURE__ */ n.jsx(
                    "button",
                    {
                      type: "button",
                      className: `${ht["flare-floating-window-control"]} ${ht["flare-floating-window-close"]}`,
                      onClick: () => ee("close-button"),
                      "aria-label": S.close,
                      title: S.close,
                      children: /* @__PURE__ */ n.jsx("span", { "aria-hidden": "true", children: Z.close })
                    }
                  ) : null
                ] })
              ]
            }
          ),
          xe !== "minimized" ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
            Be ? /* @__PURE__ */ n.jsx("div", { className: ht["flare-floating-window-header"], children: Be }) : null,
            /* @__PURE__ */ n.jsx("div", { className: ht["flare-floating-window-body"], children: Xe }),
            qe ? /* @__PURE__ */ n.jsx("div", { className: ht["flare-floating-window-footer"], children: qe }) : null,
            B && xe === "normal" ? /* @__PURE__ */ n.jsx("div", { className: ht["flare-floating-window-resize-handles"], children: ho.map((D) => /* @__PURE__ */ n.jsx(
              "button",
              {
                type: "button",
                className: `${ht["flare-floating-window-resize-handle"]} ${ht[`is-${D}`]}`,
                "data-flare-window-no-drag": !0,
                "aria-label": `${S.resize}: ${D}`,
                onPointerDown: (I) => T(I, D),
                onKeyDown: (I) => L(D, I)
              },
              D
            )) }) : null
          ] }) : null
        ]
      }
    )
  ] });
  return Xr(Te, K);
}
const it = {
  "flare-drawer": "_flare-drawer_1tvua_1",
  "flare-drawer-enter": "_flare-drawer-enter_1tvua_1",
  "is-start": "_is-start_1tvua_32",
  "is-end": "_is-end_1tvua_33",
  "flare-drawer-enter-start": "_flare-drawer-enter-start_1tvua_1",
  "flare-drawer-enter-end": "_flare-drawer-enter-end_1tvua_1",
  "is-top": "_is-top_1tvua_58",
  "is-bottom": "_is-bottom_1tvua_59",
  "flare-drawer-enter-top": "_flare-drawer-enter-top_1tvua_1",
  "flare-drawer-enter-bottom": "_flare-drawer-enter-bottom_1tvua_1",
  "flare-drawer__backdrop": "_flare-drawer__backdrop_1tvua_76",
  "flare-drawer-backdrop-enter": "_flare-drawer-backdrop-enter_1tvua_1",
  "flare-drawer__header": "_flare-drawer__header_1tvua_84",
  "flare-drawer__footer": "_flare-drawer__footer_1tvua_85",
  "flare-drawer__identity": "_flare-drawer__identity_1tvua_100",
  "flare-drawer__title-copy": "_flare-drawer__title-copy_1tvua_106",
  "flare-drawer__title": "_flare-drawer__title_1tvua_106",
  "flare-drawer__subtitle": "_flare-drawer__subtitle_1tvua_120",
  "flare-drawer__header-actions": "_flare-drawer__header-actions_1tvua_125",
  "flare-drawer__close": "_flare-drawer__close_1tvua_131",
  "flare-drawer__item": "_flare-drawer__item_1tvua_132",
  "flare-drawer__toggle": "_flare-drawer__toggle_1tvua_133",
  "flare-drawer__body": "_flare-drawer__body_1tvua_158",
  "flare-drawer-content-enter": "_flare-drawer-content-enter_1tvua_1",
  "flare-drawer__navigation": "_flare-drawer__navigation_1tvua_166",
  "flare-drawer__root-list": "_flare-drawer__root-list_1tvua_167",
  "flare-drawer__list": "_flare-drawer__list_1tvua_168",
  "flare-drawer__row": "_flare-drawer__row_1tvua_182",
  "is-active": "_is-active_1tvua_219",
  "is-disabled": "_is-disabled_1tvua_226",
  "flare-drawer__item-label": "_flare-drawer__item-label_1tvua_234",
  "flare-drawer__icon": "_flare-drawer__icon_1tvua_242",
  "flare-drawer__end": "_flare-drawer__end_1tvua_242",
  "flare-drawer__disclosure": "_flare-drawer__disclosure_1tvua_242",
  "flare-drawer__submenu": "_flare-drawer__submenu_1tvua_280",
  "flare-drawer-submenu-enter": "_flare-drawer-submenu-enter_1tvua_1"
}, vo = {
  close: "Close drawer",
  navigation: "Navigation",
  expand: (e) => `Expand ${e}`,
  collapse: (e) => `Collapse ${e}`
};
function xa(e) {
  return Array.from(e.querySelectorAll(
    'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
  )).filter((t) => t.getAttribute("aria-hidden") !== "true");
}
function _o(e, t = []) {
  const r = new Set(t), a = (o, c) => {
    var h;
    if (c.includes(o.id)) return !1;
    (o.defaultExpanded || o.active) && r.add(o.id);
    const s = ((h = o.children) == null ? void 0 : h.some((u) => a(u, [...c, o.id]))) ?? !1;
    return s && r.add(o.id), !!(o.active || s);
  };
  return e.forEach((o) => a(o, [])), [...r];
}
function wo() {
  return /* @__PURE__ */ n.jsx("svg", { "aria-hidden": "true", viewBox: "0 0 24 24", width: "1em", height: "1em", focusable: "false", children: /* @__PURE__ */ n.jsx("path", { d: "m6 6 12 12M18 6 6 18", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }) });
}
function ya() {
  return /* @__PURE__ */ n.jsx("svg", { "aria-hidden": "true", viewBox: "0 0 24 24", width: "1em", height: "1em", focusable: "false", children: /* @__PURE__ */ n.jsx("path", { d: "m9 6 6 6-6 6", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
}
function Yo(e) {
  const { messages: t } = fr(), r = Rt().replace(/:/g, ""), a = e.id ?? `flare-drawer-${r}`, o = `${a}-title`, c = me(null), s = me(null), h = me(null), [u, b] = Ne(() => _o(e.items ?? [], e.defaultExpandedItemIds)), f = e.expandedItemIds ?? u, w = { ...vo, ...t.drawer, ...e.labels }, x = e.modal ?? !0, k = e.trapFocus ?? x, N = e.closeOnEscape ?? !0, j = e.closeOnBackdropClick ?? !0, F = e.closeOnOutsidePointerDown ?? !x, B = e.closeOnItemSelect ?? !0, A = e.autoFocus ?? !0, P = e.restoreFocus ?? !0, Y = (re) => e.onOpenChange(!1, re), X = (re) => {
    var p;
    e.expandedItemIds === void 0 && b(re), (p = e.onExpandedItemIdsChange) == null || p.call(e, re);
  };
  pe(() => {
    var re;
    if (e.open)
      return s.current = document.activeElement instanceof HTMLElement ? document.activeElement : null, h.current = ((re = s.current) == null ? void 0 : re.closest(".flare-ui-theme")) ?? null, A && requestAnimationFrame(() => {
        var p;
        return (p = xa(c.current ?? document.body)[0] ?? c.current) == null ? void 0 : p.focus();
      }), () => {
        var p;
        P && ((p = s.current) == null || p.focus());
      };
  }, [A, e.open, P]), pe(() => {
    if (!e.open) return;
    const re = (p) => {
      if (p.key === "Escape" && N) {
        p.preventDefault(), Y("escape");
        return;
      }
      if (p.key !== "Tab" || !k || !c.current) return;
      const z = xa(c.current);
      if (!z.length) {
        p.preventDefault(), c.current.focus();
        return;
      }
      const V = z[0], le = z[z.length - 1];
      p.shiftKey && document.activeElement === V ? (p.preventDefault(), le.focus()) : !p.shiftKey && document.activeElement === le && (p.preventDefault(), V.focus());
    };
    return document.addEventListener("keydown", re), () => document.removeEventListener("keydown", re);
  }, [N, e.open, k]), pe(() => {
    if (!e.open || !F || x) return;
    const re = (p) => {
      var z;
      (z = c.current) != null && z.contains(p.target) || Y("outside");
    };
    return document.addEventListener("pointerdown", re, !0), () => document.removeEventListener("pointerdown", re, !0);
  }, [F, x, e.open]);
  const oe = ze(() => {
    var re;
    return (re = e.items) != null && re.length ? /* @__PURE__ */ n.jsx("nav", { className: it["flare-drawer__navigation"], "aria-label": e.navigationLabel ?? w.navigation, children: /* @__PURE__ */ n.jsx(
      $a,
      {
        items: e.items,
        expandedIds: f,
        onExpandedChange: X,
        onItemSelect: (p) => {
          var z;
          (z = p.onSelect) == null || z.call(p), B && (p.onSelect || p.href) && Y("item-select");
        },
        labels: w
      }
    ) }) : null;
  }, [B, f, w, e.items, e.navigationLabel]);
  if (!e.open || typeof document > "u") return null;
  const {
    open: G,
    onOpenChange: S,
    placement: Z = "start",
    title: We,
    titleIcon: be,
    subtitle: ee,
    headerActions: q,
    footer: T,
    children: L,
    items: ke,
    navigationLabel: te,
    expandedItemIds: ce,
    defaultExpandedItemIds: we,
    onExpandedItemIdsChange: Fe,
    closeOnEscape: De,
    closeOnBackdropClick: Ee,
    closeOnOutsidePointerDown: Me,
    closeOnItemSelect: Be,
    modal: qe,
    trapFocus: Xe,
    autoFocus: xe,
    restoreFocus: ue,
    portalTarget: Ve,
    zIndex: Oe,
    labels: st,
    closeIcon: Pe,
    className: dt,
    style: ut,
    ...Q
  } = e, se = Ve ?? h.current ?? document.querySelector(".flare-ui-theme") ?? document.getElementById("root") ?? document.body;
  return Xr(
    /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      x ? /* @__PURE__ */ n.jsx("div", { className: it["flare-drawer__backdrop"], "aria-hidden": "true", onPointerDown: () => j && Y("backdrop") }) : null,
      /* @__PURE__ */ n.jsxs(
        "section",
        {
          ...Q,
          ref: c,
          id: a,
          role: "dialog",
          "aria-modal": x,
          "aria-labelledby": We ? o : void 0,
          tabIndex: -1,
          className: [it["flare-drawer"], it[`is-${Z}`], dt].filter(Boolean).join(" "),
          style: { zIndex: Oe, ...ut },
          children: [
            /* @__PURE__ */ n.jsxs("header", { className: it["flare-drawer__header"], children: [
              /* @__PURE__ */ n.jsxs("div", { className: it["flare-drawer__identity"], children: [
                be ? /* @__PURE__ */ n.jsx("span", { className: it["flare-drawer__icon"], children: be }) : null,
                We ? /* @__PURE__ */ n.jsxs("span", { className: it["flare-drawer__title-copy"], children: [
                  /* @__PURE__ */ n.jsx("strong", { id: o, className: it["flare-drawer__title"], children: We }),
                  ee ? /* @__PURE__ */ n.jsx("small", { className: it["flare-drawer__subtitle"], children: ee }) : null
                ] }) : null
              ] }),
              /* @__PURE__ */ n.jsxs("div", { className: it["flare-drawer__header-actions"], children: [
                q,
                /* @__PURE__ */ n.jsx("button", { type: "button", className: it["flare-drawer__close"], onClick: () => Y("close-button"), "aria-label": w.close, children: Pe ?? /* @__PURE__ */ n.jsx(wo, {}) })
              ] })
            ] }),
            /* @__PURE__ */ n.jsxs("div", { className: it["flare-drawer__body"], children: [
              oe,
              L
            ] }),
            T ? /* @__PURE__ */ n.jsx("footer", { className: it["flare-drawer__footer"], children: T }) : null
          ]
        }
      )
    ] }),
    se
  );
}
function $a(e) {
  const t = e.ancestorIds ?? [];
  return /* @__PURE__ */ n.jsx("ul", { className: e.nested ? it["flare-drawer__list"] : it["flare-drawer__root-list"], children: e.items.map((r) => {
    var f;
    const a = !!((f = r.children) != null && f.length) && !t.includes(r.id), o = e.expandedIds.includes(r.id), c = `flare-drawer-submenu-${r.id}`, s = r.ariaLabel ?? (typeof r.label == "string" ? r.label : r.id), h = () => e.onExpandedChange(o ? e.expandedIds.filter((w) => w !== r.id) : [...e.expandedIds, r.id]), u = !!(r.href || r.onSelect), b = /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      /* @__PURE__ */ n.jsx(n.Fragment, { children: r.icon ? /* @__PURE__ */ n.jsx("span", { className: it["flare-drawer__icon"], children: r.icon }) : null }),
      /* @__PURE__ */ n.jsx("span", { className: it["flare-drawer__item-label"], children: r.label }),
      r.endAdornment ? /* @__PURE__ */ n.jsx("span", { className: it["flare-drawer__end"], children: r.endAdornment }) : null,
      a && !u ? /* @__PURE__ */ n.jsx("span", { className: it["flare-drawer__disclosure"], children: /* @__PURE__ */ n.jsx(ya, {}) }) : null
    ] });
    return /* @__PURE__ */ n.jsxs("li", { className: [r.active && it["is-active"], r.disabled && it["is-disabled"]].filter(Boolean).join(" "), children: [
      /* @__PURE__ */ n.jsxs("div", { className: it["flare-drawer__row"], children: [
        r.href ? /* @__PURE__ */ n.jsx("a", { className: it["flare-drawer__item"], href: r.disabled ? void 0 : r.href, target: r.target, "aria-disabled": r.disabled, onClick: (w) => {
          if (r.disabled) {
            w.preventDefault();
            return;
          }
          e.onItemSelect(r);
        }, children: b }) : /* @__PURE__ */ n.jsx("button", { type: "button", className: it["flare-drawer__item"], disabled: r.disabled, "aria-expanded": a ? o : void 0, "aria-controls": a ? c : void 0, onClick: () => a && !u ? h() : e.onItemSelect(r), children: b }),
        a && u ? /* @__PURE__ */ n.jsx("button", { type: "button", className: it["flare-drawer__toggle"], disabled: r.disabled, "aria-label": o ? e.labels.collapse(s) : e.labels.expand(s), "aria-expanded": o, "aria-controls": c, onClick: h, children: /* @__PURE__ */ n.jsx(ya, {}) }) : null
      ] }),
      a && o ? /* @__PURE__ */ n.jsx("div", { id: c, className: it["flare-drawer__submenu"], children: /* @__PURE__ */ n.jsx($a, { ...e, items: r.children ?? [], ancestorIds: [...t, r.id], nested: !0 }) }) : null
    ] }, r.id);
  }) });
}
const Gt = {
  "flare-collection-view": "_flare-collection-view_c8ecq_1",
  "flare-collection-view__toolbar": "_flare-collection-view__toolbar_c8ecq_5",
  "flare-collection-view__toolbar-start": "_flare-collection-view__toolbar-start_c8ecq_13",
  "flare-collection-view__switcher": "_flare-collection-view__switcher_c8ecq_17",
  "flare-collection-view__option": "_flare-collection-view__option_c8ecq_27",
  "flare-collection-view__option--active": "_flare-collection-view__option--active_c8ecq_50",
  "flare-collection-view__content": "_flare-collection-view__content_c8ecq_70",
  "flare-collection-view__content--grid": "_flare-collection-view__content--grid_c8ecq_75",
  "flare-collection-view__content--list": "_flare-collection-view__content--list_c8ecq_76",
  "flare-collection-view__content--compact": "_flare-collection-view__content--compact_c8ecq_77",
  "flare-collection-fade-in": "_flare-collection-fade-in_c8ecq_1",
  "flare-collection-fade-out": "_flare-collection-fade-out_c8ecq_1"
}, xo = ["grid", "list", "compact"];
function Go({
  children: e,
  viewMode: t,
  onViewModeChange: r,
  labels: a,
  toolbarStart: o,
  className: c,
  contentClassName: s,
  gridMinItemWidth: h,
  gridMaxItemWidth: u,
  compactMinItemWidth: b,
  compactMaxItemWidth: f,
  mobileGridMinItemWidth: w
}) {
  const x = `flare-collection-${Rt().replace(/[^a-zA-Z0-9_-]/g, "")}`, [k, N] = Ne(0), j = {
    viewTransitionName: x,
    "--flare-collection-grid-min-width": h,
    "--flare-collection-grid-max-width": u,
    "--flare-collection-compact-min-width": b,
    "--flare-collection-compact-max-width": f,
    "--flare-collection-mobile-grid-min-width": w
  }, F = (B) => {
    if (B === t)
      return;
    const A = document;
    if (A.startViewTransition) {
      A.startViewTransition(() => {
        Ha(() => r(B));
      }).finished.catch(() => {
      });
      return;
    }
    N((P) => P + 1), r(B);
  };
  return /* @__PURE__ */ n.jsxs("section", { className: [Gt["flare-collection-view"], c].filter(Boolean).join(" "), children: [
    /* @__PURE__ */ n.jsxs("div", { className: Gt["flare-collection-view__toolbar"], children: [
      o ? /* @__PURE__ */ n.jsx("div", { className: Gt["flare-collection-view__toolbar-start"], children: o }) : null,
      /* @__PURE__ */ n.jsx("div", { className: Gt["flare-collection-view__switcher"], role: "group", "aria-label": a.viewOptions, children: xo.map((B) => /* @__PURE__ */ n.jsx(
        "button",
        {
          type: "button",
          className: [
            Gt["flare-collection-view__option"],
            t === B ? Gt["flare-collection-view__option--active"] : void 0
          ].filter(Boolean).join(" "),
          "aria-pressed": t === B,
          "aria-label": a[B],
          title: a[B],
          onClick: () => F(B),
          children: /* @__PURE__ */ n.jsx(yo, { mode: B })
        },
        B
      )) })
    ] }),
    /* @__PURE__ */ n.jsx(
      "div",
      {
        className: [
          Gt["flare-collection-view__content"],
          Gt[`flare-collection-view__content--${t}`],
          s
        ].filter(Boolean).join(" "),
        style: j,
        children: e
      },
      k
    )
  ] });
}
function yo({ mode: e }) {
  return e === "list" ? /* @__PURE__ */ n.jsx("svg", { viewBox: "0 0 16 16", "aria-hidden": "true", children: /* @__PURE__ */ n.jsx("path", { d: "M2 3h2v2H2zm3.5.5H14M2 7h2v2H2zm3.5.5H14M2 11h2v2H2zm3.5.5H14" }) }) : e === "compact" ? /* @__PURE__ */ n.jsx("svg", { viewBox: "0 0 16 16", "aria-hidden": "true", children: /* @__PURE__ */ n.jsx("path", { d: "M2 2h3v3H2zm4.5 0h3v3h-3zm4.5 0h3v3h-3zM2 6.5h3v3H2zm4.5 0h3v3h-3zm4.5 0h3v3h-3zM2 11h3v3H2zm4.5 0h3v3h-3zm4.5 0h3v3h-3z" }) }) : /* @__PURE__ */ n.jsx("svg", { viewBox: "0 0 16 16", "aria-hidden": "true", children: /* @__PURE__ */ n.jsx("path", { d: "M2 2h5v5H2zm7 0h5v5H9zM2 9h5v5H2zm7 0h5v5H9z" }) });
}
const Ht = {
  "flare-pager": "_flare-pager_5yrzz_1",
  "flare-pager__pages": "_flare-pager__pages_5yrzz_9",
  "flare-pager__button": "_flare-pager__button_5yrzz_16",
  "flare-pager__button--current": "_flare-pager__button--current_5yrzz_32",
  "flare-pager__ellipsis": "_flare-pager__ellipsis_5yrzz_52"
}, po = {
  firstPage: "First page",
  previousPage: "Previous page",
  nextPage: "Next page",
  lastPage: "Last page",
  page: (e, t) => `Page ${e} of ${t}`
}, Ur = (e, t, r) => Math.min(Math.max(e, t), r);
function ko(e, t, r) {
  if (t <= r)
    return Array.from({ length: t }, (h, u) => u + 1);
  const a = r - 2, o = Ur(
    e - Math.floor(a / 2),
    2,
    t - a
  ), c = o + a - 1, s = [1];
  o > 2 && s.push("ellipsis");
  for (let h = o; h <= c; h += 1)
    s.push(h);
  return c < t - 1 && s.push("ellipsis"), s.push(t), s;
}
function Xo(e) {
  const { messages: t } = fr(), {
    currentPage: r,
    pageCount: a,
    onPageChange: o,
    labels: c,
    direction: s = "auto",
    visiblePages: h = 5,
    className: u,
    "aria-label": b,
    ...f
  } = e, w = Math.max(0, Math.floor(a)), x = w ? Ur(Math.floor(r), 1, w) : 1, k = { ...po, ...t.pager, ...c }, N = Math.max(5, Math.floor(h)), [j, F] = W.useState(
    s === "rtl" ? "rtl" : "ltr"
  ), B = W.useRef(null);
  if (W.useLayoutEffect(() => {
    if (s === "ltr" || s === "rtl") {
      F(s);
      return;
    }
    const G = B.current ? getComputedStyle(B.current).direction : document.documentElement.dir;
    F(G === "rtl" ? "rtl" : "ltr");
  }, [s]), w <= 1)
    return null;
  const A = (G) => {
    const S = Ur(G, 1, w);
    S !== x && o(S);
  }, P = j === "rtl" ? "›" : "‹", Y = j === "rtl" ? "‹" : "›", X = j === "rtl" ? "»" : "«", oe = j === "rtl" ? "«" : "»";
  return /* @__PURE__ */ n.jsxs(
    "nav",
    {
      ref: B,
      className: [Ht["flare-pager"], u].filter(Boolean).join(" "),
      dir: s === "auto" ? void 0 : s,
      ...f,
      "aria-label": b ?? t.pager.navigation,
      children: [
        /* @__PURE__ */ n.jsx("button", { type: "button", className: Ht["flare-pager__button"], onClick: () => A(1), disabled: x === 1, "aria-label": k.firstPage, children: X }),
        /* @__PURE__ */ n.jsx("button", { type: "button", className: Ht["flare-pager__button"], onClick: () => A(x - 1), disabled: x === 1, "aria-label": k.previousPage, children: P }),
        /* @__PURE__ */ n.jsx("div", { className: Ht["flare-pager__pages"], children: ko(x, w, N).map(
          (G, S) => G === "ellipsis" ? /* @__PURE__ */ n.jsx("span", { className: Ht["flare-pager__ellipsis"], "aria-hidden": "true", children: "…" }, `ellipsis-${S}`) : /* @__PURE__ */ n.jsx(
            "button",
            {
              type: "button",
              className: [Ht["flare-pager__button"], G === x ? Ht["flare-pager__button--current"] : void 0].filter(Boolean).join(" "),
              "aria-current": G === x ? "page" : void 0,
              "aria-label": k.page(G, w),
              onClick: () => A(G),
              children: G
            },
            G
          )
        ) }),
        /* @__PURE__ */ n.jsx("button", { type: "button", className: Ht["flare-pager__button"], onClick: () => A(x + 1), disabled: x === w, "aria-label": k.nextPage, children: Y }),
        /* @__PURE__ */ n.jsx("button", { type: "button", className: Ht["flare-pager__button"], onClick: () => A(w), disabled: x === w, "aria-label": k.lastPage, children: oe })
      ]
    }
  );
}
const br = (...e) => e.filter(Boolean).join(" ");
function Jo(e) {
  const { messages: t } = fr(), r = me(null), [a, o] = Ne(e.direction === "rtl" ? "rtl" : "ltr");
  W.useLayoutEffect(() => {
    if (e.direction === "ltr" || e.direction === "rtl") {
      o(e.direction);
      return;
    }
    const g = r.current ? getComputedStyle(r.current).direction : document.documentElement.dir;
    o(g === "rtl" ? "rtl" : "ltr");
  }, [e.direction]);
  const c = R(() => e.multiple ? Array.isArray(e.value) ? e.value : e.value === void 0 || e.value === null ? [] : [e.value] : Array.isArray(e.value) ? e.value.length > 0 ? e.value[0] : void 0 : e.value, [e.multiple, e.value]), [s, h] = Ne(!1), [u, b] = Ne(c), [f, w] = Ne(""), [x, k] = Ne(-1), N = me(null), j = me(null), F = me(null), B = me(null), A = me([]), P = W.useRef(null), Y = Rt(), X = Rt(), oe = e.label ? `${X}-label` : void 0, G = R((g) => Array.isArray(g) ? g : g == null ? [] : [g], []);
  pe(() => {
    e.multiple ? b(G(e.value)) : Array.isArray(e.value) ? b(e.value.length > 0 ? e.value[0] : void 0) : b(e.value);
  }, [e.multiple, e.value, G]);
  const S = R(() => u, [u]), Z = R(() => {
    var g;
    return ((g = P.current) == null ? void 0 : g.validate(S())) ?? !0;
  }, [S]), We = R(() => {
    var H, D;
    const g = e.multiple ? [] : void 0;
    e.value === void 0 && b(g), (H = P.current) == null || H.onChange(g), (D = P.current) == null || D.validate(g);
  }, [e.multiple, e.value]);
  nr(e.name, Z, S, We);
  const be = R(() => {
    h(!1), w(""), k(-1);
  }, []), ee = R((g = "") => {
    e.disabled || (w(g), h(!0));
  }, [e.disabled]), q = R(() => (be(), !0), [be]);
  pe(() => {
    const g = N.current, H = j.current;
    if (g) {
      if (!s) {
        g.close();
        return;
      }
      H && g.open({
        anchor: H,
        placement: "bottom",
        align: "start",
        offset: 8
      });
    }
  }, [s]), pe(() => {
    if (!s)
      return;
    const g = window.requestAnimationFrame(() => {
      var H;
      (H = F.current) == null || H.focus();
    });
    return () => window.cancelAnimationFrame(g);
  }, [s]);
  const T = ze(() => {
    const g = f.trim().toLowerCase();
    return g ? e.items.filter((H) => H.text.toLowerCase().includes(g)) : e.items;
  }, [f, e.items]), L = R((g) => e.multiple ? G(u).some((H) => H === g) : u === g, [u, e.multiple, G]), ke = R((g) => {
    var H, D, I;
    b(g), (H = P.current) == null || H.onChange(g), (D = P.current) == null || D.validate(g), (I = e.onChange) == null || I.call(e, g);
  }, [e.onChange]), te = R((g) => {
    var H, D, I;
    if (!g.disabled)
      if (e.multiple) {
        const Ce = G(u), Le = Ce.some((Je) => Je === g.value) ? Ce.filter((Je) => Je !== g.value) : [...Ce, g.value];
        ke(Le);
      } else
        b(g.value), (H = P.current) == null || H.onChange(g.value), (D = P.current) == null || D.validate(g.value), (I = e.onChange) == null || I.call(e, g.value), be();
  }, [be, u, e.multiple, G, ke]), ce = R((g) => {
    const H = A.current[g];
    H == null || H.scrollIntoView({ block: "nearest" });
  }, []), we = R((g, H) => {
    if (!T.length)
      return -1;
    let D = g;
    for (let I = 0; I < T.length; I += 1)
      if (D = (D + H + T.length) % T.length, !T[D].disabled)
        return D;
    return -1;
  }, [T]);
  pe(() => {
    if (s) {
      if (!T.length) {
        k(-1);
        return;
      }
      k((g) => {
        if (g >= 0 && g < T.length && !T[g].disabled)
          return g;
        const H = T.findIndex((D) => L(D.value) && !D.disabled);
        return H >= 0 ? H : we(-1, 1);
      });
    }
  }, [T, we, L, s]), pe(() => {
    x >= 0 && ce(x);
  }, [ce, x]);
  const Fe = R((g) => {
    T.length && k((H) => {
      const D = H < 0 ? g === 1 ? -1 : 0 : H, I = we(D, g);
      return I >= 0 ? (ce(I), I) : H;
    });
  }, [ce, T.length, we]), De = R(() => {
    if (x < 0 || x >= T.length)
      return;
    const g = T[x];
    te(g);
  }, [T, x, te]), Ee = (g) => {
    if (!s) {
      if (g.key === "Enter" || g.key === " " || g.key === "ArrowDown" || g.key === "ArrowUp") {
        g.preventDefault(), ee();
        return;
      }
      g.key.length === 1 && !g.altKey && !g.ctrlKey && !g.metaKey && (g.preventDefault(), ee(g.key));
    }
  }, Me = (g) => {
    var H, D;
    if (s)
      switch (g.key) {
        case " ": {
          x >= 0 && (g.preventDefault(), De());
          break;
        }
        case "ArrowDown": {
          g.preventDefault(), Fe(1), (H = B.current) == null || H.focus();
          break;
        }
        case "ArrowUp": {
          g.preventDefault(), Fe(-1), (D = B.current) == null || D.focus();
          break;
        }
        case "Enter": {
          x >= 0 && (g.preventDefault(), De());
          break;
        }
        case "Tab": {
          be();
          break;
        }
        case "Escape": {
          g.preventDefault(), be();
          break;
        }
      }
  }, Be = (g) => {
    if (s)
      switch (g.key) {
        case "ArrowDown": {
          g.preventDefault(), Fe(1);
          break;
        }
        case "ArrowUp": {
          g.preventDefault(), Fe(-1);
          break;
        }
        case "Home": {
          g.preventDefault();
          const H = we(-1, 1);
          H >= 0 && (k(H), ce(H));
          break;
        }
        case "End": {
          g.preventDefault();
          const H = we(0, -1);
          H >= 0 && (k(H), ce(H));
          break;
        }
        case "Enter": {
          x >= 0 && (g.preventDefault(), De());
          break;
        }
        case " ": {
          x >= 0 && (g.preventDefault(), De());
          break;
        }
        case "Tab": {
          be();
          break;
        }
        case "Escape": {
          g.preventDefault(), be();
          break;
        }
        case "Backspace": {
          g.preventDefault(), w((H) => H.slice(0, -1)), window.setTimeout(() => {
            var H;
            return (H = F.current) == null ? void 0 : H.focus();
          }, 0);
          break;
        }
        default: {
          g.key.length === 1 && !g.altKey && !g.ctrlKey && !g.metaKey && (g.preventDefault(), w((H) => H + g.key), window.setTimeout(() => {
            var H;
            return (H = F.current) == null ? void 0 : H.focus();
          }, 0));
          break;
        }
      }
  }, qe = e.clearable ?? !0, Xe = ze(() => e.multiple ? G(u).length > 0 : u != null, [u, e.multiple, G]), xe = R((g) => {
    var H, D, I;
    g.stopPropagation(), e.multiple ? ke([]) : (b(void 0), (H = P.current) == null || H.onChange(void 0), (D = P.current) == null || D.validate(void 0), (I = e.onChange) == null || I.call(e, void 0)), w(""), k(-1), s && window.setTimeout(() => {
      var Ce;
      return (Ce = F.current) == null ? void 0 : Ce.focus();
    }, 0);
  }, [s, e.multiple, e.onChange, ke]), ue = ze(() => e.items.filter((g) => !g.disabled), [e.items]), Ve = ze(
    () => ue.length > 0 && ue.every((g) => L(g.value)),
    [L, ue]
  ), Oe = R(() => {
    ke(ue.map((g) => g.value));
  }, [ue, ke]), st = R(() => {
    ke([]);
  }, [ke]), Pe = ze(() => {
    if (e.multiple) {
      const H = G(u);
      return H.length ? { text: e.items.filter((I) => H.some((Ce) => Ce === I.value)).map((I) => I.text).join(", "), icon: void 0, isPlaceholder: !1 } : { text: e.placeholder || "", icon: void 0, isPlaceholder: !0 };
    }
    const g = e.items.find((H) => H.value === u);
    return g ? { text: g.text, icon: g.icon, isPlaceholder: !1 } : { text: e.placeholder || "", icon: void 0, isPlaceholder: !0 };
  }, [u, e.items, e.multiple, e.placeholder, G]), dt = br(
    lt["flare-drop-down-list"],
    a === "rtl" && lt["flare-drop-down-list--rtl"],
    e.className,
    e.disabled && lt["flare-drop-down-list--disabled"]
  ), ut = br(
    lt["flare-drop-down-list__selection"],
    s && lt["flare-drop-down-list__selection--open"]
  ), Q = R((g) => {
    if (g != null)
      return typeof g == "number" ? `${g}px` : g;
  }, []), {
    className: se,
    style: re,
    items: p,
    value: z,
    onChange: V,
    direction: le,
    multiple: he,
    placeholder: ie,
    label: rt,
    icon: He,
    clearable: ae,
    showBulkActions: ye,
    clearSelectionLabel: Ke,
    selectAllLabel: $e,
    selectNoneLabel: Ue,
    filterPlaceholder: xt,
    emptyMessage: nt,
    disabled: Ye,
    matchPopupWidth: mt,
    popupWidth: gt,
    popupMinWidth: ft,
    popupMaxWidth: $,
    width: K,
    minWidth: je,
    maxWidth: C,
    required: J,
    validationError: ve,
    refForward: Te,
    customValidation: Ae,
    ...vt
  } = e, _t = ze(() => {
    const g = { ...re };
    return K !== void 0 && (g.width = Q(K)), je !== void 0 && (g.minWidth = Q(je)), C !== void 0 && (g.maxWidth = Q(C)), g;
  }, [C, je, re, Q, K]);
  return /* @__PURE__ */ n.jsx(
    ar,
    {
      label: e.label,
      refHandle: P,
      validationError: ve,
      required: J,
      customValidation: Ae,
      children: /* @__PURE__ */ n.jsxs(
        "div",
        {
          ref: r,
          className: dt,
          style: _t,
          dir: e.direction === "auto" || e.direction == null ? void 0 : e.direction,
          ...vt,
          children: [
            /* @__PURE__ */ n.jsxs(
              "div",
              {
                className: ut,
                tabIndex: Ye ? -1 : 0,
                role: "combobox",
                "aria-haspopup": "listbox",
                "aria-expanded": s,
                "aria-controls": Y,
                "aria-labelledby": oe,
                "aria-disabled": Ye,
                id: X,
                onClick: () => s ? be() : ee(),
                onKeyDown: Ee,
                ref: j,
                children: [
                  e.icon && /* @__PURE__ */ n.jsx("span", { className: lt["flare-drop-down-list__selection-icon"], children: e.icon }),
                  /* @__PURE__ */ n.jsxs("div", { className: lt["flare-drop-down-list__selection-value"], children: [
                    Pe.icon && /* @__PURE__ */ n.jsx("span", { className: lt["flare-drop-down-list__selection-value-icon"], children: Pe.icon }),
                    s ? /* @__PURE__ */ n.jsx(
                      "input",
                      {
                        ref: F,
                        className: lt["flare-drop-down-list__search"],
                        value: f,
                        onChange: (g) => w(g.target.value),
                        placeholder: e.filterPlaceholder ?? e.placeholder ?? t.dropdown.filter,
                        onKeyDown: Me,
                        onClick: (g) => g.stopPropagation()
                      }
                    ) : /* @__PURE__ */ n.jsx(
                      "span",
                      {
                        className: br(
                          lt["flare-drop-down-list__selection-text"],
                          Pe.isPlaceholder && lt["flare-drop-down-list__selection-text--placeholder"]
                        ),
                        children: Pe.text
                      }
                    )
                  ] }),
                  e.multiple && qe && Xe && /* @__PURE__ */ n.jsx(
                    "button",
                    {
                      type: "button",
                      className: lt["flare-drop-down-list__clear"],
                      "aria-label": e.clearSelectionLabel ?? t.dropdown.clear,
                      onClick: xe,
                      children: "×"
                    }
                  ),
                  /* @__PURE__ */ n.jsx(
                    "span",
                    {
                      className: br(
                        lt["flare-drop-down-list__caret"],
                        s && lt["flare-drop-down-list__caret--open"]
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ n.jsxs(
              La,
              {
                ref: N,
                className: lt["flare-drop-down-list__popup"],
                contentClassName: lt["flare-drop-down-list__menu"],
                dir: a,
                matchAnchorWidth: e.matchPopupWidth,
                width: gt,
                minWidth: ft,
                maxWidth: $,
                closeOnOutsidePointerDown: !0,
                closeOnEscape: !0,
                onRequestClose: q,
                children: [
                  e.multiple && e.showBulkActions !== !1 && ue.length > 0 && /* @__PURE__ */ n.jsxs("div", { className: lt["flare-drop-down-list__bulk-actions"], children: [
                    /* @__PURE__ */ n.jsx(
                      "button",
                      {
                        type: "button",
                        className: lt["flare-drop-down-list__bulk-action"],
                        disabled: Ve,
                        onClick: Oe,
                        children: e.selectAllLabel ?? t.dropdown.selectAll
                      }
                    ),
                    /* @__PURE__ */ n.jsx(
                      "button",
                      {
                        type: "button",
                        className: lt["flare-drop-down-list__bulk-action"],
                        disabled: !Xe,
                        onClick: st,
                        children: e.selectNoneLabel ?? t.dropdown.selectNone
                      }
                    )
                  ] }),
                  /* @__PURE__ */ n.jsxs(
                    "div",
                    {
                      className: lt["flare-drop-down-list__options"],
                      role: "listbox",
                      "aria-multiselectable": e.multiple || void 0,
                      "aria-labelledby": oe,
                      id: Y,
                      tabIndex: -1,
                      ref: B,
                      onKeyDown: Be,
                      children: [
                        T.length === 0 && /* @__PURE__ */ n.jsx("div", { className: lt["flare-drop-down-list__empty"], children: e.emptyMessage ?? t.dropdown.noResults }),
                        T.map((g, H) => {
                          const D = L(g.value), I = H === x, Ce = () => {
                            te(g);
                          };
                          return /* @__PURE__ */ n.jsxs(
                            "div",
                            {
                              role: "option",
                              "aria-selected": D,
                              className: br(
                                lt["flare-drop-down-list__item"],
                                I && lt["flare-drop-down-list__item--highlighted"],
                                D && lt["flare-drop-down-list__item--selected"],
                                g.disabled && lt["flare-drop-down-list__item--disabled"]
                              ),
                              onClick: Ce,
                              onMouseEnter: () => k(H),
                              ref: (Le) => {
                                A.current[H] = Le;
                              },
                              children: [
                                e.multiple && /* @__PURE__ */ n.jsx(
                                  Ta,
                                  {
                                    checked: D,
                                    disabled: g.disabled,
                                    onChange: Ce,
                                    tabIndex: -1
                                  }
                                ),
                                g.icon && /* @__PURE__ */ n.jsx("span", { className: lt["flare-drop-down-list__item-icon"], children: g.icon }),
                                /* @__PURE__ */ n.jsx("span", { className: lt["flare-drop-down-list__item-label"], children: g.text })
                              ]
                            },
                            `${H}-${g.text}`
                          );
                        })
                      ]
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}
const dr = {
  "flare-text-box": "_flare-text-box_vgu3d_1",
  "flare-text-box-field": "_flare-text-box-field_vgu3d_39",
  "is-disabled": "_is-disabled_vgu3d_57",
  "flare-text-box-input": "_flare-text-box-input_vgu3d_62",
  "flare-text-box-icon": "_flare-text-box-icon_vgu3d_90",
  "validation-error": "_validation-error_vgu3d_111"
}, pa = (...e) => e.filter(Boolean).join(" "), Co = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/, So = /[A-Za-z]/;
function Yr(e) {
  for (const t of e) {
    if (Co.test(t)) return "rtl";
    if (So.test(t)) return "ltr";
  }
  return "ltr";
}
function Vr(e, t) {
  return Yr(e || t || "");
}
function jo(e) {
  const t = e.trim(), r = t.startsWith("^") || t.endsWith("$") ? t : `^${t}$`;
  return new RegExp(r);
}
function No(e) {
  try {
    if (e instanceof RegExp) {
      const r = e.flags.replace(/g|y/g, "");
      return new RegExp(e.source, r);
    }
    return jo(e ?? "[0-9]");
  } catch {
    return /^[0-9]$/;
  }
}
function ka(e, t) {
  return e ? e.length === 1 ? e : e[0] ?? t : t;
}
function Do(e, t, r) {
  const a = [];
  for (let o = 0; o < e.length; ) {
    const c = e[o];
    if (c === "\\" && o + 1 < e.length) {
      a.push({ kind: "literal", value: e[o + 1] }), o += 2;
      continue;
    }
    if (c === t) {
      a.push({ kind: "slot", re: r }), o += 1;
      continue;
    }
    if (c === "[") {
      const s = e.indexOf("]", o + 1);
      if (s === -1) {
        a.push({ kind: "literal", value: c }), o += 1;
        continue;
      }
      const h = e.slice(o + 1, s);
      try {
        a.push({ kind: "slot", re: new RegExp(`^[${h}]$`) }), o = s + 1;
        continue;
      } catch {
        a.push({ kind: "literal", value: e.slice(o, s + 1) }), o = s + 1;
        continue;
      }
    }
    a.push({ kind: "literal", value: c }), o += 1;
  }
  return a;
}
function Eo(e, t) {
  return e.map((r) => r.kind === "slot" ? t : r.value).join("");
}
function Wa(e, t, r) {
  const a = e ?? "", o = t == null ? a.length : Math.max(0, Math.min(t, a.length)), c = [];
  let s = 0, h = 0;
  const u = (b) => {
    if (b)
      for (let f = 0; f < b.length && h < a.length; ) {
        if (a[h] === b[f]) {
          h += 1, f += 1;
          continue;
        }
        break;
      }
  };
  for (const b of r) {
    if (b.kind === "literal") {
      u(b.value);
      continue;
    }
    for (; h < a.length; ) {
      const f = a[h];
      if (b.re.test(f)) {
        const w = h;
        c.push(f), w < o && s++, h = w + 1;
        break;
      }
      h += 1;
    }
  }
  return { slots: c, slotsBeforeCaret: s };
}
function Er(e, t) {
  return Wa(e, null, t).slots;
}
function Ca(e, t, r) {
  return Wa(e, t, r);
}
function rr(e, t) {
  if (e.length === 0) return "";
  let r = "", a = 0;
  for (const o of t) {
    if (o.kind === "literal") {
      r += o.value;
      continue;
    }
    const c = e[a];
    if (!c) break;
    r += c, a++;
  }
  return r;
}
function Sa(e, t, r) {
  const a = t.map((c) => c.kind === "slot" ? r : c.value);
  let o = 0;
  for (let c = 0; c < t.length; c++)
    t[c].kind === "slot" && (e[o] && (a[c] = e[o]), o++);
  return a.join("");
}
function ur(e, t) {
  let r = 0, a = 0;
  for (const o of t)
    if (o.kind === "slot") {
      if (r === e) return a;
      r++, a += 1;
    } else
      a += o.value.length;
  return a;
}
function zo(e) {
  const t = [];
  let r = 0;
  for (const a of e)
    a.kind === "slot" ? (t.push(r), r += 1) : r += a.value.length;
  return t;
}
function Zo(e) {
  var He;
  const t = ka(e.maskSlotChar, "_"), r = ze(
    () => No(e.maskSlotRegex),
    [e.maskSlotRegex]
  ), a = ze(() => {
    if (e.mask)
      try {
        return Do(e.mask, t, r);
      } catch {
        return;
      }
  }, [e.mask, t, r]), o = e.value !== void 0, c = ze(() => a ? a.filter(
    (ae) => ae.kind === "slot"
  ) : [], [a]), s = ka(
    e.maskPlaceholderChar,
    "_"
  ), h = ze(() => {
    if (!a)
      return { char: s, hasConflict: !1 };
    if (!c.some(($e) => $e.re.test(s)))
      return { char: s, hasConflict: !1 };
    const Ke = ["•", "·", "□", "◦", "⁃", "–", "—"].find(
      ($e) => !c.some((Ue) => Ue.re.test($e))
    );
    return {
      char: Ke ?? s,
      hasConflict: !Ke
    };
  }, [a, s, c]), u = h.char, b = h.hasConflict, f = !!(e.maskShowTemplate && a && !b), w = R(
    (ae) => {
      if (!a) return ae;
      const ye = Er(ae, a);
      return rr(ye, a);
    },
    [a]
  ), [x, k] = Ne(
    () => w(e.value ?? "")
  ), [N, j] = Ne(
    () => Vr(w(e.value ?? ""), e.placeholder)
  ), [F, B] = Ne(!1), A = Rt(), P = e.id ?? A, Y = me(null), X = me(null), oe = me(null), G = R(() => {
    const ae = o ? e.value ?? "" : x;
    return w(ae);
  }, [x, o, w, e.value]), S = R(
    (ae) => {
      var ye, Ke, $e;
      o || k(ae), j(Vr(ae, e.placeholder)), (ye = Y.current) == null || ye.onChange(ae), (Ke = Y.current) == null || Ke.validate(ae), ($e = e.onChange) == null || $e.call(e, ae);
    },
    [o, e.onChange]
  );
  pe(() => {
    if (!o) return;
    const ae = w(e.value ?? "");
    k(ae), j(Vr(ae, e.placeholder));
  }, [o, w, e.placeholder, e.value]), pe(() => {
    if (o) return;
    const ae = w(x);
    ae !== x && (k(ae), j(Yr(ae)));
  }, [x, o, w]);
  const Z = R(() => {
    var ye;
    const ae = G();
    return ((ye = Y.current) == null ? void 0 : ye.validate(ae)) ?? !0;
  }, [G]), We = R(() => {
    var ae, ye;
    o || (k(""), j(Yr(""))), (ae = Y.current) == null || ae.onChange(""), (ye = Y.current) == null || ye.validate("");
  }, [o]);
  nr(e.name, Z, G, We);
  const be = R(
    (ae) => {
      var gt;
      if ((gt = e.onKeyDown) == null || gt.call(e, ae), ae.defaultPrevented || !a) return;
      const ye = ae.currentTarget, Ke = ye.selectionStart ?? 0, $e = ye.selectionEnd ?? Ke;
      if (ae.key !== "Backspace" && ae.key !== "Delete") return;
      if (Ke !== $e) {
        const ft = Er(ye.value, a), K = zo(a).map((ve, Te) => ({ pos: ve, index: Te })).filter(({ pos: ve }) => ve >= Ke && ve < $e).map(({ index: ve }) => ve);
        if (K.length === 0) {
          ae.preventDefault();
          return;
        }
        ae.preventDefault();
        const je = ft.filter(
          (ve, Te) => !K.includes(Te)
        ), C = rr(je, a), J = K[0];
        f ? oe.current = ur(
          J,
          a
        ) : oe.current = rr(
          je.slice(0, J),
          a
        ).length, S(C);
        return;
      }
      const { slots: Ue, slotsBeforeCaret: xt } = Ca(
        ye.value,
        Ke,
        a
      );
      if (Ue.length === 0) return;
      const nt = ae.key === "Backspace" ? xt - 1 : xt;
      if (nt < 0 || nt >= Ue.length) return;
      ae.preventDefault();
      const Ye = Ue.slice();
      Ye.splice(nt, 1);
      const mt = rr(Ye, a);
      f ? oe.current = Ye.length === 0 ? ur(0, a) : ur(nt, a) : oe.current = rr(
        Ye.slice(0, nt),
        a
      ).length, S(mt);
    },
    [S, f, a, e]
  ), ee = (ae) => {
    const ye = ae.target.value;
    if (!a) {
      S(ye);
      return;
    }
    const Ke = ae.target.selectionStart;
    if (f) {
      const { slots: xt, slotsBeforeCaret: nt } = Ca(
        ye,
        Ke,
        a
      ), Ye = rr(xt, a);
      oe.current = xt.length === 0 ? ur(0, a) : ur(nt, a), S(Ye);
      return;
    }
    const $e = Er(ye, a), Ue = rr($e, a);
    S(Ue);
  };
  Na(() => {
    const ae = oe.current;
    if (ae == null) return;
    oe.current = null;
    const ye = X.current;
    if (ye)
      try {
        ye.setSelectionRange(ae, ae);
      } catch {
      }
  });
  const q = e.disabled ? dr["is-disabled"] : void 0, T = typeof e.regex == "string" ? e.regex : (He = e.regex) == null ? void 0 : He.source, L = a ? "text" : e.type ?? "text", ke = pa(
    dr["flare-text-box"],
    e.className,
    e.validationError && dr["validation-error"]
  ), te = pa(
    dr["flare-text-box-field"],
    q
  ), {
    regex: ce,
    mask: we,
    maskShowTemplate: Fe,
    maskPlaceholderChar: De,
    maskSlotChar: Ee,
    maskSlotRegex: Me,
    icon: Be,
    label: qe,
    className: Xe,
    onChange: xe,
    onBlur: ue,
    value: Ve,
    type: Oe,
    ariaDescribedBy: st,
    hideLabel: Pe,
    onKeyDown: dt,
    onFocus: ut,
    validationError: Q,
    customValidation: se,
    allowEmpty: re,
    ...p
  } = e, z = G(), V = a ? Er(z, a) : [];
  let le = z;
  f && a && (le = V.length === 0 ? F ? Sa(V, a, u) : "" : Sa(V, a, u));
  const he = ze(() => !a || !f ? e.placeholder : e.placeholder ?? Eo(a, u), [f, a, u, e.placeholder]), ie = R(
    (ae) => {
      var ye;
      B(!0), (ye = e.onFocus) == null || ye.call(e, ae), !(!a || !f) && V.length === 0 && (oe.current = ur(0, a));
    },
    [V.length, f, a, e]
  ), rt = R(
    (ae) => {
      var ye;
      B(!1), (ye = e.onBlur) == null || ye.call(e, ae);
    },
    [e]
  );
  return /* @__PURE__ */ n.jsx(
    ar,
    {
      label: qe,
      hideLabel: e.hideLabel,
      refHandle: Y,
      validationError: e.validationError,
      required: e.required,
      customValidation: e.customValidation,
      children: /* @__PURE__ */ n.jsx("div", { className: ke, children: /* @__PURE__ */ n.jsxs("div", { className: te, children: [
        e.icon && /* @__PURE__ */ n.jsx("span", { className: dr["flare-text-box-icon"], children: e.icon }),
        /* @__PURE__ */ n.jsx(
          "input",
          {
            ...p,
            ref: X,
            id: P,
            type: L,
            value: le,
            onChange: ee,
            onKeyDown: be,
            onFocus: ie,
            onBlur: rt,
            placeholder: he,
            disabled: e.disabled,
            pattern: T,
            required: e.required,
            step: e.step,
            name: e.name,
            autoComplete: e.autoComplete,
            inputMode: e.inputMode,
            "aria-describedby": e.ariaDescribedBy,
            dir: N,
            className: dr["flare-text-box-input"]
          }
        )
      ] }) })
    }
  );
}
export {
  Ao as FlareAmountRangePicker,
  Oo as FlareAutoComplete,
  Lo as FlareButton,
  Vo as FlareCard,
  Ta as FlareCheckBox,
  Go as FlareCollectionView,
  Ko as FlareDataGrid,
  $o as FlareDatePicker,
  Wo as FlareDateRangePicker,
  Yo as FlareDrawer,
  Jo as FlareDropDownList,
  Uo as FlareFloatingWindow,
  Qa as FlareForm,
  Jr as FlareFormContext,
  ar as FlareInputWrapper,
  Ho as FlareLayout,
  Mn as FlareLayoutBottomSticky,
  Tn as FlareLayoutContent,
  On as FlareLayoutFooter,
  Pn as FlareLayoutHeader,
  In as FlareLayoutSideBar,
  Rn as FlareLayoutSubHeader,
  Fn as FlareLayoutTopSticky,
  Ja as FlareLocaleProvider,
  Xo as FlarePager,
  Rr as FlarePopup,
  La as FlarePopupMenu,
  Yn as FlarePopupMenuCheckboxItem,
  Gn as FlarePopupMenuDivider,
  Ar as FlarePopupMenuItem,
  Xn as FlarePopupMenuTitle,
  qo as FlareScrollPane,
  Bo as FlareSplitView,
  ha as FlareSplitViewPane,
  Zo as FlareTextBox,
  Fo as FlareThemeProvider,
  Ka as flareDarkTheme,
  kt as flareLightTheme,
  Io as flareWin95Theme,
  za as getFlareLocale,
  Mo as useFlareFormContext,
  fr as useFlareLocale,
  To as useFlareTheme,
  Za as useOptionalFlareFormContext
};
